"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __esm = (fn, res) => function __init() {
  return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
};
var __commonJS = (cb, mod2) => function __require() {
  return mod2 || (0, cb[__getOwnPropNames(cb)[0]])((mod2 = { exports: {} }).exports, mod2), mod2.exports;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod2, isNodeMode, target) => (target = mod2 != null ? __create(__getProtoOf(mod2)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod2 || !mod2.__esModule ? __defProp(target, "default", { value: mod2, enumerable: true }) : target,
  mod2
));
var __toCommonJS = (mod2) => __copyProps(__defProp({}, "__esModule", { value: true }), mod2);
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);

// node_modules/tsup/assets/cjs_shims.js
var getImportMetaUrl, importMetaUrl;
var init_cjs_shims = __esm({
  "node_modules/tsup/assets/cjs_shims.js"() {
    "use strict";
    getImportMetaUrl = () => typeof document === "undefined" ? new URL(`file:${__filename}`).href : document.currentScript && document.currentScript.src || new URL("main.js", document.baseURI).href;
    importMetaUrl = /* @__PURE__ */ getImportMetaUrl();
  }
});

// node_modules/thenby/thenBy.module.js
var require_thenBy_module = __commonJS({
  "node_modules/thenby/thenBy.module.js"(exports2, module2) {
    "use strict";
    init_cjs_shims();
    module2.exports = function() {
      function identity3(v2) {
        return v2;
      }
      function ignoreCase(v2) {
        return typeof v2 === "string" ? v2.toLowerCase() : v2;
      }
      function makeCompareFunction(f, opt) {
        opt = typeof opt === "object" ? opt : { direction: opt };
        if (typeof f != "function") {
          var prop = f;
          f = function(v1) {
            return !!v1[prop] ? v1[prop] : "";
          };
        }
        if (f.length === 1) {
          var uf = f;
          var preprocess = opt.ignoreCase ? ignoreCase : identity3;
          var cmp = opt.cmp || function(v1, v2) {
            return v1 < v2 ? -1 : v1 > v2 ? 1 : 0;
          };
          f = function(v1, v2) {
            return cmp(preprocess(uf(v1)), preprocess(uf(v2)));
          };
        }
        const descTokens = { "-1": "", desc: "" };
        if (opt.direction in descTokens) return function(v1, v2) {
          return -f(v1, v2);
        };
        return f;
      }
      function tb(func, opt) {
        var x = typeof this == "function" && !this.firstBy ? this : false;
        var y = makeCompareFunction(func, opt);
        var f = x ? function(a, b) {
          return x(a, b) || y(a, b);
        } : y;
        f.thenBy = tb;
        return f;
      }
      tb.firstBy = tb;
      return tb;
    }();
  }
});

// src/index.ts
var src_exports = {};
__export(src_exports, {
  AggregationTypes: () => AggregationTypes,
  ApiVersion: () => ApiVersion,
  BASEMAP: () => basemap_styles_default,
  CARTO_SOURCES: () => CARTO_SOURCES,
  CartoAPIError: () => CartoAPIError,
  CellSet: () => CellSet,
  DEFAULT_API_BASE_URL: () => DEFAULT_API_BASE_URL,
  FEATURE_GEOM_PROPERTY: () => FEATURE_GEOM_PROPERTY,
  FilterType: () => FilterType,
  OPACITY_MAP: () => OPACITY_MAP,
  OTHERS_CATEGORY_NAME: () => OTHERS_CATEGORY_NAME,
  Provider: () => Provider,
  RasterBandColorinterp: () => RasterBandColorinterp,
  SOURCE_DEFAULTS: () => SOURCE_DEFAULTS,
  SchemaFieldType: () => SchemaFieldType,
  SpatialIndex: () => SpatialIndex,
  SpatialIndexColumn: () => SpatialIndexColumn,
  TEXT_LABEL_INDEX: () => TEXT_LABEL_INDEX,
  TEXT_NUMBER_FORMATTER: () => TEXT_NUMBER_FORMATTER,
  TEXT_OUTLINE_OPACITY: () => TEXT_OUTLINE_OPACITY,
  TileFormat: () => TileFormat,
  WidgetQuerySource: () => WidgetQuerySource,
  WidgetRasterSource: () => WidgetRasterSource,
  WidgetRemoteSource: () => WidgetRemoteSource,
  WidgetSource: () => WidgetSource,
  WidgetTableSource: () => WidgetTableSource,
  WidgetTilesetSource: () => WidgetTilesetSource,
  _ErrorCode: () => ErrorCode,
  _applyLayerGroupFilters: () => applyLayerGroupFilters,
  _buildFeatureFilter: () => _buildFeatureFilter,
  _createVecExprEvaluator: () => createVecExprEvaluator,
  _domainFromValues: () => domainFromValues,
  _evaluateVecExpr: () => evaluateVecExpr,
  _getHexagonResolution: () => _getHexagonResolution,
  _getLog10ScaleSteps: () => getLog10ScaleSteps,
  _getRasterTileLayerStyleProps: () => getRasterTileLayerStyleProps,
  _validateVecExprSyntax: () => validateVecExprSyntax,
  addFilter: () => addFilter,
  aggregate: () => aggregate,
  aggregationFunctions: () => aggregationFunctions,
  applyFilters: () => applyFilters,
  applySorting: () => applySorting,
  boundaryQuerySource: () => boundaryQuerySource,
  boundaryTableSource: () => boundaryTableSource,
  buildBinaryFeatureFilter: () => buildBinaryFeatureFilter,
  buildPublicMapUrl: () => buildPublicMapUrl,
  buildStatsUrl: () => buildStatsUrl,
  calculateClusterRadius: () => calculateClusterRadius,
  calculateClusterTextFontSize: () => calculateClusterTextFontSize,
  calculateLayerScale: () => calculateLayerScale,
  clearDefaultRequestCache: () => clearDefaultRequestCache,
  clearFilters: () => clearFilters,
  configureSource: () => configureSource,
  createColorScale: () => createColorScale,
  createPolygonSpatialFilter: () => createPolygonSpatialFilter,
  createViewportSpatialFilter: () => createViewportSpatialFilter,
  fetchBasemapProps: () => fetchBasemapProps,
  fetchMap: () => fetchMap,
  filterFunctions: () => filterFunctions,
  geojsonFeatures: () => geojsonFeatures,
  getApplicableFilters: () => getApplicableFilters,
  getClient: () => getClient,
  getColorAccessor: () => getColorAccessor,
  getColumnNameFromGeoColumn: () => getColumnNameFromGeoColumn,
  getDataFilterExtensionProps: () => getDataFilterExtensionProps,
  getDefaultAggregationExpColumnAliasForLayerType: () => getDefaultAggregationExpColumnAliasForLayerType,
  getFilter: () => getFilter,
  getIconUrlAccessor: () => getIconUrlAccessor,
  getLayerDescriptor: () => getLayerDescriptor,
  getLayerProps: () => getLayerProps,
  getMaxMarkerSize: () => getMaxMarkerSize,
  getSizeAccessor: () => getSizeAccessor,
  getSorter: () => getSorter,
  getSpatialIndexFromGeoColumn: () => getSpatialIndexFromGeoColumn,
  getTextAccessor: () => getTextAccessor,
  groupValuesByColumn: () => groupValuesByColumn,
  groupValuesByDateColumn: () => groupValuesByDateColumn,
  h3QuerySource: () => h3QuerySource,
  h3TableSource: () => h3TableSource,
  h3TilesetSource: () => h3TilesetSource,
  hasFilter: () => hasFilter,
  histogram: () => histogram,
  makeIntervalComplete: () => makeIntervalComplete,
  negateAccessor: () => negateAccessor,
  opacityToAlpha: () => opacityToAlpha,
  parseMap: () => parseMap,
  quadbinQuerySource: () => quadbinQuerySource,
  quadbinTableSource: () => quadbinTableSource,
  quadbinTilesetSource: () => quadbinTilesetSource,
  query: () => query,
  rasterSource: () => rasterSource,
  removeFilter: () => removeFilter,
  requestWithParameters: () => requestWithParameters,
  scaleAggregationResLevel: () => scaleAggregationResLevel,
  scatterPlot: () => scatterPlot,
  setClient: () => setClient,
  tileFeatures: () => tileFeatures,
  tileFeaturesGeometries: () => tileFeaturesGeometries,
  tileFeaturesSpatialIndex: () => tileFeaturesSpatialIndex,
  trajectoryQuerySource: () => trajectoryQuerySource,
  trajectoryTableSource: () => trajectoryTableSource,
  transformToTileCoords: () => transformToTileCoords,
  vectorQuerySource: () => vectorQuerySource,
  vectorTableSource: () => vectorTableSource,
  vectorTilesetSource: () => vectorTilesetSource
});
module.exports = __toCommonJS(src_exports);
init_cjs_shims();

// src/client.ts
init_cjs_shims();
var client = "deck-gl-carto";
function getClient() {
  return client;
}
function setClient(c) {
  client = c;
}

// src/constants.ts
init_cjs_shims();
var FilterType = /* @__PURE__ */ ((FilterType2) => {
  FilterType2["IN"] = "in";
  FilterType2["BETWEEN"] = "between";
  FilterType2["CLOSED_OPEN"] = "closed_open";
  FilterType2["TIME"] = "time";
  FilterType2["STRING_SEARCH"] = "stringSearch";
  return FilterType2;
})(FilterType || {});
var ApiVersion = /* @__PURE__ */ ((ApiVersion2) => {
  ApiVersion2["V1"] = "v1";
  ApiVersion2["V2"] = "v2";
  ApiVersion2["V3"] = "v3";
  return ApiVersion2;
})(ApiVersion || {});
var DEFAULT_API_BASE_URL = "https://gcp-us-east1.api.carto.com";
var TileFormat = /* @__PURE__ */ ((TileFormat2) => {
  TileFormat2["MVT"] = "mvt";
  TileFormat2["JSON"] = "json";
  TileFormat2["GEOJSON"] = "geojson";
  TileFormat2["BINARY"] = "binary";
  return TileFormat2;
})(TileFormat || {});
var SpatialIndex = /* @__PURE__ */ ((SpatialIndex2) => {
  SpatialIndex2["H3"] = "h3";
  SpatialIndex2["QUADBIN"] = "quadbin";
  return SpatialIndex2;
})(SpatialIndex || {});
var Provider = /* @__PURE__ */ ((Provider2) => {
  Provider2["BIGQUERY"] = "bigquery";
  Provider2["REDSHIFT"] = "redshift";
  Provider2["POSTGRES"] = "postgres";
  Provider2["SNOWFLAKE"] = "snowflake";
  Provider2["DATABRICKS"] = "databricks";
  Provider2["DATABRICKS_REST"] = "databricksRest";
  return Provider2;
})(Provider || {});
var SpatialIndexColumn = Object.freeze({
  ["h3" /* H3 */]: ["h3", "hex", "h3id", "hex_id", "h3hex"],
  ["quadbin" /* QUADBIN */]: ["quadbin"]
});
var AggregationTypes = {
  Count: "count",
  Avg: "avg",
  Min: "min",
  Max: "max",
  Sum: "sum",
  Custom: "custom"
};

// src/deck/get-data-filter-extension-props.ts
init_cjs_shims();

// src/filters/Filter.ts
init_cjs_shims();

// src/filters/FilterTypes.ts
init_cjs_shims();

// src/utils/makeIntervalComplete.ts
init_cjs_shims();
function makeIntervalComplete(intervals) {
  return intervals.map((val) => {
    if (val[0] === void 0 || val[0] === null) {
      return [Number.MIN_SAFE_INTEGER, val[1]];
    }
    if (val[1] === void 0 || val[1] === null) {
      return [val[0], Number.MAX_SAFE_INTEGER];
    }
    return val;
  });
}

// src/filters/FilterTypes.ts
var filterFunctions = {
  ["in" /* IN */]: filterIn,
  ["between" /* BETWEEN */]: filterBetween,
  ["time" /* TIME */]: filterTime,
  ["closed_open" /* CLOSED_OPEN */]: filterClosedOpen,
  ["stringSearch" /* STRING_SEARCH */]: filterStringSearch
};
function filterIn(filterValues, featureValue) {
  return filterValues.includes(featureValue);
}
function filterBetween(filterValues, featureValue) {
  const checkRange = (range) => {
    const [lowerBound, upperBound] = range;
    return featureValue >= lowerBound && featureValue <= upperBound;
  };
  return makeIntervalComplete(filterValues).some(
    checkRange
  );
}
function filterTime(filterValues, featureValue) {
  const featureValueAsTimestamp = new Date(featureValue).getTime();
  if (isFinite(featureValueAsTimestamp)) {
    return filterBetween(filterValues, featureValueAsTimestamp);
  } else {
    throw new Error(`Column used to filter by time isn't well formatted.`);
  }
}
function filterClosedOpen(filterValues, featureValue) {
  const checkRange = (range) => {
    const [lowerBound, upperBound] = range;
    return featureValue >= lowerBound && featureValue < upperBound;
  };
  return makeIntervalComplete(filterValues).some(
    checkRange
  );
}
function filterStringSearch(filterValues, featureValue, params = {}) {
  const normalizedFeatureValue = normalize(featureValue, params);
  const stringRegExp = params.useRegExp ? filterValues : filterValues.map((filterValue) => {
    let stringRegExp2 = escapeRegExp(normalize(filterValue, params));
    if (params.mustStart) stringRegExp2 = `^${stringRegExp2}`;
    if (params.mustEnd) stringRegExp2 = `${stringRegExp2}$`;
    return stringRegExp2;
  });
  const regex = new RegExp(
    stringRegExp.join("|"),
    params.caseSensitive ? "g" : "gi"
  );
  return !!normalizedFeatureValue.match(regex);
}
var specialCharRegExp = /[.*+?^${}()|[\]\\]/g;
var normalizeRegExp = /\p{Diacritic}/gu;
function escapeRegExp(value) {
  return value.replace(specialCharRegExp, "\\$&");
}
function normalize(data, params) {
  let normalizedData = String(data);
  if (!params.keepSpecialCharacters)
    normalizedData = normalizedData.normalize("NFD").replace(normalizeRegExp, "");
  return normalizedData;
}

// src/filters/Filter.ts
var LOGICAL_OPERATOR_METHODS = {
  and: "every",
  or: "some"
};
function passesFilter(columns, filters, feature2, filtersLogicalOperator) {
  const method = LOGICAL_OPERATOR_METHODS[filtersLogicalOperator];
  return columns[method]((column) => {
    const columnFilters = filters[column];
    const columnFilterTypes = Object.keys(columnFilters);
    if (!feature2 || feature2[column] === null || feature2[column] === void 0) {
      return false;
    }
    return columnFilterTypes.every((filter) => {
      const filterFunction = filterFunctions[filter];
      if (!filterFunction) {
        throw new Error(`"${filter}" filter is not implemented.`);
      }
      return filterFunction(
        columnFilters[filter].values,
        feature2[column],
        columnFilters[filter].params
      );
    });
  });
}
function _buildFeatureFilter({
  filters = {},
  type = "boolean",
  filtersLogicalOperator = "and"
}) {
  const columns = Object.keys(filters);
  if (!columns.length) {
    return () => type === "number" ? 1 : true;
  }
  return (feature2) => {
    const f = feature2.properties || feature2;
    const featurePassesFilter = passesFilter(
      columns,
      filters,
      f,
      filtersLogicalOperator
    );
    return type === "number" ? Number(featurePassesFilter) : featurePassesFilter;
  };
}
function applyFilters(features, filters, filtersLogicalOperator) {
  return Object.keys(filters).length ? features.filter(_buildFeatureFilter({ filters, filtersLogicalOperator })) : features;
}
function buildBinaryFeatureFilter({ filters = {} }) {
  const columns = Object.keys(filters);
  if (!columns.length) {
    return () => 1;
  }
  return (featureIdIdx, binaryData) => passesFilterUsingBinary(columns, filters, featureIdIdx, binaryData);
}
function getValueFromNumericProps(featureIdIdx, binaryData, { column }) {
  return binaryData.numericProps?.[column]?.value[featureIdIdx];
}
function getValueFromProperties(featureIdIdx, binaryData, { column }) {
  const propertyIdx = binaryData.featureIds.value[featureIdIdx];
  return binaryData.properties[propertyIdx]?.[column];
}
var GET_VALUE_BY_BINARY_PROP = {
  properties: getValueFromProperties,
  numericProps: getValueFromNumericProps
};
function getBinaryPropertyByFilterValues(filterValues) {
  return typeof filterValues.flat()[0] === "string" ? "properties" : "numericProps";
}
function getFeatureValue(featureIdIdx, binaryData, filter) {
  const { column, values } = filter;
  const binaryProp = getBinaryPropertyByFilterValues(values);
  const getFeatureValueFn = GET_VALUE_BY_BINARY_PROP[binaryProp];
  return getFeatureValueFn(featureIdIdx, binaryData, { column });
}
function passesFilterUsingBinary(columns, filters, featureIdIdx, binaryData) {
  return columns.every((column) => {
    const columnFilters = filters[column];
    return Object.entries(columnFilters).every(([type, { values }]) => {
      const filterFn = filterFunctions[type];
      if (!filterFn) {
        throw new Error(`"${type}" filter is not implemented.`);
      }
      if (!values) return 0;
      const featureValue = getFeatureValue(featureIdIdx, binaryData, {
        type,
        column,
        values
      });
      if (featureValue === void 0 || featureValue === null) return 0;
      return filterFn(values, featureValue);
    });
  });
}

// src/filters/geosjonFeatures.ts
init_cjs_shims();

// node_modules/@turf/boolean-intersects/dist/esm/index.js
init_cjs_shims();

// node_modules/@turf/boolean-disjoint/dist/esm/index.js
init_cjs_shims();

// node_modules/@turf/boolean-point-in-polygon/dist/esm/index.js
init_cjs_shims();

// node_modules/point-in-polygon-hao/dist/esm/index.js
init_cjs_shims();

// node_modules/robust-predicates/index.js
init_cjs_shims();

// node_modules/robust-predicates/esm/orient2d.js
init_cjs_shims();

// node_modules/robust-predicates/esm/util.js
init_cjs_shims();
var epsilon = 11102230246251565e-32;
var splitter = 134217729;
var resulterrbound = (3 + 8 * epsilon) * epsilon;
function sum(elen, e, flen, f, h) {
  let Q, Qnew, hh, bvirt;
  let enow = e[0];
  let fnow = f[0];
  let eindex = 0;
  let findex = 0;
  if (fnow > enow === fnow > -enow) {
    Q = enow;
    enow = e[++eindex];
  } else {
    Q = fnow;
    fnow = f[++findex];
  }
  let hindex = 0;
  if (eindex < elen && findex < flen) {
    if (fnow > enow === fnow > -enow) {
      Qnew = enow + Q;
      hh = Q - (Qnew - enow);
      enow = e[++eindex];
    } else {
      Qnew = fnow + Q;
      hh = Q - (Qnew - fnow);
      fnow = f[++findex];
    }
    Q = Qnew;
    if (hh !== 0) {
      h[hindex++] = hh;
    }
    while (eindex < elen && findex < flen) {
      if (fnow > enow === fnow > -enow) {
        Qnew = Q + enow;
        bvirt = Qnew - Q;
        hh = Q - (Qnew - bvirt) + (enow - bvirt);
        enow = e[++eindex];
      } else {
        Qnew = Q + fnow;
        bvirt = Qnew - Q;
        hh = Q - (Qnew - bvirt) + (fnow - bvirt);
        fnow = f[++findex];
      }
      Q = Qnew;
      if (hh !== 0) {
        h[hindex++] = hh;
      }
    }
  }
  while (eindex < elen) {
    Qnew = Q + enow;
    bvirt = Qnew - Q;
    hh = Q - (Qnew - bvirt) + (enow - bvirt);
    enow = e[++eindex];
    Q = Qnew;
    if (hh !== 0) {
      h[hindex++] = hh;
    }
  }
  while (findex < flen) {
    Qnew = Q + fnow;
    bvirt = Qnew - Q;
    hh = Q - (Qnew - bvirt) + (fnow - bvirt);
    fnow = f[++findex];
    Q = Qnew;
    if (hh !== 0) {
      h[hindex++] = hh;
    }
  }
  if (Q !== 0 || hindex === 0) {
    h[hindex++] = Q;
  }
  return hindex;
}
function estimate(elen, e) {
  let Q = e[0];
  for (let i = 1; i < elen; i++) Q += e[i];
  return Q;
}
function vec(n) {
  return new Float64Array(n);
}

// node_modules/robust-predicates/esm/orient2d.js
var ccwerrboundA = (3 + 16 * epsilon) * epsilon;
var ccwerrboundB = (2 + 12 * epsilon) * epsilon;
var ccwerrboundC = (9 + 64 * epsilon) * epsilon * epsilon;
var B = vec(4);
var C1 = vec(8);
var C2 = vec(12);
var D = vec(16);
var u = vec(4);
function orient2dadapt(ax, ay, bx, by, cx, cy, detsum) {
  let acxtail, acytail, bcxtail, bcytail;
  let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0, u32;
  const acx = ax - cx;
  const bcx = bx - cx;
  const acy = ay - cy;
  const bcy = by - cy;
  s1 = acx * bcy;
  c = splitter * acx;
  ahi = c - (c - acx);
  alo = acx - ahi;
  c = splitter * bcy;
  bhi = c - (c - bcy);
  blo = bcy - bhi;
  s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
  t1 = acy * bcx;
  c = splitter * acy;
  ahi = c - (c - acy);
  alo = acy - ahi;
  c = splitter * bcx;
  bhi = c - (c - bcx);
  blo = bcx - bhi;
  t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
  _i = s0 - t0;
  bvirt = s0 - _i;
  B[0] = s0 - (_i + bvirt) + (bvirt - t0);
  _j = s1 + _i;
  bvirt = _j - s1;
  _0 = s1 - (_j - bvirt) + (_i - bvirt);
  _i = _0 - t1;
  bvirt = _0 - _i;
  B[1] = _0 - (_i + bvirt) + (bvirt - t1);
  u32 = _j + _i;
  bvirt = u32 - _j;
  B[2] = _j - (u32 - bvirt) + (_i - bvirt);
  B[3] = u32;
  let det = estimate(4, B);
  let errbound = ccwerrboundB * detsum;
  if (det >= errbound || -det >= errbound) {
    return det;
  }
  bvirt = ax - acx;
  acxtail = ax - (acx + bvirt) + (bvirt - cx);
  bvirt = bx - bcx;
  bcxtail = bx - (bcx + bvirt) + (bvirt - cx);
  bvirt = ay - acy;
  acytail = ay - (acy + bvirt) + (bvirt - cy);
  bvirt = by - bcy;
  bcytail = by - (bcy + bvirt) + (bvirt - cy);
  if (acxtail === 0 && acytail === 0 && bcxtail === 0 && bcytail === 0) {
    return det;
  }
  errbound = ccwerrboundC * detsum + resulterrbound * Math.abs(det);
  det += acx * bcytail + bcy * acxtail - (acy * bcxtail + bcx * acytail);
  if (det >= errbound || -det >= errbound) return det;
  s1 = acxtail * bcy;
  c = splitter * acxtail;
  ahi = c - (c - acxtail);
  alo = acxtail - ahi;
  c = splitter * bcy;
  bhi = c - (c - bcy);
  blo = bcy - bhi;
  s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
  t1 = acytail * bcx;
  c = splitter * acytail;
  ahi = c - (c - acytail);
  alo = acytail - ahi;
  c = splitter * bcx;
  bhi = c - (c - bcx);
  blo = bcx - bhi;
  t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
  _i = s0 - t0;
  bvirt = s0 - _i;
  u[0] = s0 - (_i + bvirt) + (bvirt - t0);
  _j = s1 + _i;
  bvirt = _j - s1;
  _0 = s1 - (_j - bvirt) + (_i - bvirt);
  _i = _0 - t1;
  bvirt = _0 - _i;
  u[1] = _0 - (_i + bvirt) + (bvirt - t1);
  u32 = _j + _i;
  bvirt = u32 - _j;
  u[2] = _j - (u32 - bvirt) + (_i - bvirt);
  u[3] = u32;
  const C1len = sum(4, B, 4, u, C1);
  s1 = acx * bcytail;
  c = splitter * acx;
  ahi = c - (c - acx);
  alo = acx - ahi;
  c = splitter * bcytail;
  bhi = c - (c - bcytail);
  blo = bcytail - bhi;
  s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
  t1 = acy * bcxtail;
  c = splitter * acy;
  ahi = c - (c - acy);
  alo = acy - ahi;
  c = splitter * bcxtail;
  bhi = c - (c - bcxtail);
  blo = bcxtail - bhi;
  t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
  _i = s0 - t0;
  bvirt = s0 - _i;
  u[0] = s0 - (_i + bvirt) + (bvirt - t0);
  _j = s1 + _i;
  bvirt = _j - s1;
  _0 = s1 - (_j - bvirt) + (_i - bvirt);
  _i = _0 - t1;
  bvirt = _0 - _i;
  u[1] = _0 - (_i + bvirt) + (bvirt - t1);
  u32 = _j + _i;
  bvirt = u32 - _j;
  u[2] = _j - (u32 - bvirt) + (_i - bvirt);
  u[3] = u32;
  const C2len = sum(C1len, C1, 4, u, C2);
  s1 = acxtail * bcytail;
  c = splitter * acxtail;
  ahi = c - (c - acxtail);
  alo = acxtail - ahi;
  c = splitter * bcytail;
  bhi = c - (c - bcytail);
  blo = bcytail - bhi;
  s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
  t1 = acytail * bcxtail;
  c = splitter * acytail;
  ahi = c - (c - acytail);
  alo = acytail - ahi;
  c = splitter * bcxtail;
  bhi = c - (c - bcxtail);
  blo = bcxtail - bhi;
  t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
  _i = s0 - t0;
  bvirt = s0 - _i;
  u[0] = s0 - (_i + bvirt) + (bvirt - t0);
  _j = s1 + _i;
  bvirt = _j - s1;
  _0 = s1 - (_j - bvirt) + (_i - bvirt);
  _i = _0 - t1;
  bvirt = _0 - _i;
  u[1] = _0 - (_i + bvirt) + (bvirt - t1);
  u32 = _j + _i;
  bvirt = u32 - _j;
  u[2] = _j - (u32 - bvirt) + (_i - bvirt);
  u[3] = u32;
  const Dlen = sum(C2len, C2, 4, u, D);
  return D[Dlen - 1];
}
function orient2d(ax, ay, bx, by, cx, cy) {
  const detleft = (ay - cy) * (bx - cx);
  const detright = (ax - cx) * (by - cy);
  const det = detleft - detright;
  const detsum = Math.abs(detleft + detright);
  if (Math.abs(det) >= ccwerrboundA * detsum) return det;
  return -orient2dadapt(ax, ay, bx, by, cx, cy, detsum);
}

// node_modules/robust-predicates/esm/orient3d.js
init_cjs_shims();
var o3derrboundA = (7 + 56 * epsilon) * epsilon;
var o3derrboundB = (3 + 28 * epsilon) * epsilon;
var o3derrboundC = (26 + 288 * epsilon) * epsilon * epsilon;
var bc = vec(4);
var ca = vec(4);
var ab = vec(4);
var at_b = vec(4);
var at_c = vec(4);
var bt_c = vec(4);
var bt_a = vec(4);
var ct_a = vec(4);
var ct_b = vec(4);
var bct = vec(8);
var cat = vec(8);
var abt = vec(8);
var u2 = vec(4);
var _8 = vec(8);
var _8b = vec(8);
var _16 = vec(8);
var _12 = vec(12);
var fin = vec(192);
var fin2 = vec(192);

// node_modules/robust-predicates/esm/incircle.js
init_cjs_shims();
var iccerrboundA = (10 + 96 * epsilon) * epsilon;
var iccerrboundB = (4 + 48 * epsilon) * epsilon;
var iccerrboundC = (44 + 576 * epsilon) * epsilon * epsilon;
var bc2 = vec(4);
var ca2 = vec(4);
var ab2 = vec(4);
var aa = vec(4);
var bb = vec(4);
var cc = vec(4);
var u3 = vec(4);
var v = vec(4);
var axtbc = vec(8);
var aytbc = vec(8);
var bxtca = vec(8);
var bytca = vec(8);
var cxtab = vec(8);
var cytab = vec(8);
var abt2 = vec(8);
var bct2 = vec(8);
var cat2 = vec(8);
var abtt = vec(4);
var bctt = vec(4);
var catt = vec(4);
var _82 = vec(8);
var _162 = vec(16);
var _16b = vec(16);
var _16c = vec(16);
var _32 = vec(32);
var _32b = vec(32);
var _48 = vec(48);
var _64 = vec(64);
var fin3 = vec(1152);
var fin22 = vec(1152);

// node_modules/robust-predicates/esm/insphere.js
init_cjs_shims();
var isperrboundA = (16 + 224 * epsilon) * epsilon;
var isperrboundB = (5 + 72 * epsilon) * epsilon;
var isperrboundC = (71 + 1408 * epsilon) * epsilon * epsilon;
var ab3 = vec(4);
var bc3 = vec(4);
var cd = vec(4);
var de = vec(4);
var ea = vec(4);
var ac = vec(4);
var bd = vec(4);
var ce = vec(4);
var da = vec(4);
var eb = vec(4);
var abc = vec(24);
var bcd = vec(24);
var cde = vec(24);
var dea = vec(24);
var eab = vec(24);
var abd = vec(24);
var bce = vec(24);
var cda = vec(24);
var deb = vec(24);
var eac = vec(24);
var adet = vec(1152);
var bdet = vec(1152);
var cdet = vec(1152);
var ddet = vec(1152);
var edet = vec(1152);
var abdet = vec(2304);
var cddet = vec(2304);
var cdedet = vec(3456);
var deter = vec(5760);
var _83 = vec(8);
var _8b2 = vec(8);
var _8c = vec(8);
var _163 = vec(16);
var _24 = vec(24);
var _482 = vec(48);
var _48b = vec(48);
var _96 = vec(96);
var _192 = vec(192);
var _384x = vec(384);
var _384y = vec(384);
var _384z = vec(384);
var _768 = vec(768);
var xdet = vec(96);
var ydet = vec(96);
var zdet = vec(96);
var fin4 = vec(1152);

// node_modules/point-in-polygon-hao/dist/esm/index.js
function pointInPolygon(p, polygon2) {
  var i;
  var ii;
  var k = 0;
  var f;
  var u1;
  var v1;
  var u22;
  var v2;
  var currentP;
  var nextP;
  var x = p[0];
  var y = p[1];
  var numContours = polygon2.length;
  for (i = 0; i < numContours; i++) {
    ii = 0;
    var contour = polygon2[i];
    var contourLen = contour.length - 1;
    currentP = contour[0];
    if (currentP[0] !== contour[contourLen][0] && currentP[1] !== contour[contourLen][1]) {
      throw new Error("First and last coordinates in a ring must be the same");
    }
    u1 = currentP[0] - x;
    v1 = currentP[1] - y;
    for (ii; ii < contourLen; ii++) {
      nextP = contour[ii + 1];
      u22 = nextP[0] - x;
      v2 = nextP[1] - y;
      if (v1 === 0 && v2 === 0) {
        if (u22 <= 0 && u1 >= 0 || u1 <= 0 && u22 >= 0) {
          return 0;
        }
      } else if (v2 >= 0 && v1 <= 0 || v2 <= 0 && v1 >= 0) {
        f = orient2d(u1, u22, v1, v2, 0, 0);
        if (f === 0) {
          return 0;
        }
        if (f > 0 && v2 > 0 && v1 <= 0 || f < 0 && v2 <= 0 && v1 > 0) {
          k++;
        }
      }
      currentP = nextP;
      v1 = v2;
      u1 = u22;
    }
  }
  if (k % 2 === 0) {
    return false;
  }
  return true;
}

// node_modules/@turf/invariant/dist/esm/index.js
init_cjs_shims();

// node_modules/@turf/helpers/dist/esm/index.js
init_cjs_shims();
var earthRadius = 63710088e-1;
var factors = {
  centimeters: earthRadius * 100,
  centimetres: earthRadius * 100,
  degrees: 360 / (2 * Math.PI),
  feet: earthRadius * 3.28084,
  inches: earthRadius * 39.37,
  kilometers: earthRadius / 1e3,
  kilometres: earthRadius / 1e3,
  meters: earthRadius,
  metres: earthRadius,
  miles: earthRadius / 1609.344,
  millimeters: earthRadius * 1e3,
  millimetres: earthRadius * 1e3,
  nauticalmiles: earthRadius / 1852,
  radians: 1,
  yards: earthRadius * 1.0936
};
function feature(geom, properties, options = {}) {
  const feat = { type: "Feature" };
  if (options.id === 0 || options.id) {
    feat.id = options.id;
  }
  if (options.bbox) {
    feat.bbox = options.bbox;
  }
  feat.properties = properties || {};
  feat.geometry = geom;
  return feat;
}
function point(coordinates, properties, options = {}) {
  if (!coordinates) {
    throw new Error("coordinates is required");
  }
  if (!Array.isArray(coordinates)) {
    throw new Error("coordinates must be an Array");
  }
  if (coordinates.length < 2) {
    throw new Error("coordinates must be at least 2 numbers long");
  }
  if (!isNumber(coordinates[0]) || !isNumber(coordinates[1])) {
    throw new Error("coordinates must contain numbers");
  }
  const geom = {
    type: "Point",
    coordinates
  };
  return feature(geom, properties, options);
}
function polygon(coordinates, properties, options = {}) {
  for (const ring of coordinates) {
    if (ring.length < 4) {
      throw new Error(
        "Each LinearRing of a Polygon must have 4 or more Positions."
      );
    }
    if (ring[ring.length - 1].length !== ring[0].length) {
      throw new Error("First and last Position are not equivalent.");
    }
    for (let j = 0; j < ring[ring.length - 1].length; j++) {
      if (ring[ring.length - 1][j] !== ring[0][j]) {
        throw new Error("First and last Position are not equivalent.");
      }
    }
  }
  const geom = {
    type: "Polygon",
    coordinates
  };
  return feature(geom, properties, options);
}
function lineString(coordinates, properties, options = {}) {
  if (coordinates.length < 2) {
    throw new Error("coordinates must be an array of two or more positions");
  }
  const geom = {
    type: "LineString",
    coordinates
  };
  return feature(geom, properties, options);
}
function featureCollection(features, options = {}) {
  const fc = { type: "FeatureCollection" };
  if (options.id) {
    fc.id = options.id;
  }
  if (options.bbox) {
    fc.bbox = options.bbox;
  }
  fc.features = features;
  return fc;
}
function multiLineString(coordinates, properties, options = {}) {
  const geom = {
    type: "MultiLineString",
    coordinates
  };
  return feature(geom, properties, options);
}
function multiPolygon(coordinates, properties, options = {}) {
  const geom = {
    type: "MultiPolygon",
    coordinates
  };
  return feature(geom, properties, options);
}
function isNumber(num) {
  return !isNaN(num) && num !== null && !Array.isArray(num);
}

// node_modules/@turf/invariant/dist/esm/index.js
function getCoord(coord) {
  if (!coord) {
    throw new Error("coord is required");
  }
  if (!Array.isArray(coord)) {
    if (coord.type === "Feature" && coord.geometry !== null && coord.geometry.type === "Point") {
      return [...coord.geometry.coordinates];
    }
    if (coord.type === "Point") {
      return [...coord.coordinates];
    }
  }
  if (Array.isArray(coord) && coord.length >= 2 && !Array.isArray(coord[0]) && !Array.isArray(coord[1])) {
    return [...coord];
  }
  throw new Error("coord must be GeoJSON Point or an Array of numbers");
}
function getCoords(coords) {
  if (Array.isArray(coords)) {
    return coords;
  }
  if (coords.type === "Feature") {
    if (coords.geometry !== null) {
      return coords.geometry.coordinates;
    }
  } else {
    if (coords.coordinates) {
      return coords.coordinates;
    }
  }
  throw new Error(
    "coords must be GeoJSON Feature, Geometry Object or an Array"
  );
}
function getGeom(geojson) {
  if (geojson.type === "Feature") {
    return geojson.geometry;
  }
  return geojson;
}
function getType(geojson, _name) {
  if (geojson.type === "FeatureCollection") {
    return "FeatureCollection";
  }
  if (geojson.type === "GeometryCollection") {
    return "GeometryCollection";
  }
  if (geojson.type === "Feature" && geojson.geometry !== null) {
    return geojson.geometry.type;
  }
  return geojson.type;
}

// node_modules/@turf/boolean-point-in-polygon/dist/esm/index.js
function booleanPointInPolygon(point2, polygon2, options = {}) {
  if (!point2) {
    throw new Error("point is required");
  }
  if (!polygon2) {
    throw new Error("polygon is required");
  }
  const pt = getCoord(point2);
  const geom = getGeom(polygon2);
  const type = geom.type;
  const bbox2 = polygon2.bbox;
  let polys = geom.coordinates;
  if (bbox2 && inBBox(pt, bbox2) === false) {
    return false;
  }
  if (type === "Polygon") {
    polys = [polys];
  }
  let result = false;
  for (var i = 0; i < polys.length; ++i) {
    const polyResult = pointInPolygon(pt, polys[i]);
    if (polyResult === 0) return options.ignoreBoundary ? false : true;
    else if (polyResult) result = true;
  }
  return result;
}
function inBBox(pt, bbox2) {
  return bbox2[0] <= pt[0] && bbox2[1] <= pt[1] && bbox2[2] >= pt[0] && bbox2[3] >= pt[1];
}

// node_modules/@turf/line-intersect/dist/esm/index.js
init_cjs_shims();

// node_modules/sweepline-intersections/dist/sweeplineIntersections.esm.js
init_cjs_shims();
var TinyQueue = class {
  constructor(data = [], compare2 = defaultCompare) {
    this.data = data;
    this.length = this.data.length;
    this.compare = compare2;
    if (this.length > 0) {
      for (let i = (this.length >> 1) - 1; i >= 0; i--) this._down(i);
    }
  }
  push(item) {
    this.data.push(item);
    this.length++;
    this._up(this.length - 1);
  }
  pop() {
    if (this.length === 0) return void 0;
    const top = this.data[0];
    const bottom = this.data.pop();
    this.length--;
    if (this.length > 0) {
      this.data[0] = bottom;
      this._down(0);
    }
    return top;
  }
  peek() {
    return this.data[0];
  }
  _up(pos) {
    const { data, compare: compare2 } = this;
    const item = data[pos];
    while (pos > 0) {
      const parent = pos - 1 >> 1;
      const current = data[parent];
      if (compare2(item, current) >= 0) break;
      data[pos] = current;
      pos = parent;
    }
    data[pos] = item;
  }
  _down(pos) {
    const { data, compare: compare2 } = this;
    const halfLength = this.length >> 1;
    const item = data[pos];
    while (pos < halfLength) {
      let left = (pos << 1) + 1;
      let best = data[left];
      const right = left + 1;
      if (right < this.length && compare2(data[right], best) < 0) {
        left = right;
        best = data[right];
      }
      if (compare2(best, item) >= 0) break;
      data[pos] = best;
      pos = left;
    }
    data[pos] = item;
  }
};
function defaultCompare(a, b) {
  return a < b ? -1 : a > b ? 1 : 0;
}
function checkWhichEventIsLeft(e1, e2) {
  if (e1.p.x > e2.p.x) return 1;
  if (e1.p.x < e2.p.x) return -1;
  if (e1.p.y !== e2.p.y) return e1.p.y > e2.p.y ? 1 : -1;
  return 1;
}
function checkWhichSegmentHasRightEndpointFirst(seg1, seg2) {
  if (seg1.rightSweepEvent.p.x > seg2.rightSweepEvent.p.x) return 1;
  if (seg1.rightSweepEvent.p.x < seg2.rightSweepEvent.p.x) return -1;
  if (seg1.rightSweepEvent.p.y !== seg2.rightSweepEvent.p.y) return seg1.rightSweepEvent.p.y < seg2.rightSweepEvent.p.y ? 1 : -1;
  return 1;
}
var Event = class {
  constructor(p, featureId2, ringId2, eventId2) {
    this.p = {
      x: p[0],
      y: p[1]
    };
    this.featureId = featureId2;
    this.ringId = ringId2;
    this.eventId = eventId2;
    this.otherEvent = null;
    this.isLeftEndpoint = null;
  }
  isSamePoint(eventToCheck) {
    return this.p.x === eventToCheck.p.x && this.p.y === eventToCheck.p.y;
  }
};
function fillEventQueue(geojson, eventQueue) {
  if (geojson.type === "FeatureCollection") {
    const features = geojson.features;
    for (let i = 0; i < features.length; i++) {
      processFeature(features[i], eventQueue);
    }
  } else {
    processFeature(geojson, eventQueue);
  }
}
var featureId = 0;
var ringId = 0;
var eventId = 0;
function processFeature(featureOrGeometry, eventQueue) {
  const geom = featureOrGeometry.type === "Feature" ? featureOrGeometry.geometry : featureOrGeometry;
  let coords = geom.coordinates;
  if (geom.type === "Polygon" || geom.type === "MultiLineString") coords = [coords];
  if (geom.type === "LineString") coords = [[coords]];
  for (let i = 0; i < coords.length; i++) {
    for (let ii = 0; ii < coords[i].length; ii++) {
      let currentP = coords[i][ii][0];
      let nextP = null;
      ringId = ringId + 1;
      for (let iii = 0; iii < coords[i][ii].length - 1; iii++) {
        nextP = coords[i][ii][iii + 1];
        const e1 = new Event(currentP, featureId, ringId, eventId);
        const e2 = new Event(nextP, featureId, ringId, eventId + 1);
        e1.otherEvent = e2;
        e2.otherEvent = e1;
        if (checkWhichEventIsLeft(e1, e2) > 0) {
          e2.isLeftEndpoint = true;
          e1.isLeftEndpoint = false;
        } else {
          e1.isLeftEndpoint = true;
          e2.isLeftEndpoint = false;
        }
        eventQueue.push(e1);
        eventQueue.push(e2);
        currentP = nextP;
        eventId = eventId + 1;
      }
    }
  }
  featureId = featureId + 1;
}
var Segment = class {
  constructor(event) {
    this.leftSweepEvent = event;
    this.rightSweepEvent = event.otherEvent;
  }
};
function testSegmentIntersect(seg1, seg2) {
  if (seg1 === null || seg2 === null) return false;
  if (seg1.leftSweepEvent.ringId === seg2.leftSweepEvent.ringId && (seg1.rightSweepEvent.isSamePoint(seg2.leftSweepEvent) || seg1.rightSweepEvent.isSamePoint(seg2.leftSweepEvent) || seg1.rightSweepEvent.isSamePoint(seg2.rightSweepEvent) || seg1.leftSweepEvent.isSamePoint(seg2.leftSweepEvent) || seg1.leftSweepEvent.isSamePoint(seg2.rightSweepEvent))) return false;
  const x1 = seg1.leftSweepEvent.p.x;
  const y1 = seg1.leftSweepEvent.p.y;
  const x2 = seg1.rightSweepEvent.p.x;
  const y2 = seg1.rightSweepEvent.p.y;
  const x3 = seg2.leftSweepEvent.p.x;
  const y3 = seg2.leftSweepEvent.p.y;
  const x4 = seg2.rightSweepEvent.p.x;
  const y4 = seg2.rightSweepEvent.p.y;
  const denom = (y4 - y3) * (x2 - x1) - (x4 - x3) * (y2 - y1);
  const numeA = (x4 - x3) * (y1 - y3) - (y4 - y3) * (x1 - x3);
  const numeB = (x2 - x1) * (y1 - y3) - (y2 - y1) * (x1 - x3);
  if (denom === 0) {
    if (numeA === 0 && numeB === 0) return false;
    return false;
  }
  const uA = numeA / denom;
  const uB = numeB / denom;
  if (uA >= 0 && uA <= 1 && uB >= 0 && uB <= 1) {
    const x = x1 + uA * (x2 - x1);
    const y = y1 + uA * (y2 - y1);
    return [x, y];
  }
  return false;
}
function runCheck(eventQueue, ignoreSelfIntersections) {
  ignoreSelfIntersections = ignoreSelfIntersections ? ignoreSelfIntersections : false;
  const intersectionPoints = [];
  const outQueue = new TinyQueue([], checkWhichSegmentHasRightEndpointFirst);
  while (eventQueue.length) {
    const event = eventQueue.pop();
    if (event.isLeftEndpoint) {
      const segment = new Segment(event);
      for (let i = 0; i < outQueue.data.length; i++) {
        const otherSeg = outQueue.data[i];
        if (ignoreSelfIntersections) {
          if (otherSeg.leftSweepEvent.featureId === event.featureId) continue;
        }
        const intersection3 = testSegmentIntersect(segment, otherSeg);
        if (intersection3 !== false) intersectionPoints.push(intersection3);
      }
      outQueue.push(segment);
    } else if (event.isLeftEndpoint === false) {
      outQueue.pop();
    }
  }
  return intersectionPoints;
}
function sweeplineIntersections(geojson, ignoreSelfIntersections) {
  const eventQueue = new TinyQueue([], checkWhichEventIsLeft);
  fillEventQueue(geojson, eventQueue);
  return runCheck(eventQueue, ignoreSelfIntersections);
}
var sweeplineIntersections_esm_default = sweeplineIntersections;

// node_modules/@turf/line-intersect/dist/esm/index.js
var sweeplineIntersections2 = sweeplineIntersections_esm_default;
function lineIntersect(line1, line2, options = {}) {
  const { removeDuplicates = true, ignoreSelfIntersections = true } = options;
  let features = [];
  if (line1.type === "FeatureCollection")
    features = features.concat(line1.features);
  else if (line1.type === "Feature") features.push(line1);
  else if (line1.type === "LineString" || line1.type === "Polygon" || line1.type === "MultiLineString" || line1.type === "MultiPolygon") {
    features.push(feature(line1));
  }
  if (line2.type === "FeatureCollection")
    features = features.concat(line2.features);
  else if (line2.type === "Feature") features.push(line2);
  else if (line2.type === "LineString" || line2.type === "Polygon" || line2.type === "MultiLineString" || line2.type === "MultiPolygon") {
    features.push(feature(line2));
  }
  const intersections = sweeplineIntersections2(
    featureCollection(features),
    ignoreSelfIntersections
  );
  let results = [];
  if (removeDuplicates) {
    const unique = {};
    intersections.forEach((intersection3) => {
      const key = intersection3.join(",");
      if (!unique[key]) {
        unique[key] = true;
        results.push(intersection3);
      }
    });
  } else {
    results = intersections;
  }
  return featureCollection(results.map((r) => point(r)));
}

// node_modules/@turf/meta/dist/esm/index.js
init_cjs_shims();
function coordEach(geojson, callback, excludeWrapCoord) {
  if (geojson === null) return;
  var j, k, l, geometry, stopG, coords, geometryMaybeCollection, wrapShrink = 0, coordIndex = 0, isGeometryCollection, type = geojson.type, isFeatureCollection = type === "FeatureCollection", isFeature = type === "Feature", stop = isFeatureCollection ? geojson.features.length : 1;
  for (var featureIndex = 0; featureIndex < stop; featureIndex++) {
    geometryMaybeCollection = isFeatureCollection ? geojson.features[featureIndex].geometry : isFeature ? geojson.geometry : geojson;
    isGeometryCollection = geometryMaybeCollection ? geometryMaybeCollection.type === "GeometryCollection" : false;
    stopG = isGeometryCollection ? geometryMaybeCollection.geometries.length : 1;
    for (var geomIndex = 0; geomIndex < stopG; geomIndex++) {
      var multiFeatureIndex = 0;
      var geometryIndex = 0;
      geometry = isGeometryCollection ? geometryMaybeCollection.geometries[geomIndex] : geometryMaybeCollection;
      if (geometry === null) continue;
      coords = geometry.coordinates;
      var geomType = geometry.type;
      wrapShrink = excludeWrapCoord && (geomType === "Polygon" || geomType === "MultiPolygon") ? 1 : 0;
      switch (geomType) {
        case null:
          break;
        case "Point":
          if (callback(
            coords,
            coordIndex,
            featureIndex,
            multiFeatureIndex,
            geometryIndex
          ) === false)
            return false;
          coordIndex++;
          multiFeatureIndex++;
          break;
        case "LineString":
        case "MultiPoint":
          for (j = 0; j < coords.length; j++) {
            if (callback(
              coords[j],
              coordIndex,
              featureIndex,
              multiFeatureIndex,
              geometryIndex
            ) === false)
              return false;
            coordIndex++;
            if (geomType === "MultiPoint") multiFeatureIndex++;
          }
          if (geomType === "LineString") multiFeatureIndex++;
          break;
        case "Polygon":
        case "MultiLineString":
          for (j = 0; j < coords.length; j++) {
            for (k = 0; k < coords[j].length - wrapShrink; k++) {
              if (callback(
                coords[j][k],
                coordIndex,
                featureIndex,
                multiFeatureIndex,
                geometryIndex
              ) === false)
                return false;
              coordIndex++;
            }
            if (geomType === "MultiLineString") multiFeatureIndex++;
            if (geomType === "Polygon") geometryIndex++;
          }
          if (geomType === "Polygon") multiFeatureIndex++;
          break;
        case "MultiPolygon":
          for (j = 0; j < coords.length; j++) {
            geometryIndex = 0;
            for (k = 0; k < coords[j].length; k++) {
              for (l = 0; l < coords[j][k].length - wrapShrink; l++) {
                if (callback(
                  coords[j][k][l],
                  coordIndex,
                  featureIndex,
                  multiFeatureIndex,
                  geometryIndex
                ) === false)
                  return false;
                coordIndex++;
              }
              geometryIndex++;
            }
            multiFeatureIndex++;
          }
          break;
        case "GeometryCollection":
          for (j = 0; j < geometry.geometries.length; j++)
            if (coordEach(geometry.geometries[j], callback, excludeWrapCoord) === false)
              return false;
          break;
        default:
          throw new Error("Unknown Geometry Type");
      }
    }
  }
}
function geomEach(geojson, callback) {
  var i, j, g, geometry, stopG, geometryMaybeCollection, isGeometryCollection, featureProperties, featureBBox, featureId2, featureIndex = 0, isFeatureCollection = geojson.type === "FeatureCollection", isFeature = geojson.type === "Feature", stop = isFeatureCollection ? geojson.features.length : 1;
  for (i = 0; i < stop; i++) {
    geometryMaybeCollection = isFeatureCollection ? geojson.features[i].geometry : isFeature ? geojson.geometry : geojson;
    featureProperties = isFeatureCollection ? geojson.features[i].properties : isFeature ? geojson.properties : {};
    featureBBox = isFeatureCollection ? geojson.features[i].bbox : isFeature ? geojson.bbox : void 0;
    featureId2 = isFeatureCollection ? geojson.features[i].id : isFeature ? geojson.id : void 0;
    isGeometryCollection = geometryMaybeCollection ? geometryMaybeCollection.type === "GeometryCollection" : false;
    stopG = isGeometryCollection ? geometryMaybeCollection.geometries.length : 1;
    for (g = 0; g < stopG; g++) {
      geometry = isGeometryCollection ? geometryMaybeCollection.geometries[g] : geometryMaybeCollection;
      if (geometry === null) {
        if (callback(
          null,
          featureIndex,
          featureProperties,
          featureBBox,
          featureId2
        ) === false)
          return false;
        continue;
      }
      switch (geometry.type) {
        case "Point":
        case "LineString":
        case "MultiPoint":
        case "Polygon":
        case "MultiLineString":
        case "MultiPolygon": {
          if (callback(
            geometry,
            featureIndex,
            featureProperties,
            featureBBox,
            featureId2
          ) === false)
            return false;
          break;
        }
        case "GeometryCollection": {
          for (j = 0; j < geometry.geometries.length; j++) {
            if (callback(
              geometry.geometries[j],
              featureIndex,
              featureProperties,
              featureBBox,
              featureId2
            ) === false)
              return false;
          }
          break;
        }
        default:
          throw new Error("Unknown Geometry Type");
      }
    }
    featureIndex++;
  }
}
function flattenEach(geojson, callback) {
  geomEach(geojson, function(geometry, featureIndex, properties, bbox2, id) {
    var type = geometry === null ? null : geometry.type;
    switch (type) {
      case null:
      case "Point":
      case "LineString":
      case "Polygon":
        if (callback(
          feature(geometry, properties, { bbox: bbox2, id }),
          featureIndex,
          0
        ) === false)
          return false;
        return;
    }
    var geomType;
    switch (type) {
      case "MultiPoint":
        geomType = "Point";
        break;
      case "MultiLineString":
        geomType = "LineString";
        break;
      case "MultiPolygon":
        geomType = "Polygon";
        break;
    }
    for (var multiFeatureIndex = 0; multiFeatureIndex < geometry.coordinates.length; multiFeatureIndex++) {
      var coordinate = geometry.coordinates[multiFeatureIndex];
      var geom = {
        type: geomType,
        coordinates: coordinate
      };
      if (callback(feature(geom, properties), featureIndex, multiFeatureIndex) === false)
        return false;
    }
  });
}

// node_modules/@turf/polygon-to-line/dist/esm/index.js
init_cjs_shims();
function polygonToLine(poly, options = {}) {
  const geom = getGeom(poly);
  if (!options.properties && poly.type === "Feature") {
    options.properties = poly.properties;
  }
  switch (geom.type) {
    case "Polygon":
      return singlePolygonToLine(geom, options);
    case "MultiPolygon":
      return multiPolygonToLine(geom, options);
    default:
      throw new Error("invalid poly");
  }
}
function singlePolygonToLine(poly, options = {}) {
  const geom = getGeom(poly);
  const coords = geom.coordinates;
  const properties = options.properties ? options.properties : poly.type === "Feature" ? poly.properties : {};
  return coordsToLine(coords, properties);
}
function multiPolygonToLine(multiPoly, options = {}) {
  const geom = getGeom(multiPoly);
  const coords = geom.coordinates;
  const properties = options.properties ? options.properties : multiPoly.type === "Feature" ? multiPoly.properties : {};
  const lines = [];
  coords.forEach((coord) => {
    lines.push(coordsToLine(coord, properties));
  });
  return featureCollection(lines);
}
function coordsToLine(coords, properties) {
  if (coords.length > 1) {
    return multiLineString(coords, properties);
  }
  return lineString(coords[0], properties);
}

// node_modules/@turf/boolean-disjoint/dist/esm/index.js
function booleanDisjoint(feature1, feature2, {
  ignoreSelfIntersections = true
} = { ignoreSelfIntersections: true }) {
  let bool = true;
  flattenEach(feature1, (flatten1) => {
    flattenEach(feature2, (flatten2) => {
      if (bool === false) {
        return false;
      }
      bool = disjoint(
        flatten1.geometry,
        flatten2.geometry,
        ignoreSelfIntersections
      );
    });
  });
  return bool;
}
function disjoint(geom1, geom2, ignoreSelfIntersections) {
  switch (geom1.type) {
    case "Point":
      switch (geom2.type) {
        case "Point":
          return !compareCoords(geom1.coordinates, geom2.coordinates);
        case "LineString":
          return !isPointOnLine(geom2, geom1);
        case "Polygon":
          return !booleanPointInPolygon(geom1, geom2);
      }
      break;
    case "LineString":
      switch (geom2.type) {
        case "Point":
          return !isPointOnLine(geom1, geom2);
        case "LineString":
          return !isLineOnLine(geom1, geom2, ignoreSelfIntersections);
        case "Polygon":
          return !isLineInPoly(geom2, geom1, ignoreSelfIntersections);
      }
      break;
    case "Polygon":
      switch (geom2.type) {
        case "Point":
          return !booleanPointInPolygon(geom2, geom1);
        case "LineString":
          return !isLineInPoly(geom1, geom2, ignoreSelfIntersections);
        case "Polygon":
          return !isPolyInPoly(geom2, geom1, ignoreSelfIntersections);
      }
  }
  return false;
}
function isPointOnLine(lineString2, pt) {
  for (let i = 0; i < lineString2.coordinates.length - 1; i++) {
    if (isPointOnLineSegment(
      lineString2.coordinates[i],
      lineString2.coordinates[i + 1],
      pt.coordinates
    )) {
      return true;
    }
  }
  return false;
}
function isLineOnLine(lineString1, lineString2, ignoreSelfIntersections) {
  const doLinesIntersect = lineIntersect(lineString1, lineString2, {
    ignoreSelfIntersections
  });
  if (doLinesIntersect.features.length > 0) {
    return true;
  }
  return false;
}
function isLineInPoly(polygon2, lineString2, ignoreSelfIntersections) {
  for (const coord of lineString2.coordinates) {
    if (booleanPointInPolygon(coord, polygon2)) {
      return true;
    }
  }
  const doLinesIntersect = lineIntersect(lineString2, polygonToLine(polygon2), {
    ignoreSelfIntersections
  });
  if (doLinesIntersect.features.length > 0) {
    return true;
  }
  return false;
}
function isPolyInPoly(feature1, feature2, ignoreSelfIntersections) {
  for (const coord1 of feature1.coordinates[0]) {
    if (booleanPointInPolygon(coord1, feature2)) {
      return true;
    }
  }
  for (const coord2 of feature2.coordinates[0]) {
    if (booleanPointInPolygon(coord2, feature1)) {
      return true;
    }
  }
  const doLinesIntersect = lineIntersect(
    polygonToLine(feature1),
    polygonToLine(feature2),
    { ignoreSelfIntersections }
  );
  if (doLinesIntersect.features.length > 0) {
    return true;
  }
  return false;
}
function isPointOnLineSegment(lineSegmentStart, lineSegmentEnd, pt) {
  const dxc = pt[0] - lineSegmentStart[0];
  const dyc = pt[1] - lineSegmentStart[1];
  const dxl = lineSegmentEnd[0] - lineSegmentStart[0];
  const dyl = lineSegmentEnd[1] - lineSegmentStart[1];
  const cross = dxc * dyl - dyc * dxl;
  if (cross !== 0) {
    return false;
  }
  if (Math.abs(dxl) >= Math.abs(dyl)) {
    if (dxl > 0) {
      return lineSegmentStart[0] <= pt[0] && pt[0] <= lineSegmentEnd[0];
    } else {
      return lineSegmentEnd[0] <= pt[0] && pt[0] <= lineSegmentStart[0];
    }
  } else if (dyl > 0) {
    return lineSegmentStart[1] <= pt[1] && pt[1] <= lineSegmentEnd[1];
  } else {
    return lineSegmentEnd[1] <= pt[1] && pt[1] <= lineSegmentStart[1];
  }
}
function compareCoords(pair1, pair2) {
  return pair1[0] === pair2[0] && pair1[1] === pair2[1];
}

// node_modules/@turf/boolean-intersects/dist/esm/index.js
function booleanIntersects(feature1, feature2, {
  ignoreSelfIntersections = true
} = {}) {
  let bool = false;
  flattenEach(feature1, (flatten1) => {
    flattenEach(feature2, (flatten2) => {
      if (bool === true) {
        return true;
      }
      bool = !booleanDisjoint(flatten1.geometry, flatten2.geometry, {
        ignoreSelfIntersections
      });
    });
  });
  return bool;
}
var turf_boolean_intersects_default = booleanIntersects;

// src/filters/geosjonFeatures.ts
function geojsonFeatures({
  geojson,
  spatialFilter,
  uniqueIdProperty
}) {
  let uniqueIdx = 0;
  const map = /* @__PURE__ */ new Map();
  if (!spatialFilter) {
    return [];
  }
  for (const feature2 of geojson.features) {
    const uniqueId = uniqueIdProperty ? feature2.properties[uniqueIdProperty] : ++uniqueIdx;
    if (!map.has(uniqueId) && turf_boolean_intersects_default(spatialFilter, feature2)) {
      map.set(uniqueId, feature2.properties);
    }
  }
  return Array.from(map.values());
}

// src/filters/tileFeatures.ts
init_cjs_shims();

// src/filters/tileFeaturesGeometries.ts
init_cjs_shims();

// src/utils/transformTileCoordsToWGS84.ts
init_cjs_shims();

// node_modules/@math.gl/core/dist/index.js
init_cjs_shims();

// node_modules/@math.gl/core/dist/lib/common.js
init_cjs_shims();
var RADIANS_TO_DEGREES = 1 / Math.PI * 180;
var DEGREES_TO_RADIANS = 1 / 180 * Math.PI;
var DEFAULT_CONFIG = {
  EPSILON: 1e-12,
  debug: false,
  precision: 4,
  printTypes: false,
  printDegrees: false,
  printRowMajor: true,
  _cartographicRadians: false
};
globalThis.mathgl = globalThis.mathgl || { config: { ...DEFAULT_CONFIG } };
var config = globalThis.mathgl.config;
function isArray(value) {
  return Array.isArray(value) || ArrayBuffer.isView(value) && !(value instanceof DataView);
}
function lerp(a, b, t) {
  if (isArray(a)) {
    return a.map((ai, i) => lerp(ai, b[i], t));
  }
  return t * b + (1 - t) * a;
}

// node_modules/@math.gl/web-mercator/dist/index.js
init_cjs_shims();

// node_modules/@math.gl/web-mercator/dist/web-mercator-viewport.js
init_cjs_shims();

// node_modules/@math.gl/web-mercator/dist/math-utils.js
init_cjs_shims();

// node_modules/@math.gl/web-mercator/dist/web-mercator-utils.js
init_cjs_shims();

// node_modules/@math.gl/web-mercator/dist/assert.js
init_cjs_shims();
function assert(condition, message) {
  if (!condition) {
    throw new Error(message || "@math.gl/web-mercator: assertion failed.");
  }
}

// node_modules/@math.gl/web-mercator/dist/web-mercator-utils.js
var PI = Math.PI;
var PI_4 = PI / 4;
var DEGREES_TO_RADIANS2 = PI / 180;
var RADIANS_TO_DEGREES2 = 180 / PI;
var TILE_SIZE = 512;
function lngLatToWorld(lngLat) {
  const [lng, lat] = lngLat;
  assert(Number.isFinite(lng));
  assert(Number.isFinite(lat) && lat >= -90 && lat <= 90, "invalid latitude");
  const lambda2 = lng * DEGREES_TO_RADIANS2;
  const phi2 = lat * DEGREES_TO_RADIANS2;
  const x = TILE_SIZE * (lambda2 + PI) / (2 * PI);
  const y = TILE_SIZE * (PI + Math.log(Math.tan(PI_4 + phi2 * 0.5))) / (2 * PI);
  return [x, y];
}
function worldToLngLat(xy) {
  const [x, y] = xy;
  const lambda2 = x / TILE_SIZE * (2 * PI) - PI;
  const phi2 = 2 * (Math.atan(Math.exp(y / TILE_SIZE * (2 * PI) - PI)) - PI_4);
  return [lambda2 * RADIANS_TO_DEGREES2, phi2 * RADIANS_TO_DEGREES2];
}

// node_modules/@math.gl/web-mercator/dist/fit-bounds.js
init_cjs_shims();

// node_modules/@math.gl/web-mercator/dist/get-bounds.js
init_cjs_shims();
var DEGREES_TO_RADIANS3 = Math.PI / 180;

// node_modules/@math.gl/web-mercator/dist/normalize-viewport-props.js
init_cjs_shims();

// node_modules/@math.gl/web-mercator/dist/fly-to-viewport.js
init_cjs_shims();

// src/utils/transformTileCoordsToWGS84.ts
var TRANSFORM_FN = {
  Point: transformPoint,
  MultiPoint: transformMultiPoint,
  LineString: transformLineString,
  MultiLineString: transformMultiLineString,
  Polygon: transformPolygon,
  MultiPolygon: transformMultiPolygon
};
function transformTileCoordsToWGS84(geometry, bbox2) {
  const [west, south, east, north] = bbox2;
  const nw = lngLatToWorld([west, north]);
  const se = lngLatToWorld([east, south]);
  const projectedBbox = [nw, se];
  if (geometry.type === "GeometryCollection") {
    throw new Error("Unsupported geometry type GeometryCollection");
  }
  const transformFn = TRANSFORM_FN[geometry.type];
  const coordinates = transformFn(geometry.coordinates, projectedBbox);
  return { ...geometry, coordinates };
}
function transformPoint([pointX, pointY], [nw, se]) {
  const x = lerp(nw[0], se[0], pointX);
  const y = lerp(nw[1], se[1], pointY);
  return worldToLngLat([x, y]);
}
function getPoints(geometry, bbox2) {
  return geometry.map((g) => transformPoint(g, bbox2));
}
function transformMultiPoint(multiPoint, bbox2) {
  return getPoints(multiPoint, bbox2);
}
function transformLineString(line, bbox2) {
  return getPoints(line, bbox2);
}
function transformMultiLineString(multiLineString2, bbox2) {
  return multiLineString2.map(
    (lineString2) => transformLineString(lineString2, bbox2)
  );
}
function transformPolygon(polygon2, bbox2) {
  return polygon2.map((polygonRing) => getPoints(polygonRing, bbox2));
}
function transformMultiPolygon(multiPolygon2, bbox2) {
  return multiPolygon2.map((polygon2) => transformPolygon(polygon2, bbox2));
}

// src/filters/tileIntersection.ts
init_cjs_shims();

// node_modules/@turf/bbox-polygon/dist/esm/index.js
init_cjs_shims();
function bboxPolygon(bbox2, options = {}) {
  const west = Number(bbox2[0]);
  const south = Number(bbox2[1]);
  const east = Number(bbox2[2]);
  const north = Number(bbox2[3]);
  if (bbox2.length === 6) {
    throw new Error(
      "@turf/bbox-polygon does not support BBox with 6 positions"
    );
  }
  const lowLeft = [west, south];
  const topLeft = [west, north];
  const topRight = [east, north];
  const lowRight = [east, south];
  return polygon(
    [[lowLeft, lowRight, topRight, topLeft, lowLeft]],
    options.properties,
    { bbox: bbox2, id: options.id }
  );
}
var turf_bbox_polygon_default = bboxPolygon;

// node_modules/@turf/boolean-within/dist/esm/index.js
init_cjs_shims();

// node_modules/@turf/bbox/dist/esm/index.js
init_cjs_shims();
function bbox(geojson, options = {}) {
  if (geojson.bbox != null && true !== options.recompute) {
    return geojson.bbox;
  }
  const result = [Infinity, Infinity, -Infinity, -Infinity];
  coordEach(geojson, (coord) => {
    if (result[0] > coord[0]) {
      result[0] = coord[0];
    }
    if (result[1] > coord[1]) {
      result[1] = coord[1];
    }
    if (result[2] < coord[0]) {
      result[2] = coord[0];
    }
    if (result[3] < coord[1]) {
      result[3] = coord[1];
    }
  });
  return result;
}

// node_modules/@turf/boolean-point-on-line/dist/esm/index.js
init_cjs_shims();
function booleanPointOnLine(pt, line, options = {}) {
  const ptCoords = getCoord(pt);
  const lineCoords = getCoords(line);
  for (let i = 0; i < lineCoords.length - 1; i++) {
    let ignoreBoundary = false;
    if (options.ignoreEndVertices) {
      if (i === 0) {
        ignoreBoundary = "start";
      }
      if (i === lineCoords.length - 2) {
        ignoreBoundary = "end";
      }
      if (i === 0 && i + 1 === lineCoords.length - 1) {
        ignoreBoundary = "both";
      }
    }
    if (isPointOnLineSegment2(
      lineCoords[i],
      lineCoords[i + 1],
      ptCoords,
      ignoreBoundary,
      typeof options.epsilon === "undefined" ? null : options.epsilon
    )) {
      return true;
    }
  }
  return false;
}
function isPointOnLineSegment2(lineSegmentStart, lineSegmentEnd, pt, excludeBoundary, epsilon2) {
  const x = pt[0];
  const y = pt[1];
  const x1 = lineSegmentStart[0];
  const y1 = lineSegmentStart[1];
  const x2 = lineSegmentEnd[0];
  const y2 = lineSegmentEnd[1];
  const dxc = pt[0] - x1;
  const dyc = pt[1] - y1;
  const dxl = x2 - x1;
  const dyl = y2 - y1;
  const cross = dxc * dyl - dyc * dxl;
  if (epsilon2 !== null) {
    if (Math.abs(cross) > epsilon2) {
      return false;
    }
  } else if (cross !== 0) {
    return false;
  }
  if (Math.abs(dxl) === Math.abs(dyl) && Math.abs(dxl) === 0) {
    if (excludeBoundary) {
      return false;
    }
    if (pt[0] === lineSegmentStart[0] && pt[1] === lineSegmentStart[1]) {
      return true;
    } else {
      return false;
    }
  }
  if (!excludeBoundary) {
    if (Math.abs(dxl) >= Math.abs(dyl)) {
      return dxl > 0 ? x1 <= x && x <= x2 : x2 <= x && x <= x1;
    }
    return dyl > 0 ? y1 <= y && y <= y2 : y2 <= y && y <= y1;
  } else if (excludeBoundary === "start") {
    if (Math.abs(dxl) >= Math.abs(dyl)) {
      return dxl > 0 ? x1 < x && x <= x2 : x2 <= x && x < x1;
    }
    return dyl > 0 ? y1 < y && y <= y2 : y2 <= y && y < y1;
  } else if (excludeBoundary === "end") {
    if (Math.abs(dxl) >= Math.abs(dyl)) {
      return dxl > 0 ? x1 <= x && x < x2 : x2 < x && x <= x1;
    }
    return dyl > 0 ? y1 <= y && y < y2 : y2 < y && y <= y1;
  } else if (excludeBoundary === "both") {
    if (Math.abs(dxl) >= Math.abs(dyl)) {
      return dxl > 0 ? x1 < x && x < x2 : x2 < x && x < x1;
    }
    return dyl > 0 ? y1 < y && y < y2 : y2 < y && y < y1;
  }
  return false;
}

// node_modules/@turf/boolean-within/dist/esm/index.js
function booleanWithin(feature1, feature2) {
  var geom1 = getGeom(feature1);
  var geom2 = getGeom(feature2);
  var type1 = geom1.type;
  var type2 = geom2.type;
  switch (type1) {
    case "Point":
      switch (type2) {
        case "MultiPoint":
          return isPointInMultiPoint(geom1, geom2);
        case "LineString":
          return booleanPointOnLine(geom1, geom2, { ignoreEndVertices: true });
        case "Polygon":
        case "MultiPolygon":
          return booleanPointInPolygon(geom1, geom2, { ignoreBoundary: true });
        default:
          throw new Error("feature2 " + type2 + " geometry not supported");
      }
    case "MultiPoint":
      switch (type2) {
        case "MultiPoint":
          return isMultiPointInMultiPoint(geom1, geom2);
        case "LineString":
          return isMultiPointOnLine(geom1, geom2);
        case "Polygon":
        case "MultiPolygon":
          return isMultiPointInPoly(geom1, geom2);
        default:
          throw new Error("feature2 " + type2 + " geometry not supported");
      }
    case "LineString":
      switch (type2) {
        case "LineString":
          return isLineOnLine2(geom1, geom2);
        case "Polygon":
        case "MultiPolygon":
          return isLineInPoly2(geom1, geom2);
        default:
          throw new Error("feature2 " + type2 + " geometry not supported");
      }
    case "Polygon":
      switch (type2) {
        case "Polygon":
        case "MultiPolygon":
          return isPolyInPoly2(geom1, geom2);
        default:
          throw new Error("feature2 " + type2 + " geometry not supported");
      }
    default:
      throw new Error("feature1 " + type1 + " geometry not supported");
  }
}
function isPointInMultiPoint(point2, multiPoint) {
  var i;
  var output = false;
  for (i = 0; i < multiPoint.coordinates.length; i++) {
    if (compareCoords2(multiPoint.coordinates[i], point2.coordinates)) {
      output = true;
      break;
    }
  }
  return output;
}
function isMultiPointInMultiPoint(multiPoint1, multiPoint2) {
  for (var i = 0; i < multiPoint1.coordinates.length; i++) {
    var anyMatch = false;
    for (var i2 = 0; i2 < multiPoint2.coordinates.length; i2++) {
      if (compareCoords2(multiPoint1.coordinates[i], multiPoint2.coordinates[i2])) {
        anyMatch = true;
      }
    }
    if (!anyMatch) {
      return false;
    }
  }
  return true;
}
function isMultiPointOnLine(multiPoint, lineString2) {
  var foundInsidePoint = false;
  for (var i = 0; i < multiPoint.coordinates.length; i++) {
    if (!booleanPointOnLine(multiPoint.coordinates[i], lineString2)) {
      return false;
    }
    if (!foundInsidePoint) {
      foundInsidePoint = booleanPointOnLine(
        multiPoint.coordinates[i],
        lineString2,
        { ignoreEndVertices: true }
      );
    }
  }
  return foundInsidePoint;
}
function isMultiPointInPoly(multiPoint, polygon2) {
  var output = true;
  var oneInside = false;
  var isInside = false;
  for (var i = 0; i < multiPoint.coordinates.length; i++) {
    isInside = booleanPointInPolygon(multiPoint.coordinates[i], polygon2);
    if (!isInside) {
      output = false;
      break;
    }
    if (!oneInside) {
      isInside = booleanPointInPolygon(multiPoint.coordinates[i], polygon2, {
        ignoreBoundary: true
      });
    }
  }
  return output && isInside;
}
function isLineOnLine2(lineString1, lineString2) {
  for (var i = 0; i < lineString1.coordinates.length; i++) {
    if (!booleanPointOnLine(lineString1.coordinates[i], lineString2)) {
      return false;
    }
  }
  return true;
}
function isLineInPoly2(linestring, polygon2) {
  var polyBbox = bbox(polygon2);
  var lineBbox = bbox(linestring);
  if (!doBBoxOverlap(polyBbox, lineBbox)) {
    return false;
  }
  var foundInsidePoint = false;
  for (var i = 0; i < linestring.coordinates.length; i++) {
    if (!booleanPointInPolygon(linestring.coordinates[i], polygon2)) {
      return false;
    }
    if (!foundInsidePoint) {
      foundInsidePoint = booleanPointInPolygon(
        linestring.coordinates[i],
        polygon2,
        { ignoreBoundary: true }
      );
    }
    if (!foundInsidePoint && i < linestring.coordinates.length - 1) {
      var midpoint = getMidpoint(
        linestring.coordinates[i],
        linestring.coordinates[i + 1]
      );
      foundInsidePoint = booleanPointInPolygon(midpoint, polygon2, {
        ignoreBoundary: true
      });
    }
  }
  return foundInsidePoint;
}
function isPolyInPoly2(geometry1, geometry2) {
  var poly1Bbox = bbox(geometry1);
  var poly2Bbox = bbox(geometry2);
  if (!doBBoxOverlap(poly2Bbox, poly1Bbox)) {
    return false;
  }
  for (var i = 0; i < geometry1.coordinates[0].length; i++) {
    if (!booleanPointInPolygon(geometry1.coordinates[0][i], geometry2)) {
      return false;
    }
  }
  return true;
}
function doBBoxOverlap(bbox1, bbox2) {
  if (bbox1[0] > bbox2[0]) return false;
  if (bbox1[2] < bbox2[2]) return false;
  if (bbox1[1] > bbox2[1]) return false;
  if (bbox1[3] < bbox2[3]) return false;
  return true;
}
function compareCoords2(pair1, pair2) {
  return pair1[0] === pair2[0] && pair1[1] === pair2[1];
}
function getMidpoint(pair1, pair2) {
  return [(pair1[0] + pair2[0]) / 2, (pair1[1] + pair2[1]) / 2];
}
var turf_boolean_within_default = booleanWithin;

// node_modules/@turf/intersect/dist/esm/index.js
init_cjs_shims();

// node_modules/polyclip-ts/dist/esm/index.js
init_cjs_shims();

// node_modules/bignumber.js/bignumber.mjs
init_cjs_shims();
var isNumeric = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i;
var mathceil = Math.ceil;
var mathfloor = Math.floor;
var bignumberError = "[BigNumber Error] ";
var tooManyDigits = bignumberError + "Number primitive has more than 15 significant digits: ";
var BASE = 1e14;
var LOG_BASE = 14;
var MAX_SAFE_INTEGER = 9007199254740991;
var POWS_TEN = [1, 10, 100, 1e3, 1e4, 1e5, 1e6, 1e7, 1e8, 1e9, 1e10, 1e11, 1e12, 1e13];
var SQRT_BASE = 1e7;
var MAX = 1e9;
function clone2(configObject) {
  var div, convertBase, parseNumeric, P = BigNumber2.prototype = { constructor: BigNumber2, toString: null, valueOf: null }, ONE = new BigNumber2(1), DECIMAL_PLACES = 20, ROUNDING_MODE = 4, TO_EXP_NEG = -7, TO_EXP_POS = 21, MIN_EXP = -1e7, MAX_EXP = 1e7, CRYPTO = false, MODULO_MODE = 1, POW_PRECISION = 0, FORMAT = {
    prefix: "",
    groupSize: 3,
    secondaryGroupSize: 0,
    groupSeparator: ",",
    decimalSeparator: ".",
    fractionGroupSize: 0,
    fractionGroupSeparator: "\xA0",
    // non-breaking space
    suffix: ""
  }, ALPHABET = "0123456789abcdefghijklmnopqrstuvwxyz", alphabetHasNormalDecimalDigits = true;
  function BigNumber2(v2, b) {
    var alphabet, c, caseChanged, e, i, isNum, len, str, x = this;
    if (!(x instanceof BigNumber2)) return new BigNumber2(v2, b);
    if (b == null) {
      if (v2 && v2._isBigNumber === true) {
        x.s = v2.s;
        if (!v2.c || v2.e > MAX_EXP) {
          x.c = x.e = null;
        } else if (v2.e < MIN_EXP) {
          x.c = [x.e = 0];
        } else {
          x.e = v2.e;
          x.c = v2.c.slice();
        }
        return;
      }
      if ((isNum = typeof v2 == "number") && v2 * 0 == 0) {
        x.s = 1 / v2 < 0 ? (v2 = -v2, -1) : 1;
        if (v2 === ~~v2) {
          for (e = 0, i = v2; i >= 10; i /= 10, e++) ;
          if (e > MAX_EXP) {
            x.c = x.e = null;
          } else {
            x.e = e;
            x.c = [v2];
          }
          return;
        }
        str = String(v2);
      } else {
        if (!isNumeric.test(str = String(v2))) return parseNumeric(x, str, isNum);
        x.s = str.charCodeAt(0) == 45 ? (str = str.slice(1), -1) : 1;
      }
      if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
      if ((i = str.search(/e/i)) > 0) {
        if (e < 0) e = i;
        e += +str.slice(i + 1);
        str = str.substring(0, i);
      } else if (e < 0) {
        e = str.length;
      }
    } else {
      intCheck(b, 2, ALPHABET.length, "Base");
      if (b == 10 && alphabetHasNormalDecimalDigits) {
        x = new BigNumber2(v2);
        return round(x, DECIMAL_PLACES + x.e + 1, ROUNDING_MODE);
      }
      str = String(v2);
      if (isNum = typeof v2 == "number") {
        if (v2 * 0 != 0) return parseNumeric(x, str, isNum, b);
        x.s = 1 / v2 < 0 ? (str = str.slice(1), -1) : 1;
        if (BigNumber2.DEBUG && str.replace(/^0\.0*|\./, "").length > 15) {
          throw Error(tooManyDigits + v2);
        }
      } else {
        x.s = str.charCodeAt(0) === 45 ? (str = str.slice(1), -1) : 1;
      }
      alphabet = ALPHABET.slice(0, b);
      e = i = 0;
      for (len = str.length; i < len; i++) {
        if (alphabet.indexOf(c = str.charAt(i)) < 0) {
          if (c == ".") {
            if (i > e) {
              e = len;
              continue;
            }
          } else if (!caseChanged) {
            if (str == str.toUpperCase() && (str = str.toLowerCase()) || str == str.toLowerCase() && (str = str.toUpperCase())) {
              caseChanged = true;
              i = -1;
              e = 0;
              continue;
            }
          }
          return parseNumeric(x, String(v2), isNum, b);
        }
      }
      isNum = false;
      str = convertBase(str, b, 10, x.s);
      if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
      else e = str.length;
    }
    for (i = 0; str.charCodeAt(i) === 48; i++) ;
    for (len = str.length; str.charCodeAt(--len) === 48; ) ;
    if (str = str.slice(i, ++len)) {
      len -= i;
      if (isNum && BigNumber2.DEBUG && len > 15 && (v2 > MAX_SAFE_INTEGER || v2 !== mathfloor(v2))) {
        throw Error(tooManyDigits + x.s * v2);
      }
      if ((e = e - i - 1) > MAX_EXP) {
        x.c = x.e = null;
      } else if (e < MIN_EXP) {
        x.c = [x.e = 0];
      } else {
        x.e = e;
        x.c = [];
        i = (e + 1) % LOG_BASE;
        if (e < 0) i += LOG_BASE;
        if (i < len) {
          if (i) x.c.push(+str.slice(0, i));
          for (len -= LOG_BASE; i < len; ) {
            x.c.push(+str.slice(i, i += LOG_BASE));
          }
          i = LOG_BASE - (str = str.slice(i)).length;
        } else {
          i -= len;
        }
        for (; i--; str += "0") ;
        x.c.push(+str);
      }
    } else {
      x.c = [x.e = 0];
    }
  }
  BigNumber2.clone = clone2;
  BigNumber2.ROUND_UP = 0;
  BigNumber2.ROUND_DOWN = 1;
  BigNumber2.ROUND_CEIL = 2;
  BigNumber2.ROUND_FLOOR = 3;
  BigNumber2.ROUND_HALF_UP = 4;
  BigNumber2.ROUND_HALF_DOWN = 5;
  BigNumber2.ROUND_HALF_EVEN = 6;
  BigNumber2.ROUND_HALF_CEIL = 7;
  BigNumber2.ROUND_HALF_FLOOR = 8;
  BigNumber2.EUCLID = 9;
  BigNumber2.config = BigNumber2.set = function(obj) {
    var p, v2;
    if (obj != null) {
      if (typeof obj == "object") {
        if (obj.hasOwnProperty(p = "DECIMAL_PLACES")) {
          v2 = obj[p];
          intCheck(v2, 0, MAX, p);
          DECIMAL_PLACES = v2;
        }
        if (obj.hasOwnProperty(p = "ROUNDING_MODE")) {
          v2 = obj[p];
          intCheck(v2, 0, 8, p);
          ROUNDING_MODE = v2;
        }
        if (obj.hasOwnProperty(p = "EXPONENTIAL_AT")) {
          v2 = obj[p];
          if (v2 && v2.pop) {
            intCheck(v2[0], -MAX, 0, p);
            intCheck(v2[1], 0, MAX, p);
            TO_EXP_NEG = v2[0];
            TO_EXP_POS = v2[1];
          } else {
            intCheck(v2, -MAX, MAX, p);
            TO_EXP_NEG = -(TO_EXP_POS = v2 < 0 ? -v2 : v2);
          }
        }
        if (obj.hasOwnProperty(p = "RANGE")) {
          v2 = obj[p];
          if (v2 && v2.pop) {
            intCheck(v2[0], -MAX, -1, p);
            intCheck(v2[1], 1, MAX, p);
            MIN_EXP = v2[0];
            MAX_EXP = v2[1];
          } else {
            intCheck(v2, -MAX, MAX, p);
            if (v2) {
              MIN_EXP = -(MAX_EXP = v2 < 0 ? -v2 : v2);
            } else {
              throw Error(bignumberError + p + " cannot be zero: " + v2);
            }
          }
        }
        if (obj.hasOwnProperty(p = "CRYPTO")) {
          v2 = obj[p];
          if (v2 === !!v2) {
            if (v2) {
              if (typeof crypto != "undefined" && crypto && (crypto.getRandomValues || crypto.randomBytes)) {
                CRYPTO = v2;
              } else {
                CRYPTO = !v2;
                throw Error(bignumberError + "crypto unavailable");
              }
            } else {
              CRYPTO = v2;
            }
          } else {
            throw Error(bignumberError + p + " not true or false: " + v2);
          }
        }
        if (obj.hasOwnProperty(p = "MODULO_MODE")) {
          v2 = obj[p];
          intCheck(v2, 0, 9, p);
          MODULO_MODE = v2;
        }
        if (obj.hasOwnProperty(p = "POW_PRECISION")) {
          v2 = obj[p];
          intCheck(v2, 0, MAX, p);
          POW_PRECISION = v2;
        }
        if (obj.hasOwnProperty(p = "FORMAT")) {
          v2 = obj[p];
          if (typeof v2 == "object") FORMAT = v2;
          else throw Error(bignumberError + p + " not an object: " + v2);
        }
        if (obj.hasOwnProperty(p = "ALPHABET")) {
          v2 = obj[p];
          if (typeof v2 == "string" && !/^.?$|[+\-.\s]|(.).*\1/.test(v2)) {
            alphabetHasNormalDecimalDigits = v2.slice(0, 10) == "0123456789";
            ALPHABET = v2;
          } else {
            throw Error(bignumberError + p + " invalid: " + v2);
          }
        }
      } else {
        throw Error(bignumberError + "Object expected: " + obj);
      }
    }
    return {
      DECIMAL_PLACES,
      ROUNDING_MODE,
      EXPONENTIAL_AT: [TO_EXP_NEG, TO_EXP_POS],
      RANGE: [MIN_EXP, MAX_EXP],
      CRYPTO,
      MODULO_MODE,
      POW_PRECISION,
      FORMAT,
      ALPHABET
    };
  };
  BigNumber2.isBigNumber = function(v2) {
    if (!v2 || v2._isBigNumber !== true) return false;
    if (!BigNumber2.DEBUG) return true;
    var i, n, c = v2.c, e = v2.e, s = v2.s;
    out: if ({}.toString.call(c) == "[object Array]") {
      if ((s === 1 || s === -1) && e >= -MAX && e <= MAX && e === mathfloor(e)) {
        if (c[0] === 0) {
          if (e === 0 && c.length === 1) return true;
          break out;
        }
        i = (e + 1) % LOG_BASE;
        if (i < 1) i += LOG_BASE;
        if (String(c[0]).length == i) {
          for (i = 0; i < c.length; i++) {
            n = c[i];
            if (n < 0 || n >= BASE || n !== mathfloor(n)) break out;
          }
          if (n !== 0) return true;
        }
      }
    } else if (c === null && e === null && (s === null || s === 1 || s === -1)) {
      return true;
    }
    throw Error(bignumberError + "Invalid BigNumber: " + v2);
  };
  BigNumber2.maximum = BigNumber2.max = function() {
    return maxOrMin(arguments, -1);
  };
  BigNumber2.minimum = BigNumber2.min = function() {
    return maxOrMin(arguments, 1);
  };
  BigNumber2.random = function() {
    var pow2_53 = 9007199254740992;
    var random53bitInt = Math.random() * pow2_53 & 2097151 ? function() {
      return mathfloor(Math.random() * pow2_53);
    } : function() {
      return (Math.random() * 1073741824 | 0) * 8388608 + (Math.random() * 8388608 | 0);
    };
    return function(dp) {
      var a, b, e, k, v2, i = 0, c = [], rand = new BigNumber2(ONE);
      if (dp == null) dp = DECIMAL_PLACES;
      else intCheck(dp, 0, MAX);
      k = mathceil(dp / LOG_BASE);
      if (CRYPTO) {
        if (crypto.getRandomValues) {
          a = crypto.getRandomValues(new Uint32Array(k *= 2));
          for (; i < k; ) {
            v2 = a[i] * 131072 + (a[i + 1] >>> 11);
            if (v2 >= 9e15) {
              b = crypto.getRandomValues(new Uint32Array(2));
              a[i] = b[0];
              a[i + 1] = b[1];
            } else {
              c.push(v2 % 1e14);
              i += 2;
            }
          }
          i = k / 2;
        } else if (crypto.randomBytes) {
          a = crypto.randomBytes(k *= 7);
          for (; i < k; ) {
            v2 = (a[i] & 31) * 281474976710656 + a[i + 1] * 1099511627776 + a[i + 2] * 4294967296 + a[i + 3] * 16777216 + (a[i + 4] << 16) + (a[i + 5] << 8) + a[i + 6];
            if (v2 >= 9e15) {
              crypto.randomBytes(7).copy(a, i);
            } else {
              c.push(v2 % 1e14);
              i += 7;
            }
          }
          i = k / 7;
        } else {
          CRYPTO = false;
          throw Error(bignumberError + "crypto unavailable");
        }
      }
      if (!CRYPTO) {
        for (; i < k; ) {
          v2 = random53bitInt();
          if (v2 < 9e15) c[i++] = v2 % 1e14;
        }
      }
      k = c[--i];
      dp %= LOG_BASE;
      if (k && dp) {
        v2 = POWS_TEN[LOG_BASE - dp];
        c[i] = mathfloor(k / v2) * v2;
      }
      for (; c[i] === 0; c.pop(), i--) ;
      if (i < 0) {
        c = [e = 0];
      } else {
        for (e = -1; c[0] === 0; c.splice(0, 1), e -= LOG_BASE) ;
        for (i = 1, v2 = c[0]; v2 >= 10; v2 /= 10, i++) ;
        if (i < LOG_BASE) e -= LOG_BASE - i;
      }
      rand.e = e;
      rand.c = c;
      return rand;
    };
  }();
  BigNumber2.sum = function() {
    var i = 1, args = arguments, sum3 = new BigNumber2(args[0]);
    for (; i < args.length; ) sum3 = sum3.plus(args[i++]);
    return sum3;
  };
  convertBase = /* @__PURE__ */ function() {
    var decimal = "0123456789";
    function toBaseOut(str, baseIn, baseOut, alphabet) {
      var j, arr = [0], arrL, i = 0, len = str.length;
      for (; i < len; ) {
        for (arrL = arr.length; arrL--; arr[arrL] *= baseIn) ;
        arr[0] += alphabet.indexOf(str.charAt(i++));
        for (j = 0; j < arr.length; j++) {
          if (arr[j] > baseOut - 1) {
            if (arr[j + 1] == null) arr[j + 1] = 0;
            arr[j + 1] += arr[j] / baseOut | 0;
            arr[j] %= baseOut;
          }
        }
      }
      return arr.reverse();
    }
    return function(str, baseIn, baseOut, sign, callerIsToString) {
      var alphabet, d, e, k, r, x, xc, y, i = str.indexOf("."), dp = DECIMAL_PLACES, rm = ROUNDING_MODE;
      if (i >= 0) {
        k = POW_PRECISION;
        POW_PRECISION = 0;
        str = str.replace(".", "");
        y = new BigNumber2(baseIn);
        x = y.pow(str.length - i);
        POW_PRECISION = k;
        y.c = toBaseOut(
          toFixedPoint(coeffToString(x.c), x.e, "0"),
          10,
          baseOut,
          decimal
        );
        y.e = y.c.length;
      }
      xc = toBaseOut(str, baseIn, baseOut, callerIsToString ? (alphabet = ALPHABET, decimal) : (alphabet = decimal, ALPHABET));
      e = k = xc.length;
      for (; xc[--k] == 0; xc.pop()) ;
      if (!xc[0]) return alphabet.charAt(0);
      if (i < 0) {
        --e;
      } else {
        x.c = xc;
        x.e = e;
        x.s = sign;
        x = div(x, y, dp, rm, baseOut);
        xc = x.c;
        r = x.r;
        e = x.e;
      }
      d = e + dp + 1;
      i = xc[d];
      k = baseOut / 2;
      r = r || d < 0 || xc[d + 1] != null;
      r = rm < 4 ? (i != null || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : i > k || i == k && (rm == 4 || r || rm == 6 && xc[d - 1] & 1 || rm == (x.s < 0 ? 8 : 7));
      if (d < 1 || !xc[0]) {
        str = r ? toFixedPoint(alphabet.charAt(1), -dp, alphabet.charAt(0)) : alphabet.charAt(0);
      } else {
        xc.length = d;
        if (r) {
          for (--baseOut; ++xc[--d] > baseOut; ) {
            xc[d] = 0;
            if (!d) {
              ++e;
              xc = [1].concat(xc);
            }
          }
        }
        for (k = xc.length; !xc[--k]; ) ;
        for (i = 0, str = ""; i <= k; str += alphabet.charAt(xc[i++])) ;
        str = toFixedPoint(str, e, alphabet.charAt(0));
      }
      return str;
    };
  }();
  div = /* @__PURE__ */ function() {
    function multiply(x, k, base) {
      var m, temp, xlo, xhi, carry = 0, i = x.length, klo = k % SQRT_BASE, khi = k / SQRT_BASE | 0;
      for (x = x.slice(); i--; ) {
        xlo = x[i] % SQRT_BASE;
        xhi = x[i] / SQRT_BASE | 0;
        m = khi * xlo + xhi * klo;
        temp = klo * xlo + m % SQRT_BASE * SQRT_BASE + carry;
        carry = (temp / base | 0) + (m / SQRT_BASE | 0) + khi * xhi;
        x[i] = temp % base;
      }
      if (carry) x = [carry].concat(x);
      return x;
    }
    function compare2(a, b, aL, bL) {
      var i, cmp;
      if (aL != bL) {
        cmp = aL > bL ? 1 : -1;
      } else {
        for (i = cmp = 0; i < aL; i++) {
          if (a[i] != b[i]) {
            cmp = a[i] > b[i] ? 1 : -1;
            break;
          }
        }
      }
      return cmp;
    }
    function subtract(a, b, aL, base) {
      var i = 0;
      for (; aL--; ) {
        a[aL] -= i;
        i = a[aL] < b[aL] ? 1 : 0;
        a[aL] = i * base + a[aL] - b[aL];
      }
      for (; !a[0] && a.length > 1; a.splice(0, 1)) ;
    }
    return function(x, y, dp, rm, base) {
      var cmp, e, i, more, n, prod, prodL, q, qc, rem, remL, rem0, xi, xL, yc0, yL, yz, s = x.s == y.s ? 1 : -1, xc = x.c, yc = y.c;
      if (!xc || !xc[0] || !yc || !yc[0]) {
        return new BigNumber2(
          // Return NaN if either NaN, or both Infinity or 0.
          !x.s || !y.s || (xc ? yc && xc[0] == yc[0] : !yc) ? NaN : (
            // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
            xc && xc[0] == 0 || !yc ? s * 0 : s / 0
          )
        );
      }
      q = new BigNumber2(s);
      qc = q.c = [];
      e = x.e - y.e;
      s = dp + e + 1;
      if (!base) {
        base = BASE;
        e = bitFloor(x.e / LOG_BASE) - bitFloor(y.e / LOG_BASE);
        s = s / LOG_BASE | 0;
      }
      for (i = 0; yc[i] == (xc[i] || 0); i++) ;
      if (yc[i] > (xc[i] || 0)) e--;
      if (s < 0) {
        qc.push(1);
        more = true;
      } else {
        xL = xc.length;
        yL = yc.length;
        i = 0;
        s += 2;
        n = mathfloor(base / (yc[0] + 1));
        if (n > 1) {
          yc = multiply(yc, n, base);
          xc = multiply(xc, n, base);
          yL = yc.length;
          xL = xc.length;
        }
        xi = yL;
        rem = xc.slice(0, yL);
        remL = rem.length;
        for (; remL < yL; rem[remL++] = 0) ;
        yz = yc.slice();
        yz = [0].concat(yz);
        yc0 = yc[0];
        if (yc[1] >= base / 2) yc0++;
        do {
          n = 0;
          cmp = compare2(yc, rem, yL, remL);
          if (cmp < 0) {
            rem0 = rem[0];
            if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);
            n = mathfloor(rem0 / yc0);
            if (n > 1) {
              if (n >= base) n = base - 1;
              prod = multiply(yc, n, base);
              prodL = prod.length;
              remL = rem.length;
              while (compare2(prod, rem, prodL, remL) == 1) {
                n--;
                subtract(prod, yL < prodL ? yz : yc, prodL, base);
                prodL = prod.length;
                cmp = 1;
              }
            } else {
              if (n == 0) {
                cmp = n = 1;
              }
              prod = yc.slice();
              prodL = prod.length;
            }
            if (prodL < remL) prod = [0].concat(prod);
            subtract(rem, prod, remL, base);
            remL = rem.length;
            if (cmp == -1) {
              while (compare2(yc, rem, yL, remL) < 1) {
                n++;
                subtract(rem, yL < remL ? yz : yc, remL, base);
                remL = rem.length;
              }
            }
          } else if (cmp === 0) {
            n++;
            rem = [0];
          }
          qc[i++] = n;
          if (rem[0]) {
            rem[remL++] = xc[xi] || 0;
          } else {
            rem = [xc[xi]];
            remL = 1;
          }
        } while ((xi++ < xL || rem[0] != null) && s--);
        more = rem[0] != null;
        if (!qc[0]) qc.splice(0, 1);
      }
      if (base == BASE) {
        for (i = 1, s = qc[0]; s >= 10; s /= 10, i++) ;
        round(q, dp + (q.e = i + e * LOG_BASE - 1) + 1, rm, more);
      } else {
        q.e = e;
        q.r = +more;
      }
      return q;
    };
  }();
  function format(n, i, rm, id) {
    var c0, e, ne, len, str;
    if (rm == null) rm = ROUNDING_MODE;
    else intCheck(rm, 0, 8);
    if (!n.c) return n.toString();
    c0 = n.c[0];
    ne = n.e;
    if (i == null) {
      str = coeffToString(n.c);
      str = id == 1 || id == 2 && (ne <= TO_EXP_NEG || ne >= TO_EXP_POS) ? toExponential(str, ne) : toFixedPoint(str, ne, "0");
    } else {
      n = round(new BigNumber2(n), i, rm);
      e = n.e;
      str = coeffToString(n.c);
      len = str.length;
      if (id == 1 || id == 2 && (i <= e || e <= TO_EXP_NEG)) {
        for (; len < i; str += "0", len++) ;
        str = toExponential(str, e);
      } else {
        i -= ne;
        str = toFixedPoint(str, e, "0");
        if (e + 1 > len) {
          if (--i > 0) for (str += "."; i--; str += "0") ;
        } else {
          i += e - len;
          if (i > 0) {
            if (e + 1 == len) str += ".";
            for (; i--; str += "0") ;
          }
        }
      }
    }
    return n.s < 0 && c0 ? "-" + str : str;
  }
  function maxOrMin(args, n) {
    var k, y, i = 1, x = new BigNumber2(args[0]);
    for (; i < args.length; i++) {
      y = new BigNumber2(args[i]);
      if (!y.s || (k = compare(x, y)) === n || k === 0 && x.s === n) {
        x = y;
      }
    }
    return x;
  }
  function normalise(n, c, e) {
    var i = 1, j = c.length;
    for (; !c[--j]; c.pop()) ;
    for (j = c[0]; j >= 10; j /= 10, i++) ;
    if ((e = i + e * LOG_BASE - 1) > MAX_EXP) {
      n.c = n.e = null;
    } else if (e < MIN_EXP) {
      n.c = [n.e = 0];
    } else {
      n.e = e;
      n.c = c;
    }
    return n;
  }
  parseNumeric = /* @__PURE__ */ function() {
    var basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i, dotAfter = /^([^.]+)\.$/, dotBefore = /^\.([^.]+)$/, isInfinityOrNaN = /^-?(Infinity|NaN)$/, whitespaceOrPlus = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
    return function(x, str, isNum, b) {
      var base, s = isNum ? str : str.replace(whitespaceOrPlus, "");
      if (isInfinityOrNaN.test(s)) {
        x.s = isNaN(s) ? null : s < 0 ? -1 : 1;
      } else {
        if (!isNum) {
          s = s.replace(basePrefix, function(m, p1, p2) {
            base = (p2 = p2.toLowerCase()) == "x" ? 16 : p2 == "b" ? 2 : 8;
            return !b || b == base ? p1 : m;
          });
          if (b) {
            base = b;
            s = s.replace(dotAfter, "$1").replace(dotBefore, "0.$1");
          }
          if (str != s) return new BigNumber2(s, base);
        }
        if (BigNumber2.DEBUG) {
          throw Error(bignumberError + "Not a" + (b ? " base " + b : "") + " number: " + str);
        }
        x.s = null;
      }
      x.c = x.e = null;
    };
  }();
  function round(x, sd, rm, r) {
    var d, i, j, k, n, ni, rd, xc = x.c, pows10 = POWS_TEN;
    if (xc) {
      out: {
        for (d = 1, k = xc[0]; k >= 10; k /= 10, d++) ;
        i = sd - d;
        if (i < 0) {
          i += LOG_BASE;
          j = sd;
          n = xc[ni = 0];
          rd = mathfloor(n / pows10[d - j - 1] % 10);
        } else {
          ni = mathceil((i + 1) / LOG_BASE);
          if (ni >= xc.length) {
            if (r) {
              for (; xc.length <= ni; xc.push(0)) ;
              n = rd = 0;
              d = 1;
              i %= LOG_BASE;
              j = i - LOG_BASE + 1;
            } else {
              break out;
            }
          } else {
            n = k = xc[ni];
            for (d = 1; k >= 10; k /= 10, d++) ;
            i %= LOG_BASE;
            j = i - LOG_BASE + d;
            rd = j < 0 ? 0 : mathfloor(n / pows10[d - j - 1] % 10);
          }
        }
        r = r || sd < 0 || // Are there any non-zero digits after the rounding digit?
        // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
        // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
        xc[ni + 1] != null || (j < 0 ? n : n % pows10[d - j - 1]);
        r = rm < 4 ? (rd || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || r || rm == 6 && // Check whether the digit to the left of the rounding digit is odd.
        (i > 0 ? j > 0 ? n / pows10[d - j] : 0 : xc[ni - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
        if (sd < 1 || !xc[0]) {
          xc.length = 0;
          if (r) {
            sd -= x.e + 1;
            xc[0] = pows10[(LOG_BASE - sd % LOG_BASE) % LOG_BASE];
            x.e = -sd || 0;
          } else {
            xc[0] = x.e = 0;
          }
          return x;
        }
        if (i == 0) {
          xc.length = ni;
          k = 1;
          ni--;
        } else {
          xc.length = ni + 1;
          k = pows10[LOG_BASE - i];
          xc[ni] = j > 0 ? mathfloor(n / pows10[d - j] % pows10[j]) * k : 0;
        }
        if (r) {
          for (; ; ) {
            if (ni == 0) {
              for (i = 1, j = xc[0]; j >= 10; j /= 10, i++) ;
              j = xc[0] += k;
              for (k = 1; j >= 10; j /= 10, k++) ;
              if (i != k) {
                x.e++;
                if (xc[0] == BASE) xc[0] = 1;
              }
              break;
            } else {
              xc[ni] += k;
              if (xc[ni] != BASE) break;
              xc[ni--] = 0;
              k = 1;
            }
          }
        }
        for (i = xc.length; xc[--i] === 0; xc.pop()) ;
      }
      if (x.e > MAX_EXP) {
        x.c = x.e = null;
      } else if (x.e < MIN_EXP) {
        x.c = [x.e = 0];
      }
    }
    return x;
  }
  function valueOf(n) {
    var str, e = n.e;
    if (e === null) return n.toString();
    str = coeffToString(n.c);
    str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? toExponential(str, e) : toFixedPoint(str, e, "0");
    return n.s < 0 ? "-" + str : str;
  }
  P.absoluteValue = P.abs = function() {
    var x = new BigNumber2(this);
    if (x.s < 0) x.s = 1;
    return x;
  };
  P.comparedTo = function(y, b) {
    return compare(this, new BigNumber2(y, b));
  };
  P.decimalPlaces = P.dp = function(dp, rm) {
    var c, n, v2, x = this;
    if (dp != null) {
      intCheck(dp, 0, MAX);
      if (rm == null) rm = ROUNDING_MODE;
      else intCheck(rm, 0, 8);
      return round(new BigNumber2(x), dp + x.e + 1, rm);
    }
    if (!(c = x.c)) return null;
    n = ((v2 = c.length - 1) - bitFloor(this.e / LOG_BASE)) * LOG_BASE;
    if (v2 = c[v2]) for (; v2 % 10 == 0; v2 /= 10, n--) ;
    if (n < 0) n = 0;
    return n;
  };
  P.dividedBy = P.div = function(y, b) {
    return div(this, new BigNumber2(y, b), DECIMAL_PLACES, ROUNDING_MODE);
  };
  P.dividedToIntegerBy = P.idiv = function(y, b) {
    return div(this, new BigNumber2(y, b), 0, 1);
  };
  P.exponentiatedBy = P.pow = function(n, m) {
    var half, isModExp, i, k, more, nIsBig, nIsNeg, nIsOdd, y, x = this;
    n = new BigNumber2(n);
    if (n.c && !n.isInteger()) {
      throw Error(bignumberError + "Exponent not an integer: " + valueOf(n));
    }
    if (m != null) m = new BigNumber2(m);
    nIsBig = n.e > 14;
    if (!x.c || !x.c[0] || x.c[0] == 1 && !x.e && x.c.length == 1 || !n.c || !n.c[0]) {
      y = new BigNumber2(Math.pow(+valueOf(x), nIsBig ? n.s * (2 - isOdd(n)) : +valueOf(n)));
      return m ? y.mod(m) : y;
    }
    nIsNeg = n.s < 0;
    if (m) {
      if (m.c ? !m.c[0] : !m.s) return new BigNumber2(NaN);
      isModExp = !nIsNeg && x.isInteger() && m.isInteger();
      if (isModExp) x = x.mod(m);
    } else if (n.e > 9 && (x.e > 0 || x.e < -1 || (x.e == 0 ? x.c[0] > 1 || nIsBig && x.c[1] >= 24e7 : x.c[0] < 8e13 || nIsBig && x.c[0] <= 9999975e7))) {
      k = x.s < 0 && isOdd(n) ? -0 : 0;
      if (x.e > -1) k = 1 / k;
      return new BigNumber2(nIsNeg ? 1 / k : k);
    } else if (POW_PRECISION) {
      k = mathceil(POW_PRECISION / LOG_BASE + 2);
    }
    if (nIsBig) {
      half = new BigNumber2(0.5);
      if (nIsNeg) n.s = 1;
      nIsOdd = isOdd(n);
    } else {
      i = Math.abs(+valueOf(n));
      nIsOdd = i % 2;
    }
    y = new BigNumber2(ONE);
    for (; ; ) {
      if (nIsOdd) {
        y = y.times(x);
        if (!y.c) break;
        if (k) {
          if (y.c.length > k) y.c.length = k;
        } else if (isModExp) {
          y = y.mod(m);
        }
      }
      if (i) {
        i = mathfloor(i / 2);
        if (i === 0) break;
        nIsOdd = i % 2;
      } else {
        n = n.times(half);
        round(n, n.e + 1, 1);
        if (n.e > 14) {
          nIsOdd = isOdd(n);
        } else {
          i = +valueOf(n);
          if (i === 0) break;
          nIsOdd = i % 2;
        }
      }
      x = x.times(x);
      if (k) {
        if (x.c && x.c.length > k) x.c.length = k;
      } else if (isModExp) {
        x = x.mod(m);
      }
    }
    if (isModExp) return y;
    if (nIsNeg) y = ONE.div(y);
    return m ? y.mod(m) : k ? round(y, POW_PRECISION, ROUNDING_MODE, more) : y;
  };
  P.integerValue = function(rm) {
    var n = new BigNumber2(this);
    if (rm == null) rm = ROUNDING_MODE;
    else intCheck(rm, 0, 8);
    return round(n, n.e + 1, rm);
  };
  P.isEqualTo = P.eq = function(y, b) {
    return compare(this, new BigNumber2(y, b)) === 0;
  };
  P.isFinite = function() {
    return !!this.c;
  };
  P.isGreaterThan = P.gt = function(y, b) {
    return compare(this, new BigNumber2(y, b)) > 0;
  };
  P.isGreaterThanOrEqualTo = P.gte = function(y, b) {
    return (b = compare(this, new BigNumber2(y, b))) === 1 || b === 0;
  };
  P.isInteger = function() {
    return !!this.c && bitFloor(this.e / LOG_BASE) > this.c.length - 2;
  };
  P.isLessThan = P.lt = function(y, b) {
    return compare(this, new BigNumber2(y, b)) < 0;
  };
  P.isLessThanOrEqualTo = P.lte = function(y, b) {
    return (b = compare(this, new BigNumber2(y, b))) === -1 || b === 0;
  };
  P.isNaN = function() {
    return !this.s;
  };
  P.isNegative = function() {
    return this.s < 0;
  };
  P.isPositive = function() {
    return this.s > 0;
  };
  P.isZero = function() {
    return !!this.c && this.c[0] == 0;
  };
  P.minus = function(y, b) {
    var i, j, t, xLTy, x = this, a = x.s;
    y = new BigNumber2(y, b);
    b = y.s;
    if (!a || !b) return new BigNumber2(NaN);
    if (a != b) {
      y.s = -b;
      return x.plus(y);
    }
    var xe = x.e / LOG_BASE, ye = y.e / LOG_BASE, xc = x.c, yc = y.c;
    if (!xe || !ye) {
      if (!xc || !yc) return xc ? (y.s = -b, y) : new BigNumber2(yc ? x : NaN);
      if (!xc[0] || !yc[0]) {
        return yc[0] ? (y.s = -b, y) : new BigNumber2(xc[0] ? x : (
          // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
          ROUNDING_MODE == 3 ? -0 : 0
        ));
      }
    }
    xe = bitFloor(xe);
    ye = bitFloor(ye);
    xc = xc.slice();
    if (a = xe - ye) {
      if (xLTy = a < 0) {
        a = -a;
        t = xc;
      } else {
        ye = xe;
        t = yc;
      }
      t.reverse();
      for (b = a; b--; t.push(0)) ;
      t.reverse();
    } else {
      j = (xLTy = (a = xc.length) < (b = yc.length)) ? a : b;
      for (a = b = 0; b < j; b++) {
        if (xc[b] != yc[b]) {
          xLTy = xc[b] < yc[b];
          break;
        }
      }
    }
    if (xLTy) {
      t = xc;
      xc = yc;
      yc = t;
      y.s = -y.s;
    }
    b = (j = yc.length) - (i = xc.length);
    if (b > 0) for (; b--; xc[i++] = 0) ;
    b = BASE - 1;
    for (; j > a; ) {
      if (xc[--j] < yc[j]) {
        for (i = j; i && !xc[--i]; xc[i] = b) ;
        --xc[i];
        xc[j] += BASE;
      }
      xc[j] -= yc[j];
    }
    for (; xc[0] == 0; xc.splice(0, 1), --ye) ;
    if (!xc[0]) {
      y.s = ROUNDING_MODE == 3 ? -1 : 1;
      y.c = [y.e = 0];
      return y;
    }
    return normalise(y, xc, ye);
  };
  P.modulo = P.mod = function(y, b) {
    var q, s, x = this;
    y = new BigNumber2(y, b);
    if (!x.c || !y.s || y.c && !y.c[0]) {
      return new BigNumber2(NaN);
    } else if (!y.c || x.c && !x.c[0]) {
      return new BigNumber2(x);
    }
    if (MODULO_MODE == 9) {
      s = y.s;
      y.s = 1;
      q = div(x, y, 0, 3);
      y.s = s;
      q.s *= s;
    } else {
      q = div(x, y, 0, MODULO_MODE);
    }
    y = x.minus(q.times(y));
    if (!y.c[0] && MODULO_MODE == 1) y.s = x.s;
    return y;
  };
  P.multipliedBy = P.times = function(y, b) {
    var c, e, i, j, k, m, xcL, xlo, xhi, ycL, ylo, yhi, zc, base, sqrtBase, x = this, xc = x.c, yc = (y = new BigNumber2(y, b)).c;
    if (!xc || !yc || !xc[0] || !yc[0]) {
      if (!x.s || !y.s || xc && !xc[0] && !yc || yc && !yc[0] && !xc) {
        y.c = y.e = y.s = null;
      } else {
        y.s *= x.s;
        if (!xc || !yc) {
          y.c = y.e = null;
        } else {
          y.c = [0];
          y.e = 0;
        }
      }
      return y;
    }
    e = bitFloor(x.e / LOG_BASE) + bitFloor(y.e / LOG_BASE);
    y.s *= x.s;
    xcL = xc.length;
    ycL = yc.length;
    if (xcL < ycL) {
      zc = xc;
      xc = yc;
      yc = zc;
      i = xcL;
      xcL = ycL;
      ycL = i;
    }
    for (i = xcL + ycL, zc = []; i--; zc.push(0)) ;
    base = BASE;
    sqrtBase = SQRT_BASE;
    for (i = ycL; --i >= 0; ) {
      c = 0;
      ylo = yc[i] % sqrtBase;
      yhi = yc[i] / sqrtBase | 0;
      for (k = xcL, j = i + k; j > i; ) {
        xlo = xc[--k] % sqrtBase;
        xhi = xc[k] / sqrtBase | 0;
        m = yhi * xlo + xhi * ylo;
        xlo = ylo * xlo + m % sqrtBase * sqrtBase + zc[j] + c;
        c = (xlo / base | 0) + (m / sqrtBase | 0) + yhi * xhi;
        zc[j--] = xlo % base;
      }
      zc[j] = c;
    }
    if (c) {
      ++e;
    } else {
      zc.splice(0, 1);
    }
    return normalise(y, zc, e);
  };
  P.negated = function() {
    var x = new BigNumber2(this);
    x.s = -x.s || null;
    return x;
  };
  P.plus = function(y, b) {
    var t, x = this, a = x.s;
    y = new BigNumber2(y, b);
    b = y.s;
    if (!a || !b) return new BigNumber2(NaN);
    if (a != b) {
      y.s = -b;
      return x.minus(y);
    }
    var xe = x.e / LOG_BASE, ye = y.e / LOG_BASE, xc = x.c, yc = y.c;
    if (!xe || !ye) {
      if (!xc || !yc) return new BigNumber2(a / 0);
      if (!xc[0] || !yc[0]) return yc[0] ? y : new BigNumber2(xc[0] ? x : a * 0);
    }
    xe = bitFloor(xe);
    ye = bitFloor(ye);
    xc = xc.slice();
    if (a = xe - ye) {
      if (a > 0) {
        ye = xe;
        t = yc;
      } else {
        a = -a;
        t = xc;
      }
      t.reverse();
      for (; a--; t.push(0)) ;
      t.reverse();
    }
    a = xc.length;
    b = yc.length;
    if (a - b < 0) {
      t = yc;
      yc = xc;
      xc = t;
      b = a;
    }
    for (a = 0; b; ) {
      a = (xc[--b] = xc[b] + yc[b] + a) / BASE | 0;
      xc[b] = BASE === xc[b] ? 0 : xc[b] % BASE;
    }
    if (a) {
      xc = [a].concat(xc);
      ++ye;
    }
    return normalise(y, xc, ye);
  };
  P.precision = P.sd = function(sd, rm) {
    var c, n, v2, x = this;
    if (sd != null && sd !== !!sd) {
      intCheck(sd, 1, MAX);
      if (rm == null) rm = ROUNDING_MODE;
      else intCheck(rm, 0, 8);
      return round(new BigNumber2(x), sd, rm);
    }
    if (!(c = x.c)) return null;
    v2 = c.length - 1;
    n = v2 * LOG_BASE + 1;
    if (v2 = c[v2]) {
      for (; v2 % 10 == 0; v2 /= 10, n--) ;
      for (v2 = c[0]; v2 >= 10; v2 /= 10, n++) ;
    }
    if (sd && x.e + 1 > n) n = x.e + 1;
    return n;
  };
  P.shiftedBy = function(k) {
    intCheck(k, -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER);
    return this.times("1e" + k);
  };
  P.squareRoot = P.sqrt = function() {
    var m, n, r, rep, t, x = this, c = x.c, s = x.s, e = x.e, dp = DECIMAL_PLACES + 4, half = new BigNumber2("0.5");
    if (s !== 1 || !c || !c[0]) {
      return new BigNumber2(!s || s < 0 && (!c || c[0]) ? NaN : c ? x : 1 / 0);
    }
    s = Math.sqrt(+valueOf(x));
    if (s == 0 || s == 1 / 0) {
      n = coeffToString(c);
      if ((n.length + e) % 2 == 0) n += "0";
      s = Math.sqrt(+n);
      e = bitFloor((e + 1) / 2) - (e < 0 || e % 2);
      if (s == 1 / 0) {
        n = "5e" + e;
      } else {
        n = s.toExponential();
        n = n.slice(0, n.indexOf("e") + 1) + e;
      }
      r = new BigNumber2(n);
    } else {
      r = new BigNumber2(s + "");
    }
    if (r.c[0]) {
      e = r.e;
      s = e + dp;
      if (s < 3) s = 0;
      for (; ; ) {
        t = r;
        r = half.times(t.plus(div(x, t, dp, 1)));
        if (coeffToString(t.c).slice(0, s) === (n = coeffToString(r.c)).slice(0, s)) {
          if (r.e < e) --s;
          n = n.slice(s - 3, s + 1);
          if (n == "9999" || !rep && n == "4999") {
            if (!rep) {
              round(t, t.e + DECIMAL_PLACES + 2, 0);
              if (t.times(t).eq(x)) {
                r = t;
                break;
              }
            }
            dp += 4;
            s += 4;
            rep = 1;
          } else {
            if (!+n || !+n.slice(1) && n.charAt(0) == "5") {
              round(r, r.e + DECIMAL_PLACES + 2, 1);
              m = !r.times(r).eq(x);
            }
            break;
          }
        }
      }
    }
    return round(r, r.e + DECIMAL_PLACES + 1, ROUNDING_MODE, m);
  };
  P.toExponential = function(dp, rm) {
    if (dp != null) {
      intCheck(dp, 0, MAX);
      dp++;
    }
    return format(this, dp, rm, 1);
  };
  P.toFixed = function(dp, rm) {
    if (dp != null) {
      intCheck(dp, 0, MAX);
      dp = dp + this.e + 1;
    }
    return format(this, dp, rm);
  };
  P.toFormat = function(dp, rm, format2) {
    var str, x = this;
    if (format2 == null) {
      if (dp != null && rm && typeof rm == "object") {
        format2 = rm;
        rm = null;
      } else if (dp && typeof dp == "object") {
        format2 = dp;
        dp = rm = null;
      } else {
        format2 = FORMAT;
      }
    } else if (typeof format2 != "object") {
      throw Error(bignumberError + "Argument not an object: " + format2);
    }
    str = x.toFixed(dp, rm);
    if (x.c) {
      var i, arr = str.split("."), g1 = +format2.groupSize, g2 = +format2.secondaryGroupSize, groupSeparator = format2.groupSeparator || "", intPart = arr[0], fractionPart = arr[1], isNeg = x.s < 0, intDigits = isNeg ? intPart.slice(1) : intPart, len = intDigits.length;
      if (g2) {
        i = g1;
        g1 = g2;
        g2 = i;
        len -= i;
      }
      if (g1 > 0 && len > 0) {
        i = len % g1 || g1;
        intPart = intDigits.substr(0, i);
        for (; i < len; i += g1) intPart += groupSeparator + intDigits.substr(i, g1);
        if (g2 > 0) intPart += groupSeparator + intDigits.slice(i);
        if (isNeg) intPart = "-" + intPart;
      }
      str = fractionPart ? intPart + (format2.decimalSeparator || "") + ((g2 = +format2.fractionGroupSize) ? fractionPart.replace(
        new RegExp("\\d{" + g2 + "}\\B", "g"),
        "$&" + (format2.fractionGroupSeparator || "")
      ) : fractionPart) : intPart;
    }
    return (format2.prefix || "") + str + (format2.suffix || "");
  };
  P.toFraction = function(md) {
    var d, d0, d1, d2, e, exp, n, n0, n1, q, r, s, x = this, xc = x.c;
    if (md != null) {
      n = new BigNumber2(md);
      if (!n.isInteger() && (n.c || n.s !== 1) || n.lt(ONE)) {
        throw Error(bignumberError + "Argument " + (n.isInteger() ? "out of range: " : "not an integer: ") + valueOf(n));
      }
    }
    if (!xc) return new BigNumber2(x);
    d = new BigNumber2(ONE);
    n1 = d0 = new BigNumber2(ONE);
    d1 = n0 = new BigNumber2(ONE);
    s = coeffToString(xc);
    e = d.e = s.length - x.e - 1;
    d.c[0] = POWS_TEN[(exp = e % LOG_BASE) < 0 ? LOG_BASE + exp : exp];
    md = !md || n.comparedTo(d) > 0 ? e > 0 ? d : n1 : n;
    exp = MAX_EXP;
    MAX_EXP = 1 / 0;
    n = new BigNumber2(s);
    n0.c[0] = 0;
    for (; ; ) {
      q = div(n, d, 0, 1);
      d2 = d0.plus(q.times(d1));
      if (d2.comparedTo(md) == 1) break;
      d0 = d1;
      d1 = d2;
      n1 = n0.plus(q.times(d2 = n1));
      n0 = d2;
      d = n.minus(q.times(d2 = d));
      n = d2;
    }
    d2 = div(md.minus(d0), d1, 0, 1);
    n0 = n0.plus(d2.times(n1));
    d0 = d0.plus(d2.times(d1));
    n0.s = n1.s = x.s;
    e = e * 2;
    r = div(n1, d1, e, ROUNDING_MODE).minus(x).abs().comparedTo(
      div(n0, d0, e, ROUNDING_MODE).minus(x).abs()
    ) < 1 ? [n1, d1] : [n0, d0];
    MAX_EXP = exp;
    return r;
  };
  P.toNumber = function() {
    return +valueOf(this);
  };
  P.toPrecision = function(sd, rm) {
    if (sd != null) intCheck(sd, 1, MAX);
    return format(this, sd, rm, 2);
  };
  P.toString = function(b) {
    var str, n = this, s = n.s, e = n.e;
    if (e === null) {
      if (s) {
        str = "Infinity";
        if (s < 0) str = "-" + str;
      } else {
        str = "NaN";
      }
    } else {
      if (b == null) {
        str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? toExponential(coeffToString(n.c), e) : toFixedPoint(coeffToString(n.c), e, "0");
      } else if (b === 10 && alphabetHasNormalDecimalDigits) {
        n = round(new BigNumber2(n), DECIMAL_PLACES + e + 1, ROUNDING_MODE);
        str = toFixedPoint(coeffToString(n.c), n.e, "0");
      } else {
        intCheck(b, 2, ALPHABET.length, "Base");
        str = convertBase(toFixedPoint(coeffToString(n.c), e, "0"), 10, b, s, true);
      }
      if (s < 0 && n.c[0]) str = "-" + str;
    }
    return str;
  };
  P.valueOf = P.toJSON = function() {
    return valueOf(this);
  };
  P._isBigNumber = true;
  P[Symbol.toStringTag] = "BigNumber";
  P[Symbol.for("nodejs.util.inspect.custom")] = P.valueOf;
  if (configObject != null) BigNumber2.set(configObject);
  return BigNumber2;
}
function bitFloor(n) {
  var i = n | 0;
  return n > 0 || n === i ? i : i - 1;
}
function coeffToString(a) {
  var s, z, i = 1, j = a.length, r = a[0] + "";
  for (; i < j; ) {
    s = a[i++] + "";
    z = LOG_BASE - s.length;
    for (; z--; s = "0" + s) ;
    r += s;
  }
  for (j = r.length; r.charCodeAt(--j) === 48; ) ;
  return r.slice(0, j + 1 || 1);
}
function compare(x, y) {
  var a, b, xc = x.c, yc = y.c, i = x.s, j = y.s, k = x.e, l = y.e;
  if (!i || !j) return null;
  a = xc && !xc[0];
  b = yc && !yc[0];
  if (a || b) return a ? b ? 0 : -j : i;
  if (i != j) return i;
  a = i < 0;
  b = k == l;
  if (!xc || !yc) return b ? 0 : !xc ^ a ? 1 : -1;
  if (!b) return k > l ^ a ? 1 : -1;
  j = (k = xc.length) < (l = yc.length) ? k : l;
  for (i = 0; i < j; i++) if (xc[i] != yc[i]) return xc[i] > yc[i] ^ a ? 1 : -1;
  return k == l ? 0 : k > l ^ a ? 1 : -1;
}
function intCheck(n, min2, max2, name) {
  if (n < min2 || n > max2 || n !== mathfloor(n)) {
    throw Error(bignumberError + (name || "Argument") + (typeof n == "number" ? n < min2 || n > max2 ? " out of range: " : " not an integer: " : " not a primitive number: ") + String(n));
  }
}
function isOdd(n) {
  var k = n.c.length - 1;
  return bitFloor(n.e / LOG_BASE) == k && n.c[k] % 2 != 0;
}
function toExponential(str, e) {
  return (str.length > 1 ? str.charAt(0) + "." + str.slice(1) : str) + (e < 0 ? "e" : "e+") + e;
}
function toFixedPoint(str, e, z) {
  var len, zs;
  if (e < 0) {
    for (zs = z + "."; ++e; zs += z) ;
    str = zs + str;
  } else {
    len = str.length;
    if (++e > len) {
      for (zs = z, e -= len; --e; zs += z) ;
      str += zs;
    } else if (e < len) {
      str = str.slice(0, e) + "." + str.slice(e);
    }
  }
  return str;
}
var BigNumber = clone2();
var bignumber_default = BigNumber;

// node_modules/splaytree-ts/dist/esm/index.js
init_cjs_shims();
var SplayTreeNode = class {
  constructor(key) {
    __publicField(this, "key");
    __publicField(this, "left", null);
    __publicField(this, "right", null);
    this.key = key;
  }
};
var SplayTreeSetNode = class extends SplayTreeNode {
  constructor(key) {
    super(key);
  }
};
var SplayTree = class {
  constructor() {
    __publicField(this, "size", 0);
    __publicField(this, "modificationCount", 0);
    __publicField(this, "splayCount", 0);
  }
  splay(key) {
    const root = this.root;
    if (root == null) {
      this.compare(key, key);
      return -1;
    }
    let right = null;
    let newTreeRight = null;
    let left = null;
    let newTreeLeft = null;
    let current = root;
    const compare2 = this.compare;
    let comp;
    while (true) {
      comp = compare2(current.key, key);
      if (comp > 0) {
        let currentLeft = current.left;
        if (currentLeft == null) break;
        comp = compare2(currentLeft.key, key);
        if (comp > 0) {
          current.left = currentLeft.right;
          currentLeft.right = current;
          current = currentLeft;
          currentLeft = current.left;
          if (currentLeft == null) break;
        }
        if (right == null) {
          newTreeRight = current;
        } else {
          right.left = current;
        }
        right = current;
        current = currentLeft;
      } else if (comp < 0) {
        let currentRight = current.right;
        if (currentRight == null) break;
        comp = compare2(currentRight.key, key);
        if (comp < 0) {
          current.right = currentRight.left;
          currentRight.left = current;
          current = currentRight;
          currentRight = current.right;
          if (currentRight == null) break;
        }
        if (left == null) {
          newTreeLeft = current;
        } else {
          left.right = current;
        }
        left = current;
        current = currentRight;
      } else {
        break;
      }
    }
    if (left != null) {
      left.right = current.left;
      current.left = newTreeLeft;
    }
    if (right != null) {
      right.left = current.right;
      current.right = newTreeRight;
    }
    if (this.root !== current) {
      this.root = current;
      this.splayCount++;
    }
    return comp;
  }
  splayMin(node) {
    let current = node;
    let nextLeft = current.left;
    while (nextLeft != null) {
      const left = nextLeft;
      current.left = left.right;
      left.right = current;
      current = left;
      nextLeft = current.left;
    }
    return current;
  }
  splayMax(node) {
    let current = node;
    let nextRight = current.right;
    while (nextRight != null) {
      const right = nextRight;
      current.right = right.left;
      right.left = current;
      current = right;
      nextRight = current.right;
    }
    return current;
  }
  _delete(key) {
    if (this.root == null) return null;
    const comp = this.splay(key);
    if (comp != 0) return null;
    let root = this.root;
    const result = root;
    const left = root.left;
    this.size--;
    if (left == null) {
      this.root = root.right;
    } else {
      const right = root.right;
      root = this.splayMax(left);
      root.right = right;
      this.root = root;
    }
    this.modificationCount++;
    return result;
  }
  addNewRoot(node, comp) {
    this.size++;
    this.modificationCount++;
    const root = this.root;
    if (root == null) {
      this.root = node;
      return;
    }
    if (comp < 0) {
      node.left = root;
      node.right = root.right;
      root.right = null;
    } else {
      node.right = root;
      node.left = root.left;
      root.left = null;
    }
    this.root = node;
  }
  _first() {
    const root = this.root;
    if (root == null) return null;
    this.root = this.splayMin(root);
    return this.root;
  }
  _last() {
    const root = this.root;
    if (root == null) return null;
    this.root = this.splayMax(root);
    return this.root;
  }
  clear() {
    this.root = null;
    this.size = 0;
    this.modificationCount++;
  }
  has(key) {
    return this.validKey(key) && this.splay(key) == 0;
  }
  defaultCompare() {
    return (a, b) => a < b ? -1 : a > b ? 1 : 0;
  }
  wrap() {
    return {
      getRoot: () => {
        return this.root;
      },
      setRoot: (root) => {
        this.root = root;
      },
      getSize: () => {
        return this.size;
      },
      getModificationCount: () => {
        return this.modificationCount;
      },
      getSplayCount: () => {
        return this.splayCount;
      },
      setSplayCount: (count) => {
        this.splayCount = count;
      },
      splay: (key) => {
        return this.splay(key);
      },
      has: (key) => {
        return this.has(key);
      }
    };
  }
};
var _a, _b;
var SplayTreeSet = class _SplayTreeSet extends SplayTree {
  constructor(compare2, isValidKey) {
    super();
    __publicField(this, "root", null);
    __publicField(this, "compare");
    __publicField(this, "validKey");
    __publicField(this, _a, "[object Set]");
    this.compare = compare2 ?? this.defaultCompare();
    this.validKey = isValidKey ?? ((v2) => v2 != null && v2 != void 0);
  }
  delete(element) {
    if (!this.validKey(element)) return false;
    return this._delete(element) != null;
  }
  deleteAll(elements) {
    for (const element of elements) {
      this.delete(element);
    }
  }
  forEach(f) {
    const nodes = this[Symbol.iterator]();
    let result;
    while (result = nodes.next(), !result.done) {
      f(result.value, result.value, this);
    }
  }
  add(element) {
    const compare2 = this.splay(element);
    if (compare2 != 0) this.addNewRoot(new SplayTreeSetNode(element), compare2);
    return this;
  }
  addAndReturn(element) {
    const compare2 = this.splay(element);
    if (compare2 != 0) this.addNewRoot(new SplayTreeSetNode(element), compare2);
    return this.root.key;
  }
  addAll(elements) {
    for (const element of elements) {
      this.add(element);
    }
  }
  isEmpty() {
    return this.root == null;
  }
  isNotEmpty() {
    return this.root != null;
  }
  single() {
    if (this.size == 0) throw "Bad state: No element";
    if (this.size > 1) throw "Bad state: Too many element";
    return this.root.key;
  }
  first() {
    if (this.size == 0) throw "Bad state: No element";
    return this._first().key;
  }
  last() {
    if (this.size == 0) throw "Bad state: No element";
    return this._last().key;
  }
  lastBefore(element) {
    if (element == null) throw "Invalid arguments(s)";
    if (this.root == null) return null;
    const comp = this.splay(element);
    if (comp < 0) return this.root.key;
    let node = this.root.left;
    if (node == null) return null;
    let nodeRight = node.right;
    while (nodeRight != null) {
      node = nodeRight;
      nodeRight = node.right;
    }
    return node.key;
  }
  firstAfter(element) {
    if (element == null) throw "Invalid arguments(s)";
    if (this.root == null) return null;
    const comp = this.splay(element);
    if (comp > 0) return this.root.key;
    let node = this.root.right;
    if (node == null) return null;
    let nodeLeft = node.left;
    while (nodeLeft != null) {
      node = nodeLeft;
      nodeLeft = node.left;
    }
    return node.key;
  }
  retainAll(elements) {
    const retainSet = new _SplayTreeSet(this.compare, this.validKey);
    const modificationCount = this.modificationCount;
    for (const object of elements) {
      if (modificationCount != this.modificationCount) {
        throw "Concurrent modification during iteration.";
      }
      if (this.validKey(object) && this.splay(object) == 0) {
        retainSet.add(this.root.key);
      }
    }
    if (retainSet.size != this.size) {
      this.root = retainSet.root;
      this.size = retainSet.size;
      this.modificationCount++;
    }
  }
  lookup(object) {
    if (!this.validKey(object)) return null;
    const comp = this.splay(object);
    if (comp != 0) return null;
    return this.root.key;
  }
  intersection(other) {
    const result = new _SplayTreeSet(this.compare, this.validKey);
    for (const element of this) {
      if (other.has(element)) result.add(element);
    }
    return result;
  }
  difference(other) {
    const result = new _SplayTreeSet(this.compare, this.validKey);
    for (const element of this) {
      if (!other.has(element)) result.add(element);
    }
    return result;
  }
  union(other) {
    const u4 = this.clone();
    u4.addAll(other);
    return u4;
  }
  clone() {
    const set2 = new _SplayTreeSet(this.compare, this.validKey);
    set2.size = this.size;
    set2.root = this.copyNode(this.root);
    return set2;
  }
  copyNode(node) {
    if (node == null) return null;
    function copyChildren(node2, dest) {
      let left;
      let right;
      do {
        left = node2.left;
        right = node2.right;
        if (left != null) {
          const newLeft = new SplayTreeSetNode(left.key);
          dest.left = newLeft;
          copyChildren(left, newLeft);
        }
        if (right != null) {
          const newRight = new SplayTreeSetNode(right.key);
          dest.right = newRight;
          node2 = right;
          dest = newRight;
        }
      } while (right != null);
    }
    const result = new SplayTreeSetNode(node.key);
    copyChildren(node, result);
    return result;
  }
  toSet() {
    return this.clone();
  }
  entries() {
    return new SplayTreeSetEntryIterableIterator(this.wrap());
  }
  keys() {
    return this[Symbol.iterator]();
  }
  values() {
    return this[Symbol.iterator]();
  }
  [(_b = Symbol.iterator, _a = Symbol.toStringTag, _b)]() {
    return new SplayTreeKeyIterableIterator(this.wrap());
  }
};
var SplayTreeIterableIterator = class {
  constructor(tree) {
    __publicField(this, "tree");
    __publicField(this, "path", new Array());
    __publicField(this, "modificationCount", null);
    __publicField(this, "splayCount");
    this.tree = tree;
    this.splayCount = tree.getSplayCount();
  }
  [Symbol.iterator]() {
    return this;
  }
  next() {
    if (this.moveNext()) return { done: false, value: this.current() };
    return { done: true, value: null };
  }
  current() {
    if (!this.path.length) return null;
    const node = this.path[this.path.length - 1];
    return this.getValue(node);
  }
  rebuildPath(key) {
    this.path.splice(0, this.path.length);
    this.tree.splay(key);
    this.path.push(this.tree.getRoot());
    this.splayCount = this.tree.getSplayCount();
  }
  findLeftMostDescendent(node) {
    while (node != null) {
      this.path.push(node);
      node = node.left;
    }
  }
  moveNext() {
    if (this.modificationCount != this.tree.getModificationCount()) {
      if (this.modificationCount == null) {
        this.modificationCount = this.tree.getModificationCount();
        let node2 = this.tree.getRoot();
        while (node2 != null) {
          this.path.push(node2);
          node2 = node2.left;
        }
        return this.path.length > 0;
      }
      throw "Concurrent modification during iteration.";
    }
    if (!this.path.length) return false;
    if (this.splayCount != this.tree.getSplayCount()) {
      this.rebuildPath(this.path[this.path.length - 1].key);
    }
    let node = this.path[this.path.length - 1];
    let next = node.right;
    if (next != null) {
      while (next != null) {
        this.path.push(next);
        next = next.left;
      }
      return true;
    }
    this.path.pop();
    while (this.path.length && this.path[this.path.length - 1].right === node) {
      node = this.path.pop();
    }
    return this.path.length > 0;
  }
};
var SplayTreeKeyIterableIterator = class extends SplayTreeIterableIterator {
  getValue(node) {
    return node.key;
  }
};
var SplayTreeSetEntryIterableIterator = class extends SplayTreeIterableIterator {
  getValue(node) {
    return [node.key, node.key];
  }
};

// node_modules/polyclip-ts/dist/esm/index.js
var constant_default = (x) => {
  return () => {
    return x;
  };
};
var compare_default = (eps) => {
  const almostEqual = eps ? (a, b) => b.minus(a).abs().isLessThanOrEqualTo(eps) : constant_default(false);
  return (a, b) => {
    if (almostEqual(a, b)) return 0;
    return a.comparedTo(b);
  };
};
function orient_default(eps) {
  const almostCollinear = eps ? (area2, ax, ay, cx, cy) => area2.exponentiatedBy(2).isLessThanOrEqualTo(
    cx.minus(ax).exponentiatedBy(2).plus(cy.minus(ay).exponentiatedBy(2)).times(eps)
  ) : constant_default(false);
  return (a, b, c) => {
    const ax = a.x, ay = a.y, cx = c.x, cy = c.y;
    const area2 = ay.minus(cy).times(b.x.minus(cx)).minus(ax.minus(cx).times(b.y.minus(cy)));
    if (almostCollinear(area2, ax, ay, cx, cy)) return 0;
    return area2.comparedTo(0);
  };
}
var identity_default = (x) => {
  return x;
};
var snap_default = (eps) => {
  if (eps) {
    const xTree = new SplayTreeSet(compare_default(eps));
    const yTree = new SplayTreeSet(compare_default(eps));
    const snapCoord = (coord, tree) => {
      return tree.addAndReturn(coord);
    };
    const snap = (v2) => {
      return {
        x: snapCoord(v2.x, xTree),
        y: snapCoord(v2.y, yTree)
      };
    };
    snap({ x: new bignumber_default(0), y: new bignumber_default(0) });
    return snap;
  }
  return identity_default;
};
var set = (eps) => {
  return {
    set: (eps2) => {
      precision = set(eps2);
    },
    reset: () => set(eps),
    compare: compare_default(eps),
    snap: snap_default(eps),
    orient: orient_default(eps)
  };
};
var precision = set();
var isInBbox = (bbox2, point2) => {
  return bbox2.ll.x.isLessThanOrEqualTo(point2.x) && point2.x.isLessThanOrEqualTo(bbox2.ur.x) && bbox2.ll.y.isLessThanOrEqualTo(point2.y) && point2.y.isLessThanOrEqualTo(bbox2.ur.y);
};
var getBboxOverlap = (b1, b2) => {
  if (b2.ur.x.isLessThan(b1.ll.x) || b1.ur.x.isLessThan(b2.ll.x) || b2.ur.y.isLessThan(b1.ll.y) || b1.ur.y.isLessThan(b2.ll.y))
    return null;
  const lowerX = b1.ll.x.isLessThan(b2.ll.x) ? b2.ll.x : b1.ll.x;
  const upperX = b1.ur.x.isLessThan(b2.ur.x) ? b1.ur.x : b2.ur.x;
  const lowerY = b1.ll.y.isLessThan(b2.ll.y) ? b2.ll.y : b1.ll.y;
  const upperY = b1.ur.y.isLessThan(b2.ur.y) ? b1.ur.y : b2.ur.y;
  return { ll: { x: lowerX, y: lowerY }, ur: { x: upperX, y: upperY } };
};
var crossProduct = (a, b) => a.x.times(b.y).minus(a.y.times(b.x));
var dotProduct = (a, b) => a.x.times(b.x).plus(a.y.times(b.y));
var length = (v2) => dotProduct(v2, v2).sqrt();
var sineOfAngle = (pShared, pBase, pAngle) => {
  const vBase = { x: pBase.x.minus(pShared.x), y: pBase.y.minus(pShared.y) };
  const vAngle = { x: pAngle.x.minus(pShared.x), y: pAngle.y.minus(pShared.y) };
  return crossProduct(vAngle, vBase).div(length(vAngle)).div(length(vBase));
};
var cosineOfAngle = (pShared, pBase, pAngle) => {
  const vBase = { x: pBase.x.minus(pShared.x), y: pBase.y.minus(pShared.y) };
  const vAngle = { x: pAngle.x.minus(pShared.x), y: pAngle.y.minus(pShared.y) };
  return dotProduct(vAngle, vBase).div(length(vAngle)).div(length(vBase));
};
var horizontalIntersection = (pt, v2, y) => {
  if (v2.y.isZero()) return null;
  return { x: pt.x.plus(v2.x.div(v2.y).times(y.minus(pt.y))), y };
};
var verticalIntersection = (pt, v2, x) => {
  if (v2.x.isZero()) return null;
  return { x, y: pt.y.plus(v2.y.div(v2.x).times(x.minus(pt.x))) };
};
var intersection = (pt1, v1, pt2, v2) => {
  if (v1.x.isZero()) return verticalIntersection(pt2, v2, pt1.x);
  if (v2.x.isZero()) return verticalIntersection(pt1, v1, pt2.x);
  if (v1.y.isZero()) return horizontalIntersection(pt2, v2, pt1.y);
  if (v2.y.isZero()) return horizontalIntersection(pt1, v1, pt2.y);
  const kross = crossProduct(v1, v2);
  if (kross.isZero()) return null;
  const ve = { x: pt2.x.minus(pt1.x), y: pt2.y.minus(pt1.y) };
  const d1 = crossProduct(ve, v1).div(kross);
  const d2 = crossProduct(ve, v2).div(kross);
  const x1 = pt1.x.plus(d2.times(v1.x)), x2 = pt2.x.plus(d1.times(v2.x));
  const y1 = pt1.y.plus(d2.times(v1.y)), y2 = pt2.y.plus(d1.times(v2.y));
  const x = x1.plus(x2).div(2);
  const y = y1.plus(y2).div(2);
  return { x, y };
};
var SweepEvent = class _SweepEvent {
  // Warning: 'point' input will be modified and re-used (for performance)
  constructor(point2, isLeft) {
    __publicField(this, "point");
    __publicField(this, "isLeft");
    __publicField(this, "segment");
    __publicField(this, "otherSE");
    __publicField(this, "consumedBy");
    if (point2.events === void 0) point2.events = [this];
    else point2.events.push(this);
    this.point = point2;
    this.isLeft = isLeft;
  }
  // for ordering sweep events in the sweep event queue
  static compare(a, b) {
    const ptCmp = _SweepEvent.comparePoints(a.point, b.point);
    if (ptCmp !== 0) return ptCmp;
    if (a.point !== b.point) a.link(b);
    if (a.isLeft !== b.isLeft) return a.isLeft ? 1 : -1;
    return Segment2.compare(a.segment, b.segment);
  }
  // for ordering points in sweep line order
  static comparePoints(aPt, bPt) {
    if (aPt.x.isLessThan(bPt.x)) return -1;
    if (aPt.x.isGreaterThan(bPt.x)) return 1;
    if (aPt.y.isLessThan(bPt.y)) return -1;
    if (aPt.y.isGreaterThan(bPt.y)) return 1;
    return 0;
  }
  link(other) {
    if (other.point === this.point) {
      throw new Error("Tried to link already linked events");
    }
    const otherEvents = other.point.events;
    for (let i = 0, iMax = otherEvents.length; i < iMax; i++) {
      const evt = otherEvents[i];
      this.point.events.push(evt);
      evt.point = this.point;
    }
    this.checkForConsuming();
  }
  /* Do a pass over our linked events and check to see if any pair
   * of segments match, and should be consumed. */
  checkForConsuming() {
    const numEvents = this.point.events.length;
    for (let i = 0; i < numEvents; i++) {
      const evt1 = this.point.events[i];
      if (evt1.segment.consumedBy !== void 0) continue;
      for (let j = i + 1; j < numEvents; j++) {
        const evt2 = this.point.events[j];
        if (evt2.consumedBy !== void 0) continue;
        if (evt1.otherSE.point.events !== evt2.otherSE.point.events) continue;
        evt1.segment.consume(evt2.segment);
      }
    }
  }
  getAvailableLinkedEvents() {
    const events = [];
    for (let i = 0, iMax = this.point.events.length; i < iMax; i++) {
      const evt = this.point.events[i];
      if (evt !== this && !evt.segment.ringOut && evt.segment.isInResult()) {
        events.push(evt);
      }
    }
    return events;
  }
  /**
   * Returns a comparator function for sorting linked events that will
   * favor the event that will give us the smallest left-side angle.
   * All ring construction starts as low as possible heading to the right,
   * so by always turning left as sharp as possible we'll get polygons
   * without uncessary loops & holes.
   *
   * The comparator function has a compute cache such that it avoids
   * re-computing already-computed values.
   */
  getLeftmostComparator(baseEvent) {
    const cache = /* @__PURE__ */ new Map();
    const fillCache = (linkedEvent) => {
      const nextEvent = linkedEvent.otherSE;
      cache.set(linkedEvent, {
        sine: sineOfAngle(this.point, baseEvent.point, nextEvent.point),
        cosine: cosineOfAngle(this.point, baseEvent.point, nextEvent.point)
      });
    };
    return (a, b) => {
      if (!cache.has(a)) fillCache(a);
      if (!cache.has(b)) fillCache(b);
      const { sine: asine, cosine: acosine } = cache.get(a);
      const { sine: bsine, cosine: bcosine } = cache.get(b);
      if (asine.isGreaterThanOrEqualTo(0) && bsine.isGreaterThanOrEqualTo(0)) {
        if (acosine.isLessThan(bcosine)) return 1;
        if (acosine.isGreaterThan(bcosine)) return -1;
        return 0;
      }
      if (asine.isLessThan(0) && bsine.isLessThan(0)) {
        if (acosine.isLessThan(bcosine)) return -1;
        if (acosine.isGreaterThan(bcosine)) return 1;
        return 0;
      }
      if (bsine.isLessThan(asine)) return -1;
      if (bsine.isGreaterThan(asine)) return 1;
      return 0;
    };
  }
};
var RingOut = class _RingOut {
  constructor(events) {
    __publicField(this, "events");
    __publicField(this, "poly");
    __publicField(this, "_isExteriorRing");
    __publicField(this, "_enclosingRing");
    this.events = events;
    for (let i = 0, iMax = events.length; i < iMax; i++) {
      events[i].segment.ringOut = this;
    }
    this.poly = null;
  }
  /* Given the segments from the sweep line pass, compute & return a series
   * of closed rings from all the segments marked to be part of the result */
  static factory(allSegments) {
    const ringsOut = [];
    for (let i = 0, iMax = allSegments.length; i < iMax; i++) {
      const segment = allSegments[i];
      if (!segment.isInResult() || segment.ringOut) continue;
      let prevEvent = null;
      let event = segment.leftSE;
      let nextEvent = segment.rightSE;
      const events = [event];
      const startingPoint = event.point;
      const intersectionLEs = [];
      while (true) {
        prevEvent = event;
        event = nextEvent;
        events.push(event);
        if (event.point === startingPoint) break;
        while (true) {
          const availableLEs = event.getAvailableLinkedEvents();
          if (availableLEs.length === 0) {
            const firstPt = events[0].point;
            const lastPt = events[events.length - 1].point;
            throw new Error(
              `Unable to complete output ring starting at [${firstPt.x}, ${firstPt.y}]. Last matching segment found ends at [${lastPt.x}, ${lastPt.y}].`
            );
          }
          if (availableLEs.length === 1) {
            nextEvent = availableLEs[0].otherSE;
            break;
          }
          let indexLE = null;
          for (let j = 0, jMax = intersectionLEs.length; j < jMax; j++) {
            if (intersectionLEs[j].point === event.point) {
              indexLE = j;
              break;
            }
          }
          if (indexLE !== null) {
            const intersectionLE = intersectionLEs.splice(indexLE)[0];
            const ringEvents = events.splice(intersectionLE.index);
            ringEvents.unshift(ringEvents[0].otherSE);
            ringsOut.push(new _RingOut(ringEvents.reverse()));
            continue;
          }
          intersectionLEs.push({
            index: events.length,
            point: event.point
          });
          const comparator = event.getLeftmostComparator(prevEvent);
          nextEvent = availableLEs.sort(comparator)[0].otherSE;
          break;
        }
      }
      ringsOut.push(new _RingOut(events));
    }
    return ringsOut;
  }
  getGeom() {
    let prevPt = this.events[0].point;
    const points = [prevPt];
    for (let i = 1, iMax = this.events.length - 1; i < iMax; i++) {
      const pt2 = this.events[i].point;
      const nextPt2 = this.events[i + 1].point;
      if (precision.orient(pt2, prevPt, nextPt2) === 0) continue;
      points.push(pt2);
      prevPt = pt2;
    }
    if (points.length === 1) return null;
    const pt = points[0];
    const nextPt = points[1];
    if (precision.orient(pt, prevPt, nextPt) === 0) points.shift();
    points.push(points[0]);
    const step = this.isExteriorRing() ? 1 : -1;
    const iStart = this.isExteriorRing() ? 0 : points.length - 1;
    const iEnd = this.isExteriorRing() ? points.length : -1;
    const orderedPoints = [];
    for (let i = iStart; i != iEnd; i += step)
      orderedPoints.push([points[i].x.toNumber(), points[i].y.toNumber()]);
    return orderedPoints;
  }
  isExteriorRing() {
    if (this._isExteriorRing === void 0) {
      const enclosing = this.enclosingRing();
      this._isExteriorRing = enclosing ? !enclosing.isExteriorRing() : true;
    }
    return this._isExteriorRing;
  }
  enclosingRing() {
    if (this._enclosingRing === void 0) {
      this._enclosingRing = this._calcEnclosingRing();
    }
    return this._enclosingRing;
  }
  /* Returns the ring that encloses this one, if any */
  _calcEnclosingRing() {
    let leftMostEvt = this.events[0];
    for (let i = 1, iMax = this.events.length; i < iMax; i++) {
      const evt = this.events[i];
      if (SweepEvent.compare(leftMostEvt, evt) > 0) leftMostEvt = evt;
    }
    let prevSeg = leftMostEvt.segment.prevInResult();
    let prevPrevSeg = prevSeg ? prevSeg.prevInResult() : null;
    while (true) {
      if (!prevSeg) return null;
      if (!prevPrevSeg) return prevSeg.ringOut;
      if (prevPrevSeg.ringOut !== prevSeg.ringOut) {
        if (prevPrevSeg.ringOut?.enclosingRing() !== prevSeg.ringOut) {
          return prevSeg.ringOut;
        } else return prevSeg.ringOut?.enclosingRing();
      }
      prevSeg = prevPrevSeg.prevInResult();
      prevPrevSeg = prevSeg ? prevSeg.prevInResult() : null;
    }
  }
};
var PolyOut = class {
  constructor(exteriorRing) {
    __publicField(this, "exteriorRing");
    __publicField(this, "interiorRings");
    this.exteriorRing = exteriorRing;
    exteriorRing.poly = this;
    this.interiorRings = [];
  }
  addInterior(ring) {
    this.interiorRings.push(ring);
    ring.poly = this;
  }
  getGeom() {
    const geom0 = this.exteriorRing.getGeom();
    if (geom0 === null) return null;
    const geom = [geom0];
    for (let i = 0, iMax = this.interiorRings.length; i < iMax; i++) {
      const ringGeom = this.interiorRings[i].getGeom();
      if (ringGeom === null) continue;
      geom.push(ringGeom);
    }
    return geom;
  }
};
var MultiPolyOut = class {
  constructor(rings) {
    __publicField(this, "rings");
    __publicField(this, "polys");
    this.rings = rings;
    this.polys = this._composePolys(rings);
  }
  getGeom() {
    const geom = [];
    for (let i = 0, iMax = this.polys.length; i < iMax; i++) {
      const polyGeom = this.polys[i].getGeom();
      if (polyGeom === null) continue;
      geom.push(polyGeom);
    }
    return geom;
  }
  _composePolys(rings) {
    const polys = [];
    for (let i = 0, iMax = rings.length; i < iMax; i++) {
      const ring = rings[i];
      if (ring.poly) continue;
      if (ring.isExteriorRing()) polys.push(new PolyOut(ring));
      else {
        const enclosingRing = ring.enclosingRing();
        if (!enclosingRing?.poly) polys.push(new PolyOut(enclosingRing));
        enclosingRing?.poly?.addInterior(ring);
      }
    }
    return polys;
  }
};
var SweepLine = class {
  constructor(queue, comparator = Segment2.compare) {
    __publicField(this, "queue");
    __publicField(this, "tree");
    __publicField(this, "segments");
    this.queue = queue;
    this.tree = new SplayTreeSet(comparator);
    this.segments = [];
  }
  process(event) {
    const segment = event.segment;
    const newEvents = [];
    if (event.consumedBy) {
      if (event.isLeft) this.queue.delete(event.otherSE);
      else this.tree.delete(segment);
      return newEvents;
    }
    if (event.isLeft) this.tree.add(segment);
    let prevSeg = segment;
    let nextSeg = segment;
    do {
      prevSeg = this.tree.lastBefore(prevSeg);
    } while (prevSeg != null && prevSeg.consumedBy != void 0);
    do {
      nextSeg = this.tree.firstAfter(nextSeg);
    } while (nextSeg != null && nextSeg.consumedBy != void 0);
    if (event.isLeft) {
      let prevMySplitter = null;
      if (prevSeg) {
        const prevInter = prevSeg.getIntersection(segment);
        if (prevInter !== null) {
          if (!segment.isAnEndpoint(prevInter)) prevMySplitter = prevInter;
          if (!prevSeg.isAnEndpoint(prevInter)) {
            const newEventsFromSplit = this._splitSafely(prevSeg, prevInter);
            for (let i = 0, iMax = newEventsFromSplit.length; i < iMax; i++) {
              newEvents.push(newEventsFromSplit[i]);
            }
          }
        }
      }
      let nextMySplitter = null;
      if (nextSeg) {
        const nextInter = nextSeg.getIntersection(segment);
        if (nextInter !== null) {
          if (!segment.isAnEndpoint(nextInter)) nextMySplitter = nextInter;
          if (!nextSeg.isAnEndpoint(nextInter)) {
            const newEventsFromSplit = this._splitSafely(nextSeg, nextInter);
            for (let i = 0, iMax = newEventsFromSplit.length; i < iMax; i++) {
              newEvents.push(newEventsFromSplit[i]);
            }
          }
        }
      }
      if (prevMySplitter !== null || nextMySplitter !== null) {
        let mySplitter = null;
        if (prevMySplitter === null) mySplitter = nextMySplitter;
        else if (nextMySplitter === null) mySplitter = prevMySplitter;
        else {
          const cmpSplitters = SweepEvent.comparePoints(
            prevMySplitter,
            nextMySplitter
          );
          mySplitter = cmpSplitters <= 0 ? prevMySplitter : nextMySplitter;
        }
        this.queue.delete(segment.rightSE);
        newEvents.push(segment.rightSE);
        const newEventsFromSplit = segment.split(mySplitter);
        for (let i = 0, iMax = newEventsFromSplit.length; i < iMax; i++) {
          newEvents.push(newEventsFromSplit[i]);
        }
      }
      if (newEvents.length > 0) {
        this.tree.delete(segment);
        newEvents.push(event);
      } else {
        this.segments.push(segment);
        segment.prev = prevSeg;
      }
    } else {
      if (prevSeg && nextSeg) {
        const inter = prevSeg.getIntersection(nextSeg);
        if (inter !== null) {
          if (!prevSeg.isAnEndpoint(inter)) {
            const newEventsFromSplit = this._splitSafely(prevSeg, inter);
            for (let i = 0, iMax = newEventsFromSplit.length; i < iMax; i++) {
              newEvents.push(newEventsFromSplit[i]);
            }
          }
          if (!nextSeg.isAnEndpoint(inter)) {
            const newEventsFromSplit = this._splitSafely(nextSeg, inter);
            for (let i = 0, iMax = newEventsFromSplit.length; i < iMax; i++) {
              newEvents.push(newEventsFromSplit[i]);
            }
          }
        }
      }
      this.tree.delete(segment);
    }
    return newEvents;
  }
  /* Safely split a segment that is currently in the datastructures
   * IE - a segment other than the one that is currently being processed. */
  _splitSafely(seg, pt) {
    this.tree.delete(seg);
    const rightSE = seg.rightSE;
    this.queue.delete(rightSE);
    const newEvents = seg.split(pt);
    newEvents.push(rightSE);
    if (seg.consumedBy === void 0) this.tree.add(seg);
    return newEvents;
  }
};
var Operation = class {
  constructor() {
    __publicField(this, "type");
    __publicField(this, "numMultiPolys");
  }
  run(type, geom, moreGeoms) {
    operation.type = type;
    const multipolys = [new MultiPolyIn(geom, true)];
    for (let i = 0, iMax = moreGeoms.length; i < iMax; i++) {
      multipolys.push(new MultiPolyIn(moreGeoms[i], false));
    }
    operation.numMultiPolys = multipolys.length;
    if (operation.type === "difference") {
      const subject = multipolys[0];
      let i = 1;
      while (i < multipolys.length) {
        if (getBboxOverlap(multipolys[i].bbox, subject.bbox) !== null) i++;
        else multipolys.splice(i, 1);
      }
    }
    if (operation.type === "intersection") {
      for (let i = 0, iMax = multipolys.length; i < iMax; i++) {
        const mpA = multipolys[i];
        for (let j = i + 1, jMax = multipolys.length; j < jMax; j++) {
          if (getBboxOverlap(mpA.bbox, multipolys[j].bbox) === null) return [];
        }
      }
    }
    const queue = new SplayTreeSet(SweepEvent.compare);
    for (let i = 0, iMax = multipolys.length; i < iMax; i++) {
      const sweepEvents = multipolys[i].getSweepEvents();
      for (let j = 0, jMax = sweepEvents.length; j < jMax; j++) {
        queue.add(sweepEvents[j]);
      }
    }
    const sweepLine = new SweepLine(queue);
    let evt = null;
    if (queue.size != 0) {
      evt = queue.first();
      queue.delete(evt);
    }
    while (evt) {
      const newEvents = sweepLine.process(evt);
      for (let i = 0, iMax = newEvents.length; i < iMax; i++) {
        const evt2 = newEvents[i];
        if (evt2.consumedBy === void 0) queue.add(evt2);
      }
      if (queue.size != 0) {
        evt = queue.first();
        queue.delete(evt);
      } else {
        evt = null;
      }
    }
    precision.reset();
    const ringsOut = RingOut.factory(sweepLine.segments);
    const result = new MultiPolyOut(ringsOut);
    return result.getGeom();
  }
};
var operation = new Operation();
var operation_default = operation;
var segmentId = 0;
var Segment2 = class _Segment {
  /* Warning: a reference to ringWindings input will be stored,
   *  and possibly will be later modified */
  constructor(leftSE, rightSE, rings, windings) {
    __publicField(this, "id");
    __publicField(this, "leftSE");
    __publicField(this, "rightSE");
    __publicField(this, "rings");
    __publicField(this, "windings");
    __publicField(this, "ringOut");
    __publicField(this, "consumedBy");
    __publicField(this, "prev");
    __publicField(this, "_prevInResult");
    __publicField(this, "_beforeState");
    __publicField(this, "_afterState");
    __publicField(this, "_isInResult");
    this.id = ++segmentId;
    this.leftSE = leftSE;
    leftSE.segment = this;
    leftSE.otherSE = rightSE;
    this.rightSE = rightSE;
    rightSE.segment = this;
    rightSE.otherSE = leftSE;
    this.rings = rings;
    this.windings = windings;
  }
  /* This compare() function is for ordering segments in the sweep
   * line tree, and does so according to the following criteria:
   *
   * Consider the vertical line that lies an infinestimal step to the
   * right of the right-more of the two left endpoints of the input
   * segments. Imagine slowly moving a point up from negative infinity
   * in the increasing y direction. Which of the two segments will that
   * point intersect first? That segment comes 'before' the other one.
   *
   * If neither segment would be intersected by such a line, (if one
   * or more of the segments are vertical) then the line to be considered
   * is directly on the right-more of the two left inputs.
   */
  static compare(a, b) {
    const alx = a.leftSE.point.x;
    const blx = b.leftSE.point.x;
    const arx = a.rightSE.point.x;
    const brx = b.rightSE.point.x;
    if (brx.isLessThan(alx)) return 1;
    if (arx.isLessThan(blx)) return -1;
    const aly = a.leftSE.point.y;
    const bly = b.leftSE.point.y;
    const ary = a.rightSE.point.y;
    const bry = b.rightSE.point.y;
    if (alx.isLessThan(blx)) {
      if (bly.isLessThan(aly) && bly.isLessThan(ary)) return 1;
      if (bly.isGreaterThan(aly) && bly.isGreaterThan(ary)) return -1;
      const aCmpBLeft = a.comparePoint(b.leftSE.point);
      if (aCmpBLeft < 0) return 1;
      if (aCmpBLeft > 0) return -1;
      const bCmpARight = b.comparePoint(a.rightSE.point);
      if (bCmpARight !== 0) return bCmpARight;
      return -1;
    }
    if (alx.isGreaterThan(blx)) {
      if (aly.isLessThan(bly) && aly.isLessThan(bry)) return -1;
      if (aly.isGreaterThan(bly) && aly.isGreaterThan(bry)) return 1;
      const bCmpALeft = b.comparePoint(a.leftSE.point);
      if (bCmpALeft !== 0) return bCmpALeft;
      const aCmpBRight = a.comparePoint(b.rightSE.point);
      if (aCmpBRight < 0) return 1;
      if (aCmpBRight > 0) return -1;
      return 1;
    }
    if (aly.isLessThan(bly)) return -1;
    if (aly.isGreaterThan(bly)) return 1;
    if (arx.isLessThan(brx)) {
      const bCmpARight = b.comparePoint(a.rightSE.point);
      if (bCmpARight !== 0) return bCmpARight;
    }
    if (arx.isGreaterThan(brx)) {
      const aCmpBRight = a.comparePoint(b.rightSE.point);
      if (aCmpBRight < 0) return 1;
      if (aCmpBRight > 0) return -1;
    }
    if (!arx.eq(brx)) {
      const ay = ary.minus(aly);
      const ax = arx.minus(alx);
      const by = bry.minus(bly);
      const bx = brx.minus(blx);
      if (ay.isGreaterThan(ax) && by.isLessThan(bx)) return 1;
      if (ay.isLessThan(ax) && by.isGreaterThan(bx)) return -1;
    }
    if (arx.isGreaterThan(brx)) return 1;
    if (arx.isLessThan(brx)) return -1;
    if (ary.isLessThan(bry)) return -1;
    if (ary.isGreaterThan(bry)) return 1;
    if (a.id < b.id) return -1;
    if (a.id > b.id) return 1;
    return 0;
  }
  static fromRing(pt1, pt2, ring) {
    let leftPt, rightPt, winding;
    const cmpPts = SweepEvent.comparePoints(pt1, pt2);
    if (cmpPts < 0) {
      leftPt = pt1;
      rightPt = pt2;
      winding = 1;
    } else if (cmpPts > 0) {
      leftPt = pt2;
      rightPt = pt1;
      winding = -1;
    } else
      throw new Error(
        `Tried to create degenerate segment at [${pt1.x}, ${pt1.y}]`
      );
    const leftSE = new SweepEvent(leftPt, true);
    const rightSE = new SweepEvent(rightPt, false);
    return new _Segment(leftSE, rightSE, [ring], [winding]);
  }
  /* When a segment is split, the rightSE is replaced with a new sweep event */
  replaceRightSE(newRightSE) {
    this.rightSE = newRightSE;
    this.rightSE.segment = this;
    this.rightSE.otherSE = this.leftSE;
    this.leftSE.otherSE = this.rightSE;
  }
  bbox() {
    const y1 = this.leftSE.point.y;
    const y2 = this.rightSE.point.y;
    return {
      ll: { x: this.leftSE.point.x, y: y1.isLessThan(y2) ? y1 : y2 },
      ur: { x: this.rightSE.point.x, y: y1.isGreaterThan(y2) ? y1 : y2 }
    };
  }
  /* A vector from the left point to the right */
  vector() {
    return {
      x: this.rightSE.point.x.minus(this.leftSE.point.x),
      y: this.rightSE.point.y.minus(this.leftSE.point.y)
    };
  }
  isAnEndpoint(pt) {
    return pt.x.eq(this.leftSE.point.x) && pt.y.eq(this.leftSE.point.y) || pt.x.eq(this.rightSE.point.x) && pt.y.eq(this.rightSE.point.y);
  }
  /* Compare this segment with a point.
   *
   * A point P is considered to be colinear to a segment if there
   * exists a distance D such that if we travel along the segment
   * from one * endpoint towards the other a distance D, we find
   * ourselves at point P.
   *
   * Return value indicates:
   *
   *   1: point lies above the segment (to the left of vertical)
   *   0: point is colinear to segment
   *  -1: point lies below the segment (to the right of vertical)
   */
  comparePoint(point2) {
    return precision.orient(this.leftSE.point, point2, this.rightSE.point);
  }
  /**
   * Given another segment, returns the first non-trivial intersection
   * between the two segments (in terms of sweep line ordering), if it exists.
   *
   * A 'non-trivial' intersection is one that will cause one or both of the
   * segments to be split(). As such, 'trivial' vs. 'non-trivial' intersection:
   *
   *   * endpoint of segA with endpoint of segB --> trivial
   *   * endpoint of segA with point along segB --> non-trivial
   *   * endpoint of segB with point along segA --> non-trivial
   *   * point along segA with point along segB --> non-trivial
   *
   * If no non-trivial intersection exists, return null
   * Else, return null.
   */
  getIntersection(other) {
    const tBbox = this.bbox();
    const oBbox = other.bbox();
    const bboxOverlap = getBboxOverlap(tBbox, oBbox);
    if (bboxOverlap === null) return null;
    const tlp = this.leftSE.point;
    const trp = this.rightSE.point;
    const olp = other.leftSE.point;
    const orp = other.rightSE.point;
    const touchesOtherLSE = isInBbox(tBbox, olp) && this.comparePoint(olp) === 0;
    const touchesThisLSE = isInBbox(oBbox, tlp) && other.comparePoint(tlp) === 0;
    const touchesOtherRSE = isInBbox(tBbox, orp) && this.comparePoint(orp) === 0;
    const touchesThisRSE = isInBbox(oBbox, trp) && other.comparePoint(trp) === 0;
    if (touchesThisLSE && touchesOtherLSE) {
      if (touchesThisRSE && !touchesOtherRSE) return trp;
      if (!touchesThisRSE && touchesOtherRSE) return orp;
      return null;
    }
    if (touchesThisLSE) {
      if (touchesOtherRSE) {
        if (tlp.x.eq(orp.x) && tlp.y.eq(orp.y)) return null;
      }
      return tlp;
    }
    if (touchesOtherLSE) {
      if (touchesThisRSE) {
        if (trp.x.eq(olp.x) && trp.y.eq(olp.y)) return null;
      }
      return olp;
    }
    if (touchesThisRSE && touchesOtherRSE) return null;
    if (touchesThisRSE) return trp;
    if (touchesOtherRSE) return orp;
    const pt = intersection(tlp, this.vector(), olp, other.vector());
    if (pt === null) return null;
    if (!isInBbox(bboxOverlap, pt)) return null;
    return precision.snap(pt);
  }
  /**
   * Split the given segment into multiple segments on the given points.
   *  * Each existing segment will retain its leftSE and a new rightSE will be
   *    generated for it.
   *  * A new segment will be generated which will adopt the original segment's
   *    rightSE, and a new leftSE will be generated for it.
   *  * If there are more than two points given to split on, new segments
   *    in the middle will be generated with new leftSE and rightSE's.
   *  * An array of the newly generated SweepEvents will be returned.
   *
   * Warning: input array of points is modified
   */
  split(point2) {
    const newEvents = [];
    const alreadyLinked = point2.events !== void 0;
    const newLeftSE = new SweepEvent(point2, true);
    const newRightSE = new SweepEvent(point2, false);
    const oldRightSE = this.rightSE;
    this.replaceRightSE(newRightSE);
    newEvents.push(newRightSE);
    newEvents.push(newLeftSE);
    const newSeg = new _Segment(
      newLeftSE,
      oldRightSE,
      this.rings.slice(),
      this.windings.slice()
    );
    if (SweepEvent.comparePoints(newSeg.leftSE.point, newSeg.rightSE.point) > 0) {
      newSeg.swapEvents();
    }
    if (SweepEvent.comparePoints(this.leftSE.point, this.rightSE.point) > 0) {
      this.swapEvents();
    }
    if (alreadyLinked) {
      newLeftSE.checkForConsuming();
      newRightSE.checkForConsuming();
    }
    return newEvents;
  }
  /* Swap which event is left and right */
  swapEvents() {
    const tmpEvt = this.rightSE;
    this.rightSE = this.leftSE;
    this.leftSE = tmpEvt;
    this.leftSE.isLeft = true;
    this.rightSE.isLeft = false;
    for (let i = 0, iMax = this.windings.length; i < iMax; i++) {
      this.windings[i] *= -1;
    }
  }
  /* Consume another segment. We take their rings under our wing
   * and mark them as consumed. Use for perfectly overlapping segments */
  consume(other) {
    let consumer = this;
    let consumee = other;
    while (consumer.consumedBy) consumer = consumer.consumedBy;
    while (consumee.consumedBy) consumee = consumee.consumedBy;
    const cmp = _Segment.compare(consumer, consumee);
    if (cmp === 0) return;
    if (cmp > 0) {
      const tmp = consumer;
      consumer = consumee;
      consumee = tmp;
    }
    if (consumer.prev === consumee) {
      const tmp = consumer;
      consumer = consumee;
      consumee = tmp;
    }
    for (let i = 0, iMax = consumee.rings.length; i < iMax; i++) {
      const ring = consumee.rings[i];
      const winding = consumee.windings[i];
      const index = consumer.rings.indexOf(ring);
      if (index === -1) {
        consumer.rings.push(ring);
        consumer.windings.push(winding);
      } else consumer.windings[index] += winding;
    }
    consumee.rings = null;
    consumee.windings = null;
    consumee.consumedBy = consumer;
    consumee.leftSE.consumedBy = consumer.leftSE;
    consumee.rightSE.consumedBy = consumer.rightSE;
  }
  /* The first segment previous segment chain that is in the result */
  prevInResult() {
    if (this._prevInResult !== void 0) return this._prevInResult;
    if (!this.prev) this._prevInResult = null;
    else if (this.prev.isInResult()) this._prevInResult = this.prev;
    else this._prevInResult = this.prev.prevInResult();
    return this._prevInResult;
  }
  beforeState() {
    if (this._beforeState !== void 0) return this._beforeState;
    if (!this.prev)
      this._beforeState = {
        rings: [],
        windings: [],
        multiPolys: []
      };
    else {
      const seg = this.prev.consumedBy || this.prev;
      this._beforeState = seg.afterState();
    }
    return this._beforeState;
  }
  afterState() {
    if (this._afterState !== void 0) return this._afterState;
    const beforeState = this.beforeState();
    this._afterState = {
      rings: beforeState.rings.slice(0),
      windings: beforeState.windings.slice(0),
      multiPolys: []
    };
    const ringsAfter = this._afterState.rings;
    const windingsAfter = this._afterState.windings;
    const mpsAfter = this._afterState.multiPolys;
    for (let i = 0, iMax = this.rings.length; i < iMax; i++) {
      const ring = this.rings[i];
      const winding = this.windings[i];
      const index = ringsAfter.indexOf(ring);
      if (index === -1) {
        ringsAfter.push(ring);
        windingsAfter.push(winding);
      } else windingsAfter[index] += winding;
    }
    const polysAfter = [];
    const polysExclude = [];
    for (let i = 0, iMax = ringsAfter.length; i < iMax; i++) {
      if (windingsAfter[i] === 0) continue;
      const ring = ringsAfter[i];
      const poly = ring.poly;
      if (polysExclude.indexOf(poly) !== -1) continue;
      if (ring.isExterior) polysAfter.push(poly);
      else {
        if (polysExclude.indexOf(poly) === -1) polysExclude.push(poly);
        const index = polysAfter.indexOf(ring.poly);
        if (index !== -1) polysAfter.splice(index, 1);
      }
    }
    for (let i = 0, iMax = polysAfter.length; i < iMax; i++) {
      const mp = polysAfter[i].multiPoly;
      if (mpsAfter.indexOf(mp) === -1) mpsAfter.push(mp);
    }
    return this._afterState;
  }
  /* Is this segment part of the final result? */
  isInResult() {
    if (this.consumedBy) return false;
    if (this._isInResult !== void 0) return this._isInResult;
    const mpsBefore = this.beforeState().multiPolys;
    const mpsAfter = this.afterState().multiPolys;
    switch (operation_default.type) {
      case "union": {
        const noBefores = mpsBefore.length === 0;
        const noAfters = mpsAfter.length === 0;
        this._isInResult = noBefores !== noAfters;
        break;
      }
      case "intersection": {
        let least;
        let most;
        if (mpsBefore.length < mpsAfter.length) {
          least = mpsBefore.length;
          most = mpsAfter.length;
        } else {
          least = mpsAfter.length;
          most = mpsBefore.length;
        }
        this._isInResult = most === operation_default.numMultiPolys && least < most;
        break;
      }
      case "xor": {
        const diff = Math.abs(mpsBefore.length - mpsAfter.length);
        this._isInResult = diff % 2 === 1;
        break;
      }
      case "difference": {
        const isJustSubject = (mps) => mps.length === 1 && mps[0].isSubject;
        this._isInResult = isJustSubject(mpsBefore) !== isJustSubject(mpsAfter);
        break;
      }
    }
    return this._isInResult;
  }
};
var RingIn = class {
  constructor(geomRing, poly, isExterior) {
    __publicField(this, "poly");
    __publicField(this, "isExterior");
    __publicField(this, "segments");
    __publicField(this, "bbox");
    if (!Array.isArray(geomRing) || geomRing.length === 0) {
      throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
    }
    this.poly = poly;
    this.isExterior = isExterior;
    this.segments = [];
    if (typeof geomRing[0][0] !== "number" || typeof geomRing[0][1] !== "number") {
      throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
    }
    const firstPoint = precision.snap({ x: new bignumber_default(geomRing[0][0]), y: new bignumber_default(geomRing[0][1]) });
    this.bbox = {
      ll: { x: firstPoint.x, y: firstPoint.y },
      ur: { x: firstPoint.x, y: firstPoint.y }
    };
    let prevPoint = firstPoint;
    for (let i = 1, iMax = geomRing.length; i < iMax; i++) {
      if (typeof geomRing[i][0] !== "number" || typeof geomRing[i][1] !== "number") {
        throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
      }
      const point2 = precision.snap({ x: new bignumber_default(geomRing[i][0]), y: new bignumber_default(geomRing[i][1]) });
      if (point2.x.eq(prevPoint.x) && point2.y.eq(prevPoint.y)) continue;
      this.segments.push(Segment2.fromRing(prevPoint, point2, this));
      if (point2.x.isLessThan(this.bbox.ll.x)) this.bbox.ll.x = point2.x;
      if (point2.y.isLessThan(this.bbox.ll.y)) this.bbox.ll.y = point2.y;
      if (point2.x.isGreaterThan(this.bbox.ur.x)) this.bbox.ur.x = point2.x;
      if (point2.y.isGreaterThan(this.bbox.ur.y)) this.bbox.ur.y = point2.y;
      prevPoint = point2;
    }
    if (!firstPoint.x.eq(prevPoint.x) || !firstPoint.y.eq(prevPoint.y)) {
      this.segments.push(Segment2.fromRing(prevPoint, firstPoint, this));
    }
  }
  getSweepEvents() {
    const sweepEvents = [];
    for (let i = 0, iMax = this.segments.length; i < iMax; i++) {
      const segment = this.segments[i];
      sweepEvents.push(segment.leftSE);
      sweepEvents.push(segment.rightSE);
    }
    return sweepEvents;
  }
};
var PolyIn = class {
  constructor(geomPoly, multiPoly) {
    __publicField(this, "multiPoly");
    __publicField(this, "exteriorRing");
    __publicField(this, "interiorRings");
    __publicField(this, "bbox");
    if (!Array.isArray(geomPoly)) {
      throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
    }
    this.exteriorRing = new RingIn(geomPoly[0], this, true);
    this.bbox = {
      ll: { x: this.exteriorRing.bbox.ll.x, y: this.exteriorRing.bbox.ll.y },
      ur: { x: this.exteriorRing.bbox.ur.x, y: this.exteriorRing.bbox.ur.y }
    };
    this.interiorRings = [];
    for (let i = 1, iMax = geomPoly.length; i < iMax; i++) {
      const ring = new RingIn(geomPoly[i], this, false);
      if (ring.bbox.ll.x.isLessThan(this.bbox.ll.x)) this.bbox.ll.x = ring.bbox.ll.x;
      if (ring.bbox.ll.y.isLessThan(this.bbox.ll.y)) this.bbox.ll.y = ring.bbox.ll.y;
      if (ring.bbox.ur.x.isGreaterThan(this.bbox.ur.x)) this.bbox.ur.x = ring.bbox.ur.x;
      if (ring.bbox.ur.y.isGreaterThan(this.bbox.ur.y)) this.bbox.ur.y = ring.bbox.ur.y;
      this.interiorRings.push(ring);
    }
    this.multiPoly = multiPoly;
  }
  getSweepEvents() {
    const sweepEvents = this.exteriorRing.getSweepEvents();
    for (let i = 0, iMax = this.interiorRings.length; i < iMax; i++) {
      const ringSweepEvents = this.interiorRings[i].getSweepEvents();
      for (let j = 0, jMax = ringSweepEvents.length; j < jMax; j++) {
        sweepEvents.push(ringSweepEvents[j]);
      }
    }
    return sweepEvents;
  }
};
var MultiPolyIn = class {
  constructor(geom, isSubject) {
    __publicField(this, "isSubject");
    __publicField(this, "polys");
    __publicField(this, "bbox");
    if (!Array.isArray(geom)) {
      throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
    }
    try {
      if (typeof geom[0][0][0] === "number") geom = [geom];
    } catch (ex) {
    }
    this.polys = [];
    this.bbox = {
      ll: { x: new bignumber_default(Number.POSITIVE_INFINITY), y: new bignumber_default(Number.POSITIVE_INFINITY) },
      ur: { x: new bignumber_default(Number.NEGATIVE_INFINITY), y: new bignumber_default(Number.NEGATIVE_INFINITY) }
    };
    for (let i = 0, iMax = geom.length; i < iMax; i++) {
      const poly = new PolyIn(geom[i], this);
      if (poly.bbox.ll.x.isLessThan(this.bbox.ll.x)) this.bbox.ll.x = poly.bbox.ll.x;
      if (poly.bbox.ll.y.isLessThan(this.bbox.ll.y)) this.bbox.ll.y = poly.bbox.ll.y;
      if (poly.bbox.ur.x.isGreaterThan(this.bbox.ur.x)) this.bbox.ur.x = poly.bbox.ur.x;
      if (poly.bbox.ur.y.isGreaterThan(this.bbox.ur.y)) this.bbox.ur.y = poly.bbox.ur.y;
      this.polys.push(poly);
    }
    this.isSubject = isSubject;
  }
  getSweepEvents() {
    const sweepEvents = [];
    for (let i = 0, iMax = this.polys.length; i < iMax; i++) {
      const polySweepEvents = this.polys[i].getSweepEvents();
      for (let j = 0, jMax = polySweepEvents.length; j < jMax; j++) {
        sweepEvents.push(polySweepEvents[j]);
      }
    }
    return sweepEvents;
  }
};
var union = (geom, ...moreGeoms) => operation_default.run("union", geom, moreGeoms);
var intersection2 = (geom, ...moreGeoms) => operation_default.run("intersection", geom, moreGeoms);
var setPrecision = precision.set;

// node_modules/@turf/intersect/dist/esm/index.js
function intersect(features, options = {}) {
  const geoms = [];
  geomEach(features, (geom) => {
    geoms.push(geom.coordinates);
  });
  if (geoms.length < 2) {
    throw new Error("Must specify at least 2 geometries");
  }
  const intersection22 = intersection2(geoms[0], ...geoms.slice(1));
  if (intersection22.length === 0) return null;
  if (intersection22.length === 1)
    return polygon(intersection22[0], options.properties);
  return multiPolygon(intersection22, options.properties);
}
var turf_intersect_default = intersect;

// src/utils/transformToTileCoords.ts
init_cjs_shims();
var TRANSFORM_FN2 = {
  Point: transformPoint2,
  MultiPoint: transformMultiPoint2,
  LineString: transformLineString2,
  MultiLineString: transformMultiLineString2,
  Polygon: transformPolygon2,
  MultiPolygon: transformMultiPolygon2
};
function transformToTileCoords(geometry, bbox2) {
  const [west, south, east, north] = bbox2;
  const nw = projectFlat([west, north]);
  const se = projectFlat([east, south]);
  const projectedBbox = [nw, se];
  if (geometry.type === "GeometryCollection") {
    throw new Error("Unsupported geometry type GeometryCollection");
  }
  const transformFn = TRANSFORM_FN2[geometry.type];
  const coordinates = transformFn(geometry.coordinates, projectedBbox);
  return { ...geometry, coordinates };
}
function transformPoint2([pointX, pointY], [nw, se]) {
  const x = inverseLerp(nw[0], se[0], pointX);
  const y = inverseLerp(nw[1], se[1], pointY);
  return [x, y];
}
function getPoints2(geometry, bbox2) {
  return geometry.map((g) => transformPoint2(projectFlat(g), bbox2));
}
function transformMultiPoint2(multiPoint, bbox2) {
  return getPoints2(multiPoint, bbox2);
}
function transformLineString2(line, bbox2) {
  return getPoints2(line, bbox2);
}
function transformMultiLineString2(multiLineString2, bbox2) {
  return multiLineString2.map(
    (lineString2) => transformLineString2(lineString2, bbox2)
  );
}
function transformPolygon2(polygon2, bbox2) {
  return polygon2.map((polygonRing) => getPoints2(polygonRing, bbox2));
}
function transformMultiPolygon2(multiPolygon2, bbox2) {
  return multiPolygon2.map((polygon2) => transformPolygon2(polygon2, bbox2));
}
function projectFlat(xyz) {
  return lngLatToWorld(xyz);
}
function inverseLerp(a, b, x) {
  return (x - a) / (b - a);
}

// src/filters/tileIntersection.ts
var import_quadbin = require("quadbin");
var import_h3_js = require("h3-js");

// node_modules/@turf/bbox-clip/dist/esm/index.js
init_cjs_shims();
function lineclip(points, bbox2, result) {
  var len = points.length, codeA = bitCode(points[0], bbox2), part = [], i, codeB, lastCode;
  let a;
  let b;
  if (!result) result = [];
  for (i = 1; i < len; i++) {
    a = points[i - 1];
    b = points[i];
    codeB = lastCode = bitCode(b, bbox2);
    while (true) {
      if (!(codeA | codeB)) {
        part.push(a);
        if (codeB !== lastCode) {
          part.push(b);
          if (i < len - 1) {
            result.push(part);
            part = [];
          }
        } else if (i === len - 1) {
          part.push(b);
        }
        break;
      } else if (codeA & codeB) {
        break;
      } else if (codeA) {
        a = intersect2(a, b, codeA, bbox2);
        codeA = bitCode(a, bbox2);
      } else {
        b = intersect2(a, b, codeB, bbox2);
        codeB = bitCode(b, bbox2);
      }
    }
    codeA = lastCode;
  }
  if (part.length) result.push(part);
  return result;
}
function polygonclip(points, bbox2) {
  var result, edge, prev, prevInside, i, p, inside;
  for (edge = 1; edge <= 8; edge *= 2) {
    result = [];
    prev = points[points.length - 1];
    prevInside = !(bitCode(prev, bbox2) & edge);
    for (i = 0; i < points.length; i++) {
      p = points[i];
      inside = !(bitCode(p, bbox2) & edge);
      if (inside !== prevInside) result.push(intersect2(prev, p, edge, bbox2));
      if (inside) result.push(p);
      prev = p;
      prevInside = inside;
    }
    points = result;
    if (!points.length) break;
  }
  return result;
}
function intersect2(a, b, edge, bbox2) {
  return edge & 8 ? [a[0] + (b[0] - a[0]) * (bbox2[3] - a[1]) / (b[1] - a[1]), bbox2[3]] : edge & 4 ? [a[0] + (b[0] - a[0]) * (bbox2[1] - a[1]) / (b[1] - a[1]), bbox2[1]] : edge & 2 ? [bbox2[2], a[1] + (b[1] - a[1]) * (bbox2[2] - a[0]) / (b[0] - a[0])] : edge & 1 ? [bbox2[0], a[1] + (b[1] - a[1]) * (bbox2[0] - a[0]) / (b[0] - a[0])] : null;
}
function bitCode(p, bbox2) {
  var code = 0;
  if (p[0] < bbox2[0]) code |= 1;
  else if (p[0] > bbox2[2]) code |= 2;
  if (p[1] < bbox2[1]) code |= 4;
  else if (p[1] > bbox2[3]) code |= 8;
  return code;
}
function bboxClip(feature2, bbox2) {
  const geom = getGeom(feature2);
  const type = geom.type;
  const properties = feature2.type === "Feature" ? feature2.properties : {};
  let coords = geom.coordinates;
  switch (type) {
    case "LineString":
    case "MultiLineString": {
      const lines = [];
      if (type === "LineString") {
        coords = [coords];
      }
      coords.forEach((line) => {
        lineclip(line, bbox2, lines);
      });
      if (lines.length === 1) {
        return lineString(lines[0], properties);
      }
      return multiLineString(lines, properties);
    }
    case "Polygon":
      return polygon(clipPolygon(coords, bbox2), properties);
    case "MultiPolygon":
      return multiPolygon(
        coords.map((poly) => {
          return clipPolygon(poly, bbox2);
        }),
        properties
      );
    default:
      throw new Error("geometry " + type + " not supported");
  }
}
function clipPolygon(rings, bbox2) {
  const outRings = [];
  for (const ring of rings) {
    const clipped = polygonclip(ring, bbox2);
    if (clipped.length > 0) {
      if (clipped[0][0] !== clipped[clipped.length - 1][0] || clipped[0][1] !== clipped[clipped.length - 1][1]) {
        clipped.push(clipped[0]);
      }
      if (clipped.length >= 4) {
        outRings.push(clipped);
      }
    }
  }
  return outRings;
}
var turf_bbox_clip_default = bboxClip;

// src/filters/tileIntersection.ts
function intersectTileGeometry(tileBbox, tileFormat, spatialFilter) {
  const tilePolygon = turf_bbox_polygon_default(tileBbox);
  if (!spatialFilter || turf_boolean_within_default(tilePolygon, spatialFilter)) {
    return true;
  }
  const clippedSpatialFilter = turf_intersect_default(
    featureCollection([tilePolygon, feature(spatialFilter)])
  );
  if (!clippedSpatialFilter) {
    return false;
  }
  return tileFormat === "mvt" /* MVT */ ? transformToTileCoords(clippedSpatialFilter.geometry, tileBbox) : clippedSpatialFilter.geometry;
}
function intersectTileRaster(parent, cellResolution, spatialFilter) {
  return intersectTileQuadbin(parent, cellResolution, spatialFilter);
}
function intersectTileQuadbin(parent, cellResolution, spatialFilter) {
  const tilePolygon = (0, import_quadbin.cellToBoundary)(parent);
  if (!spatialFilter || turf_boolean_within_default(tilePolygon, spatialFilter)) {
    return true;
  }
  const clippedSpatialFilter = turf_intersect_default(
    featureCollection([feature(tilePolygon), feature(spatialFilter)])
  );
  if (!clippedSpatialFilter) {
    return false;
  }
  const cells = (0, import_quadbin.geometryToCells)(
    clippedSpatialFilter.geometry,
    cellResolution
  );
  return new Set(cells);
}
var BBOX_WEST = [-180, -90, 0, 90];
var BBOX_EAST = [0, -90, 180, 90];
function intersectTileH3(cellResolution, spatialFilter) {
  if (!spatialFilter) {
    return true;
  }
  const spatialFilterFeature = feature(spatialFilter);
  const cellsWest = (0, import_h3_js.polygonToCells)(
    turf_bbox_clip_default(spatialFilterFeature, BBOX_WEST).geometry.coordinates,
    cellResolution,
    true
  );
  const cellsEast = (0, import_h3_js.polygonToCells)(
    turf_bbox_clip_default(spatialFilterFeature, BBOX_EAST).geometry.coordinates,
    cellResolution,
    true
  );
  return new Set(cellsWest.concat(cellsEast));
}

// src/filters/tileFeaturesGeometries.ts
var FEATURE_GEOM_PROPERTY = "__geomValue";
function tileFeaturesGeometries({
  tiles,
  tileFormat,
  spatialFilter,
  uniqueIdProperty,
  options
}) {
  const map = /* @__PURE__ */ new Map();
  for (const tile of tiles) {
    if (tile.isVisible === false || !tile.data) {
      continue;
    }
    const tileBbox = [
      tile.bbox.west,
      tile.bbox.south,
      tile.bbox.east,
      tile.bbox.north
    ];
    const intersection3 = intersectTileGeometry(
      tileBbox,
      tileFormat,
      spatialFilter
    );
    if (intersection3 === false) continue;
    const transformedSpatialFilter = intersection3 === true ? void 0 : intersection3;
    calculateFeatures({
      map,
      spatialFilter: transformedSpatialFilter,
      data: tile.data.points,
      type: "Point",
      bbox: tileBbox,
      tileFormat,
      uniqueIdProperty,
      options
    });
    calculateFeatures({
      map,
      spatialFilter: transformedSpatialFilter,
      data: tile.data.lines,
      type: "LineString",
      bbox: tileBbox,
      tileFormat,
      uniqueIdProperty,
      options
    });
    calculateFeatures({
      map,
      spatialFilter: transformedSpatialFilter,
      data: tile.data.polygons,
      type: "Polygon",
      bbox: tileBbox,
      tileFormat,
      uniqueIdProperty,
      options
    });
  }
  return Array.from(map.values());
}
function processTileFeatureProperties({
  map,
  data,
  startIndex,
  endIndex,
  type,
  bbox: bbox2,
  tileFormat,
  uniqueIdProperty,
  storeGeometry,
  spatialFilter
}) {
  const tileProps = getPropertiesFromTile(data, startIndex);
  const uniquePropertyValue = getUniquePropertyValue(
    tileProps,
    uniqueIdProperty,
    map
  );
  if (!uniquePropertyValue || map.has(uniquePropertyValue)) {
    return;
  }
  let geometry = null;
  if (storeGeometry || spatialFilter) {
    const { positions } = data;
    const ringCoordinates = getRingCoordinatesFor(
      startIndex,
      endIndex,
      positions
    );
    geometry = getFeatureByType(ringCoordinates, type);
  }
  if (geometry && spatialFilter && !turf_boolean_intersects_default(geometry, spatialFilter)) {
    return;
  }
  const properties = parseProperties(tileProps);
  if (storeGeometry && geometry) {
    properties[FEATURE_GEOM_PROPERTY] = tileFormat === "mvt" /* MVT */ ? transformTileCoordsToWGS84(geometry, bbox2) : geometry;
  }
  map.set(uniquePropertyValue, properties);
}
function addIntersectedFeaturesInTile({
  map,
  data,
  spatialFilter,
  type,
  bbox: bbox2,
  tileFormat,
  uniqueIdProperty,
  options
}) {
  const indices = getIndices(data, type);
  const storeGeometry = options?.storeGeometry || false;
  for (let i = 0; i < indices.length - 1; i++) {
    const startIndex = indices[i];
    const endIndex = indices[i + 1];
    processTileFeatureProperties({
      map,
      data,
      startIndex,
      endIndex,
      type,
      bbox: bbox2,
      tileFormat,
      uniqueIdProperty,
      storeGeometry,
      spatialFilter
    });
  }
}
function getIndices(data, type) {
  let indices;
  switch (type) {
    case "Polygon":
      indices = data.primitivePolygonIndices;
      break;
    case "LineString":
      indices = data.pathIndices;
      break;
    case "Point":
      indices = createIndicesForPoints(data);
      break;
    default:
      throw new Error(
        `Unsupported geometry type: ${type}`
      );
  }
  return indices.value;
}
function getFeatureId(data, startIndex) {
  return data.featureIds.value[startIndex];
}
function getPropertiesFromTile(data, startIndex) {
  const featureId2 = getFeatureId(data, startIndex);
  const { properties, numericProps, fields } = data;
  const result = {
    uniqueId: fields?.[featureId2]?.id,
    properties: properties[featureId2],
    numericProps: {}
  };
  for (const key in numericProps) {
    result.numericProps[key] = numericProps[key].value[startIndex];
  }
  return result;
}
function parseProperties(tileProps) {
  const { properties, numericProps } = tileProps;
  return Object.assign({}, properties, numericProps);
}
function getUniquePropertyValue(tileProps, uniqueIdProperty, map) {
  if (uniqueIdProperty) {
    return getValueFromTileProps(tileProps, uniqueIdProperty);
  }
  if (tileProps.uniqueId) {
    return tileProps.uniqueId;
  }
  const artificialId = map.size + 1;
  return getValueFromTileProps(tileProps, "cartodb_id") || getValueFromTileProps(tileProps, "geoid") || artificialId;
}
function getValueFromTileProps(tileProps, propertyName) {
  const { properties, numericProps } = tileProps;
  return numericProps[propertyName] || properties[propertyName];
}
function getFeatureByType(coordinates, type) {
  switch (type) {
    case "Polygon":
      return { type: "Polygon", coordinates: [coordinates] };
    case "LineString":
      return { type: "LineString", coordinates };
    case "Point":
      return { type: "Point", coordinates: coordinates[0] };
    default:
      throw new Error("Invalid geometry type");
  }
}
function getRingCoordinatesFor(startIndex, endIndex, positions) {
  const ringCoordinates = [];
  for (let j = startIndex; j < endIndex; j++) {
    ringCoordinates.push(
      Array.from(
        positions.value.subarray(j * positions.size, (j + 1) * positions.size)
      )
    );
  }
  return ringCoordinates;
}
function calculateFeatures({
  map,
  spatialFilter,
  data,
  type,
  bbox: bbox2,
  tileFormat,
  uniqueIdProperty,
  options
}) {
  if (!data?.properties.length) {
    return;
  }
  if (!spatialFilter) {
    addAllFeaturesInTile({
      map,
      data,
      type,
      bbox: bbox2,
      tileFormat,
      uniqueIdProperty,
      options
    });
  } else {
    addIntersectedFeaturesInTile({
      map,
      data,
      spatialFilter,
      type,
      bbox: bbox2,
      tileFormat,
      uniqueIdProperty,
      options
    });
  }
}
function addAllFeaturesInTile({
  map,
  data,
  type,
  bbox: bbox2,
  tileFormat,
  uniqueIdProperty,
  options
}) {
  const indices = getIndices(data, type);
  const storeGeometry = options?.storeGeometry || false;
  for (let i = 0; i < indices.length - 1; i++) {
    const startIndex = indices[i];
    const endIndex = indices[i + 1];
    processTileFeatureProperties({
      map,
      data,
      startIndex,
      endIndex,
      type,
      bbox: bbox2,
      tileFormat,
      uniqueIdProperty,
      storeGeometry
    });
  }
}
function createIndicesForPoints(data) {
  const featureIds = data.featureIds.value;
  const lastFeatureId = featureIds[featureIds.length - 1];
  const PointIndicesArray = featureIds.constructor;
  const pointIndices = {
    value: new PointIndicesArray(featureIds.length + 1),
    size: 1
  };
  pointIndices.value.set(featureIds);
  pointIndices.value.set([lastFeatureId + 1], featureIds.length);
  return pointIndices;
}

// src/filters/tileFeaturesSpatialIndex.ts
init_cjs_shims();
var import_quadbin2 = require("quadbin");
var import_h3_js2 = require("h3-js");
function tileFeaturesSpatialIndex({
  tiles,
  spatialFilter,
  spatialDataColumn,
  spatialDataType
}) {
  const map = /* @__PURE__ */ new Map();
  const spatialIndex = getSpatialIndex(spatialDataType);
  const cellResolution = getResolution(tiles, spatialIndex);
  const spatialIndexIDName = spatialDataColumn ? spatialDataColumn : spatialIndex;
  if (!cellResolution) {
    return [];
  }
  let intersection3;
  if (spatialIndex === "h3" /* H3 */) {
    intersection3 = intersectTileH3(cellResolution, spatialFilter);
  }
  for (const tile of tiles) {
    if (tile.isVisible === false || !tile.data) {
      continue;
    }
    if (spatialIndex === "quadbin" /* QUADBIN */) {
      const parent = getTileIndex(tile, spatialIndex);
      intersection3 = intersectTileQuadbin(
        parent,
        cellResolution,
        spatialFilter
      );
    }
    if (!intersection3) continue;
    tile.data.forEach((d) => {
      if (intersection3 === true || intersection3.has(d.id)) {
        map.set(d.id, { ...d.properties, [spatialIndexIDName]: d.id });
      }
    });
  }
  return Array.from(map.values());
}
function getTileIndex(tile, spatialIndex) {
  if (spatialIndex === "quadbin" /* QUADBIN */) {
    return tile.index.q;
  }
  return tile.id;
}
function getResolution(tiles, spatialIndex) {
  const data = tiles.find((tile) => tile.data?.length)?.data;
  if (!data) {
    return;
  }
  if (spatialIndex === "quadbin" /* QUADBIN */) {
    return Number((0, import_quadbin2.getResolution)(data[0].id));
  }
  if (spatialIndex === "h3" /* H3 */) {
    return (0, import_h3_js2.getResolution)(data[0].id);
  }
}
function getSpatialIndex(spatialDataType) {
  switch (spatialDataType) {
    case "h3":
      return "h3" /* H3 */;
    case "quadbin":
      return "quadbin" /* QUADBIN */;
    default:
      throw new Error("Unexpected spatial data type");
  }
}

// src/constants-internal.ts
init_cjs_shims();
var V3_MINOR_VERSION = "3.4";
var DEFAULT_GEO_COLUMN = "geom";
var DEFAULT_MAX_LENGTH_URL = 7e3;
var DEFAULT_TILE_RESOLUTION = 0.5;
var REDUCED_QUERIES_TILE_RESOLUTION = 1;
var DEFAULT_AGGREGATION_RES_LEVEL_H3 = 4;
var DEFAULT_AGGREGATION_RES_LEVEL_QUADBIN = 6;
var DEFAULT_AGGREGATION_EXP_ALIAS = "__aggregationValue";
var DEFAULT_AGGREGATION_EXP = `1 AS ${DEFAULT_AGGREGATION_EXP_ALIAS}`;

// src/filters/tileFeaturesRaster.ts
init_cjs_shims();
var import_quadbin3 = require("quadbin");
function tileFeaturesRaster({
  tiles,
  ...options
}) {
  const metadataByBand = {};
  for (const band of options.rasterMetadata.bands) {
    metadataByBand[band.name] = { ...band, nodata: Number(band.nodata) };
  }
  tiles = tiles.filter(isRasterTileVisible);
  if (tiles.length === 0) return [];
  const tileResolution = (0, import_quadbin3.getResolution)(tiles[0].index.q);
  const tileBlockSize = tiles[0].data.blockSize;
  const cellResolution = tileResolution + BigInt(Math.log2(tileBlockSize));
  const data = /* @__PURE__ */ new Map();
  for (const tile of tiles) {
    const parent = tile.index.q;
    const intersection3 = intersectTileRaster(
      parent,
      cellResolution,
      options.spatialFilter
    );
    if (intersection3 === false) continue;
    const tileSortedCells = cellToChildrenRaster(parent, cellResolution);
    for (let i = 0; i < tileSortedCells.length; i++) {
      if (intersection3 !== true && !intersection3.has(tileSortedCells[i])) {
        continue;
      }
      const cellData = {};
      let cellDataExists = false;
      for (const band in tile.data.cells.numericProps) {
        const value = tile.data.cells.numericProps[band].value[i];
        const bandMetadata = metadataByBand[band];
        if (isValidBandValue(value, bandMetadata.nodata)) {
          cellData[band] = tile.data.cells.numericProps[band].value[i];
          cellDataExists = true;
        }
      }
      if (cellDataExists) {
        data.set(tileSortedCells[i], cellData);
      }
    }
  }
  return Array.from(data.values());
}
function isRasterTile(tile) {
  return !!tile.data?.cells;
}
function isRasterTileVisible(tile) {
  return !!(tile.isVisible && tile.data?.cells?.numericProps);
}
function cellToChildrenRaster(parent, resolution) {
  const parentTile = (0, import_quadbin3.cellToTile)(parent);
  const childZ = Number(resolution);
  const blockSize = 2 ** (childZ - parentTile.z);
  const childBaseX = parentTile.x * blockSize;
  const childBaseY = parentTile.y * blockSize;
  const cells = [];
  for (let i = 0, il = blockSize ** 2; i < il; i++) {
    const x = childBaseX + i % blockSize;
    const y = childBaseY + Math.floor(i / blockSize);
    cells.push((0, import_quadbin3.tileToCell)({ x, y, z: childZ }));
  }
  return cells;
}
function isValidBandValue(value, nodata) {
  return Number.isNaN(value) ? false : nodata !== value;
}

// src/utils.ts
init_cjs_shims();

// src/types.ts
init_cjs_shims();
var SchemaFieldType = /* @__PURE__ */ ((SchemaFieldType2) => {
  SchemaFieldType2["Number"] = "number";
  SchemaFieldType2["Bigint"] = "bigint";
  SchemaFieldType2["String"] = "string";
  SchemaFieldType2["Geometry"] = "geometry";
  SchemaFieldType2["Timestamp"] = "timestamp";
  SchemaFieldType2["Object"] = "object";
  SchemaFieldType2["Boolean"] = "boolean";
  SchemaFieldType2["Variant"] = "variant";
  SchemaFieldType2["Unknown"] = "unknown";
  return SchemaFieldType2;
})(SchemaFieldType || {});

// src/utils.ts
var FILTER_TYPES = new Set(Object.values(FilterType));
function normalizeObjectKeys(el) {
  if (Array.isArray(el)) {
    return el.map((value) => normalizeObjectKeys(value));
  } else if (typeof el !== "object") {
    return el;
  }
  return Object.entries(el).reduce(
    (acc, [key, value]) => {
      acc[key.toLowerCase()] = typeof value === "object" && value ? normalizeObjectKeys(value) : value;
      return acc;
    },
    {}
  );
}
function assert2(condition, message) {
  if (!condition) {
    throw new Error(message);
  }
}
var _InvalidColumnError = class _InvalidColumnError extends Error {
  constructor(message) {
    super(`${_InvalidColumnError.NAME}: ${message}`);
    this.name = _InvalidColumnError.NAME;
  }
  static is(error) {
    return error instanceof _InvalidColumnError || error.message?.includes(_InvalidColumnError.NAME);
  }
};
__publicField(_InvalidColumnError, "NAME", "InvalidColumnError");
var InvalidColumnError = _InvalidColumnError;
function isEmptyObject(object) {
  for (const _ in object) {
    return false;
  }
  return true;
}
var isObject2 = (x) => x !== null && typeof x === "object";
var isPureObject = (x) => isObject2(x) && x.constructor === {}.constructor;
function assignOptional(target, ...sources) {
  for (const source of sources) {
    for (const key in source) {
      if (source[key] !== void 0) {
        target[key] = source[key];
      }
    }
  }
  return target;
}
function getWidgetSpatialDataType(spatialDataType, spatialDataColumn, schema) {
  const field = schema.find((field2) => field2.name === spatialDataColumn);
  if (field && field.type === "geometry" /* Geometry */) {
    return "geo";
  }
  return spatialDataType;
}

// src/filters/tileFeatures.ts
function tileFeatures({
  tiles,
  spatialFilter,
  uniqueIdProperty,
  tileFormat,
  spatialDataColumn = DEFAULT_GEO_COLUMN,
  spatialDataType,
  rasterMetadata,
  storeGeometry = false
}) {
  if (spatialDataType === "geo") {
    return tileFeaturesGeometries({
      tiles,
      tileFormat,
      spatialFilter,
      uniqueIdProperty,
      options: { storeGeometry }
    });
  }
  if (tiles.some(isRasterTile)) {
    assert2(rasterMetadata, "Missing raster metadata");
    return tileFeaturesRaster({
      tiles,
      spatialFilter,
      spatialDataColumn,
      spatialDataType,
      rasterMetadata
    });
  }
  return tileFeaturesSpatialIndex({
    tiles,
    spatialFilter,
    spatialDataColumn,
    spatialDataType
  });
}

// src/deck/get-data-filter-extension-props.ts
var DEFAULT_FILTER_SIZE = 4;
function getDataFilterExtensionProps(filters, filtersLogicalOperator) {
  const { filtersWithoutTimeType, timeColumn, timeFilter } = getFiltersByType(filters);
  return {
    filterRange: getFilterRange(timeFilter, DEFAULT_FILTER_SIZE),
    updateTriggers: getUpdateTriggers(
      filtersWithoutTimeType,
      timeColumn,
      timeFilter
    ),
    getFilterValue: getFilterValue(
      filtersWithoutTimeType,
      timeColumn,
      timeFilter,
      DEFAULT_FILTER_SIZE,
      filtersLogicalOperator
    )
  };
}
function getFiltersByType(filters) {
  const filtersWithoutTimeType = {};
  let timeColumn = null;
  let timeFilter = null;
  for (const [column, columnData] of Object.entries(filters)) {
    for (const [type, typeData] of Object.entries(columnData)) {
      if (type === "time" /* TIME */) {
        timeColumn = column;
        timeFilter = typeData;
      } else {
        filtersWithoutTimeType[column] = { [type]: typeData };
      }
    }
  }
  return {
    filtersWithoutTimeType,
    timeColumn,
    timeFilter
  };
}
function getFilterRange(timeFilter, filterSize) {
  const result = Array(filterSize).fill([0, 0]);
  result[0] = [1, 1];
  if (timeFilter) {
    const offsetBy = timeFilter.params?.offsetBy || 0;
    result[1] = timeFilter.values[0].map((v2) => v2 - offsetBy);
  }
  return result;
}
function getUpdateTriggers(filtersWithoutTimeType, timeColumn, timeFilter) {
  const result = { ...filtersWithoutTimeType };
  if (timeColumn && timeFilter) {
    result[timeColumn] = {
      ...result[timeColumn],
      offsetBy: timeFilter.params?.offsetBy,
      ["time" /* TIME */]: {}
      // Allows working with other filters, without an impact on performance.
    };
  }
  return {
    getFilterValue: JSON.stringify(result)
  };
}
function getFilterValue(filtersWithoutTimeType, timeColumn, timeFilter, filterSize, filtersLogicalOperator) {
  const result = Array(filterSize).fill(0);
  const featureFilter = _buildFeatureFilter({
    filters: filtersWithoutTimeType,
    type: "number",
    filtersLogicalOperator
  });
  return (feature2) => {
    result[0] = featureFilter(feature2);
    if (timeColumn && timeFilter) {
      const offsetBy = timeFilter.params?.offsetBy || 0;
      const f = feature2.properties || feature2;
      result[1] = f[timeColumn] - offsetBy;
    }
    return result;
  };
}

// src/fetch-map/index.ts
init_cjs_shims();

// src/fetch-map/basemap-styles.ts
init_cjs_shims();

// src/api/index.ts
init_cjs_shims();

// src/api/carto-api-error.ts
init_cjs_shims();
var CartoAPIError = class extends Error {
  constructor(error, errorContext, response, responseJson) {
    let responseString = "Failed to connect";
    if (response) {
      responseString = "Server returned: ";
      if (response.status === 400) {
        responseString += "Bad request";
      } else if (response.status === 401 || response.status === 403) {
        responseString += "Unauthorized access";
      } else if (response.status === 404) {
        responseString += "Not found";
      } else {
        responseString += "Error";
      }
      responseString += ` (${response.status}):`;
    }
    responseString += ` ${error.message || error}`;
    let message = `${errorContext.requestType} API request failed`;
    message += `
${responseString}`;
    for (const key of Object.keys(errorContext)) {
      if (key === "requestType") continue;
      message += `
${formatErrorKey(key)}: ${errorContext[key]}`;
    }
    message += "\n";
    super(message);
    /** Source error from server */
    __publicField(this, "error");
    /** Context (API call & parameters) in which error occured */
    __publicField(this, "errorContext");
    /** Response from server */
    __publicField(this, "response");
    /** JSON Response from server */
    __publicField(this, "responseJson");
    this.name = "CartoAPIError";
    this.response = response;
    this.responseJson = responseJson;
    this.error = error;
    this.errorContext = errorContext;
  }
};
function formatErrorKey(key) {
  return key.replace(/([A-Z])/g, " $1").replace(/^./, (s) => s.toUpperCase());
}

// src/api/endpoints.ts
init_cjs_shims();
function joinPath(...args) {
  return args.map((part) => part.endsWith("/") ? part.slice(0, -1) : part).join("/");
}
function buildV3Path(apiBaseUrl, version, endpoint, ...rest) {
  return joinPath(apiBaseUrl, version, endpoint, ...rest);
}
function buildPublicMapUrl({
  apiBaseUrl,
  cartoMapId
}) {
  return buildV3Path(apiBaseUrl, "v3", "maps", "public", cartoMapId);
}
function buildStatsUrl({
  attribute,
  apiBaseUrl,
  connectionName,
  source,
  type
}) {
  if (type === "query") {
    return buildV3Path(apiBaseUrl, "v3", "stats", connectionName, attribute);
  }
  return buildV3Path(
    apiBaseUrl,
    "v3",
    "stats",
    connectionName,
    source,
    attribute
  );
}
function buildSourceUrl({
  apiBaseUrl,
  connectionName,
  endpoint
}) {
  return buildV3Path(apiBaseUrl, "v3", "maps", connectionName, endpoint);
}
function buildQueryUrl({
  apiBaseUrl,
  connectionName
}) {
  return buildV3Path(apiBaseUrl, "v3", "sql", connectionName, "query");
}

// src/api/query.ts
init_cjs_shims();

// src/sources/index.ts
init_cjs_shims();

// src/sources/boundary-query-source.ts
init_cjs_shims();

// src/sources/base-source.ts
init_cjs_shims();

// src/api/request-with-parameters.ts
init_cjs_shims();
var DEFAULT_HEADERS = {
  Accept: "application/json",
  "Content-Type": "application/json"
};
var DEFAULT_REQUEST_CACHE = /* @__PURE__ */ new Map();
async function requestWithParameters({
  baseUrl,
  parameters = {},
  headers: customHeaders = {},
  errorContext,
  maxLengthURL = DEFAULT_MAX_LENGTH_URL,
  localCache,
  signal
}) {
  parameters = {
    v: V3_MINOR_VERSION,
    client: getClient(),
    ...typeof deck !== "undefined" && deck.VERSION && { deckglVersion: deck.VERSION },
    ...parameters
  };
  baseUrl = excludeURLParameters(baseUrl, Object.keys(parameters));
  const key = createCacheKey(baseUrl, parameters, customHeaders);
  const {
    cache: REQUEST_CACHE,
    canReadCache,
    canStoreInCache
  } = getCacheSettings(localCache);
  if (canReadCache && REQUEST_CACHE.has(key)) {
    return REQUEST_CACHE.get(key);
  }
  const url = createURLWithParameters(baseUrl, parameters);
  const headers = { ...DEFAULT_HEADERS, ...customHeaders };
  const fetchPromise = url.length > maxLengthURL ? fetch(baseUrl, {
    method: "POST",
    body: JSON.stringify(parameters),
    headers,
    signal
  }) : fetch(url, { headers, signal });
  let response;
  let responseJson;
  const jsonPromise = fetchPromise.then((_response) => {
    response = _response;
    return response.json();
  }).then((json) => {
    responseJson = json;
    if (!response || !response.ok) {
      throw new Error(json.error);
    }
    return json;
  }).catch((error) => {
    if (canStoreInCache) {
      REQUEST_CACHE.delete(key);
    }
    throw new CartoAPIError(error, errorContext, response, responseJson);
  });
  if (canStoreInCache) {
    REQUEST_CACHE.set(key, jsonPromise);
  }
  return jsonPromise;
}
function getCacheSettings(localCache) {
  const canReadCache = localCache?.cacheControl?.includes("no-cache") ? false : true;
  const canStoreInCache = localCache?.cacheControl?.includes("no-store") ? false : true;
  const cache = localCache?.cache || DEFAULT_REQUEST_CACHE;
  return {
    cache,
    canReadCache,
    canStoreInCache
  };
}
function createCacheKey(baseUrl, parameters, headers) {
  const parameterEntries = Object.entries(parameters).sort(
    ([a], [b]) => a > b ? 1 : -1
  );
  const headerEntries = Object.entries(headers).sort(
    ([a], [b]) => a > b ? 1 : -1
  );
  return JSON.stringify({
    baseUrl,
    parameters: parameterEntries,
    headers: headerEntries
  });
}
function createURLWithParameters(baseUrlString, parameters) {
  const baseUrl = new URL(baseUrlString);
  for (const [key, value] of Object.entries(parameters)) {
    if (isPureObject(value) || Array.isArray(value)) {
      baseUrl.searchParams.set(key, JSON.stringify(value));
    } else {
      if (value !== null && value !== void 0) {
        baseUrl.searchParams.set(
          key,
          value.toString()
        );
      }
    }
  }
  return baseUrl.toString();
}
function excludeURLParameters(baseUrlString, parameters) {
  const baseUrl = new URL(baseUrlString);
  for (const param of parameters) {
    if (baseUrl.searchParams.has(param)) {
      baseUrl.searchParams.delete(param);
    }
  }
  return baseUrl.toString();
}
function clearDefaultRequestCache() {
  DEFAULT_REQUEST_CACHE.clear();
}

// src/sources/base-source.ts
var SOURCE_DEFAULTS = {
  apiBaseUrl: DEFAULT_API_BASE_URL,
  headers: {},
  maxLengthURL: DEFAULT_MAX_LENGTH_URL
};
async function baseSource(endpoint, options, urlParameters) {
  const { accessToken, connectionName, cache, ...optionalOptions } = options;
  const mergedOptions = {
    ...SOURCE_DEFAULTS,
    clientId: getClient(),
    accessToken,
    connectionName,
    endpoint
  };
  for (const key in optionalOptions) {
    if (optionalOptions[key]) {
      mergedOptions[key] = optionalOptions[key];
    }
  }
  const baseUrl = buildSourceUrl(mergedOptions);
  const { clientId, maxLengthURL, localCache } = mergedOptions;
  const headers = {
    Authorization: `Bearer ${options.accessToken}`,
    ...options.headers
  };
  const parameters = { client: clientId, ...options.tags, ...urlParameters };
  const errorContext = {
    requestType: "Map instantiation",
    connection: options.connectionName,
    type: endpoint,
    source: JSON.stringify(parameters, void 0, 2)
  };
  const { tilejson, schema } = await requestWithParameters({
    baseUrl,
    parameters,
    headers,
    errorContext,
    maxLengthURL,
    localCache
  });
  const dataUrl = tilejson.url[0];
  if (cache) {
    cache.value = parseInt(
      new URL(dataUrl).searchParams.get("cache") || "",
      10
    );
  }
  errorContext.requestType = "Map data";
  const json = await requestWithParameters({
    baseUrl: dataUrl,
    parameters: { client: clientId },
    headers,
    errorContext,
    maxLengthURL,
    localCache
  });
  if (accessToken) {
    json.accessToken = accessToken;
  }
  if (schema) {
    json.schema = schema;
  }
  return json;
}

// src/sources/boundary-query-source.ts
var boundaryQuerySource = async function(options) {
  const {
    columns,
    filters,
    tilesetTableName,
    propertiesSqlQuery,
    queryParameters
  } = options;
  const urlParameters = {
    tilesetTableName,
    propertiesSqlQuery
  };
  if (columns) {
    urlParameters.columns = columns.join(",");
  }
  if (filters) {
    urlParameters.filters = filters;
  }
  if (queryParameters) {
    urlParameters.queryParameters = queryParameters;
  }
  return baseSource("boundary", options, urlParameters);
};

// src/sources/boundary-table-source.ts
init_cjs_shims();
var boundaryTableSource = async function(options) {
  const { filters, tilesetTableName, columns, propertiesTableName } = options;
  const urlParameters = {
    tilesetTableName,
    propertiesTableName
  };
  if (columns) {
    urlParameters.columns = columns.join(",");
  }
  if (filters) {
    urlParameters.filters = filters;
  }
  return baseSource("boundary", options, urlParameters);
};

// src/sources/h3-query-source.ts
init_cjs_shims();

// src/widget-sources/widget-source.ts
init_cjs_shims();
var _WidgetSource = class _WidgetSource {
  constructor(props) {
    __publicField(this, "props");
    this.props = {
      ..._WidgetSource.defaultProps,
      clientId: getClient(),
      // Refresh clientId, default may have changed.
      ...props
    };
  }
  /**
   * Destroys the widget source and releases allocated resources.
   *
   * For remote sources (tables, queries) this has no effect, but for local
   * sources (tilesets, rasters) these resources will affect performance
   * and stability if many (10+) sources are created and not released.
   */
  destroy() {
  }
};
__publicField(_WidgetSource, "defaultProps", {
  apiVersion: "v3" /* V3 */,
  apiBaseUrl: DEFAULT_API_BASE_URL,
  clientId: getClient(),
  filters: {},
  filtersLogicalOperator: "and"
});
var WidgetSource = _WidgetSource;

// src/widget-sources/widget-query-source.ts
init_cjs_shims();

// src/widget-sources/widget-remote-source.ts
init_cjs_shims();

// src/models/index.ts
init_cjs_shims();

// src/models/model.ts
init_cjs_shims();

// src/models/common.ts
init_cjs_shims();
function dealWithApiError({
  response,
  data
}) {
  if (data.error === "Column not found") {
    throw new InvalidColumnError(`${data.error} ${data.column_name}`);
  }
  if (typeof data.error === "string" && data.error?.includes("Missing columns")) {
    throw new InvalidColumnError(data.error);
  }
  switch (response.status) {
    case 401:
      throw new Error("Unauthorized access. Invalid credentials");
    case 403:
      throw new Error("Forbidden access to the requested data");
    default:
      throw new Error(
        data && data.error && typeof data.error === "string" ? data.error : JSON.stringify(data?.hint || data.error?.[0])
      );
  }
}
async function makeCall({
  url,
  accessToken,
  opts
}) {
  let response;
  let data;
  const isPost = opts?.method === "POST";
  try {
    response = await fetch(url.toString(), {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        ...isPost && { "Content-Type": "application/json" },
        ...opts.headers
      },
      ...isPost && {
        method: opts?.method,
        body: opts?.body
      },
      signal: opts?.signal,
      ...opts?.otherOptions
    });
    data = await response.json();
  } catch (error) {
    if (error.name === "AbortError") throw error;
    throw new Error(`Failed request: ${error}`);
  }
  if (!response.ok) {
    dealWithApiError({ response, data });
  }
  return data;
}

// src/models/model.ts
var AVAILABLE_MODELS = [
  "category",
  "histogram",
  "formula",
  "pick",
  "timeseries",
  "range",
  "scatterplot",
  "table",
  "aggregations"
];
var { V3 } = ApiVersion;
var REQUEST_GET_MAX_URL_LENGTH = 2048;
function executeModel(props) {
  assert2(props.source, "executeModel: missing source");
  assert2(props.model, "executeModel: missing model");
  assert2(props.params, "executeModel: missing params");
  assert2(
    AVAILABLE_MODELS.includes(props.model),
    `executeModel: model provided isn't valid. Available models: ${AVAILABLE_MODELS.join(
      ", "
    )}`
  );
  const { model, source, params, opts } = props;
  const { type, apiVersion, apiBaseUrl, accessToken, connectionName, clientId } = source;
  assert2(apiBaseUrl, "executeModel: missing apiBaseUrl");
  assert2(accessToken, "executeModel: missing accessToken");
  assert2(apiVersion === V3, "executeModel: SQL Model API requires CARTO 3+");
  assert2(type !== "tileset", "executeModel: Tilesets not supported");
  let url = `${apiBaseUrl}/v3/sql/${connectionName}/model/${model}`;
  const {
    data,
    filters,
    filtersLogicalOperator = "and",
    spatialDataType = "geo",
    spatialDataColumn = DEFAULT_GEO_COLUMN,
    spatialFiltersMode = "intersects",
    tags
  } = source;
  const queryParams = {
    type,
    client: clientId,
    source: data,
    params,
    queryParameters: source.queryParameters || "",
    filters,
    filtersLogicalOperator,
    ...tags ?? {}
  };
  queryParams.spatialDataType = spatialDataType;
  queryParams.spatialDataColumn = spatialDataColumn;
  if (source.spatialFilter) {
    queryParams.spatialFilters = { [spatialDataColumn]: source.spatialFilter };
    if (spatialDataType !== "geo") {
      queryParams.spatialFiltersMode = spatialFiltersMode;
    }
  }
  const urlWithSearchParams = url + "?" + objectToURLSearchParams(queryParams).toString();
  const isGet = urlWithSearchParams.length <= REQUEST_GET_MAX_URL_LENGTH;
  if (isGet) {
    url = urlWithSearchParams;
  }
  return makeCall({
    url,
    accessToken: source.accessToken,
    opts: {
      ...opts,
      method: isGet ? "GET" : "POST",
      ...!isGet && { body: JSON.stringify(queryParams) }
    }
  });
}
function objectToURLSearchParams(object) {
  const params = new URLSearchParams();
  for (const key in object) {
    if (isPureObject(object[key])) {
      params.append(key, JSON.stringify(object[key]));
    } else if (Array.isArray(object[key])) {
      params.append(key, JSON.stringify(object[key]));
    } else if (object[key] === null) {
      params.append(key, "null");
    } else if (object[key] !== void 0) {
      params.append(key, String(object[key]));
    }
  }
  return params;
}

// src/filters.ts
init_cjs_shims();
var FILTER_TYPES2 = new Set(Object.values(FilterType));
var isFilterType = (type) => FILTER_TYPES2.has(type);
function addFilter(filters, { column, type, values, owner }) {
  if (!filters[column]) {
    filters[column] = {};
  }
  const filter = { values, owner };
  filters[column][type] = filter;
  return filters;
}
function removeFilter(filters, { column, owner }) {
  const filter = filters[column];
  if (!filter) {
    return filters;
  }
  if (owner) {
    for (const type of FILTER_TYPES2) {
      if (owner === filter[type]?.owner) {
        delete filter[type];
      }
    }
  }
  if (!owner || isEmptyObject(filter)) {
    delete filters[column];
  }
  return filters;
}
function clearFilters(filters) {
  for (const column of Object.keys(filters)) {
    delete filters[column];
  }
  return filters;
}
function hasFilter(filters, { column, owner }) {
  const filter = filters[column];
  if (!filter) {
    return false;
  }
  if (!owner) {
    return true;
  }
  for (const type of FILTER_TYPES2) {
    if (owner === filter[type]?.owner) {
      return true;
    }
  }
  return false;
}
function getFilter(filters, { column, type, owner }) {
  const filter = filters[column];
  if (!filter) {
    return null;
  }
  if (!owner || owner === filter[type]?.owner) {
    return filter[type] || null;
  }
  return null;
}
function getApplicableFilters(owner, filters) {
  if (!filters) return {};
  const applicableFilters = {};
  for (const column in filters) {
    for (const type in filters[column]) {
      if (!isFilterType(type)) continue;
      const filter = filters[column][type];
      const isApplicable = !owner || !filter?.owner || filter?.owner !== owner;
      if (filter && isApplicable) {
        applicableFilters[column] || (applicableFilters[column] = {});
        applicableFilters[column][type] = filter;
      }
    }
  }
  return applicableFilters;
}

// src/widget-sources/constants.ts
init_cjs_shims();
var OTHERS_CATEGORY_NAME = "_carto_others";

// src/widget-sources/widget-remote-source.ts
var WidgetRemoteSource = class extends WidgetSource {
  _getModelSource(filters, filterOwner) {
    const props = this.props;
    return {
      apiVersion: props.apiVersion,
      apiBaseUrl: props.apiBaseUrl,
      clientId: props.clientId,
      accessToken: props.accessToken,
      connectionName: props.connectionName,
      filters: getApplicableFilters(filterOwner, filters || props.filters),
      filtersLogicalOperator: props.filtersLogicalOperator,
      spatialDataType: props.spatialDataType,
      spatialDataColumn: props.spatialDataColumn,
      tags: props.tags
    };
  }
  async getCategories(options) {
    const {
      signal,
      filters = this.props.filters,
      filterOwner,
      spatialFilter,
      spatialFiltersMode,
      rawResult,
      ...params
    } = options;
    const {
      column,
      operation: operation2,
      operationColumn,
      operationExp,
      othersThreshold,
      orderBy
    } = params;
    if (operation2 === AggregationTypes.Custom) {
      assert2(operationExp, "operationExp is required for custom operation");
    }
    const result = await executeModel({
      model: "category",
      source: {
        ...this.getModelSource(filters, filterOwner),
        spatialFiltersMode,
        spatialFilter
      },
      params: {
        column,
        operation: operation2,
        operationExp,
        operationColumn: operationColumn || column,
        othersThreshold,
        orderBy
      },
      opts: { signal, headers: this.props.headers }
    });
    const normalizedRows = normalizeObjectKeys(result.rows || []);
    if (rawResult) {
      return result;
    }
    if (!othersThreshold) {
      return normalizedRows;
    }
    return [
      ...normalizedRows,
      { name: OTHERS_CATEGORY_NAME, value: result?.metadata?.others }
    ];
  }
  async getFeatures(options) {
    const {
      signal,
      filters = this.props.filters,
      filterOwner,
      spatialFilter,
      spatialFiltersMode,
      ...params
    } = options;
    const { columns, dataType, featureIds, z, limit, tileResolution } = params;
    return executeModel({
      model: "pick",
      source: {
        ...this.getModelSource(filters, filterOwner),
        spatialFiltersMode,
        spatialFilter
      },
      params: {
        columns,
        dataType,
        featureIds,
        z,
        limit: limit || 1e3,
        tileResolution: tileResolution || DEFAULT_TILE_RESOLUTION
      },
      opts: { signal, headers: this.props.headers }
      // Avoid `normalizeObjectKeys()`, which changes column names.
    }).then(({ rows }) => ({ rows }));
  }
  async getFormula(options) {
    const {
      signal,
      filters = this.props.filters,
      filterOwner,
      spatialFilter,
      spatialFiltersMode,
      operationExp,
      ...params
    } = options;
    const { column, operation: operation2 } = params;
    if (operation2 === AggregationTypes.Custom) {
      assert2(operationExp, "operationExp is required for custom operation");
    }
    return executeModel({
      model: "formula",
      source: {
        ...this.getModelSource(filters, filterOwner),
        spatialFiltersMode,
        spatialFilter
      },
      params: {
        column: column ?? "*",
        operation: operation2 ?? AggregationTypes.Count,
        operationExp
      },
      opts: { signal, headers: this.props.headers }
    }).then((res) => normalizeObjectKeys(res.rows[0]));
  }
  async getHistogram(options) {
    const {
      signal,
      filters = this.props.filters,
      filterOwner,
      spatialFilter,
      spatialFiltersMode,
      ...params
    } = options;
    const { column, operation: operation2, ticks } = params;
    const data = await executeModel({
      model: "histogram",
      source: {
        ...this.getModelSource(filters, filterOwner),
        spatialFiltersMode,
        spatialFilter
      },
      params: { column, operation: operation2, ticks },
      opts: { signal, headers: this.props.headers }
    }).then((res) => normalizeObjectKeys(res.rows));
    if (data.length) {
      const result = Array(ticks.length + 1).fill(0);
      data.forEach(
        ({ tick, value }) => result[tick] = value
      );
      return result;
    }
    return [];
  }
  async getRange(options) {
    const {
      signal,
      filters = this.props.filters,
      filterOwner,
      spatialFilter,
      spatialFiltersMode,
      ...params
    } = options;
    const { column } = params;
    return executeModel({
      model: "range",
      source: {
        ...this.getModelSource(filters, filterOwner),
        spatialFiltersMode,
        spatialFilter
      },
      params: { column },
      opts: { signal, headers: this.props.headers }
    }).then((res) => normalizeObjectKeys(res.rows[0]));
  }
  async getScatter(options) {
    const {
      signal,
      filters = this.props.filters,
      filterOwner,
      spatialFilter,
      spatialFiltersMode,
      ...params
    } = options;
    const { xAxisColumn, xAxisJoinOperation, yAxisColumn, yAxisJoinOperation } = params;
    const HARD_LIMIT = 500;
    return executeModel({
      model: "scatterplot",
      source: {
        ...this.getModelSource(filters, filterOwner),
        spatialFiltersMode,
        spatialFilter
      },
      params: {
        xAxisColumn,
        xAxisJoinOperation,
        yAxisColumn,
        yAxisJoinOperation,
        limit: HARD_LIMIT
      },
      opts: { signal, headers: this.props.headers }
    }).then((res) => normalizeObjectKeys(res.rows)).then((res) => res.map(({ x, y }) => [x, y]));
  }
  async getTable(options) {
    const {
      signal,
      filters = this.props.filters,
      filterOwner,
      spatialFilter,
      spatialFiltersMode,
      ...params
    } = options;
    const { columns, sortBy, sortDirection, offset = 0, limit = 10 } = params;
    return executeModel({
      model: "table",
      source: {
        ...this.getModelSource(filters, filterOwner),
        spatialFiltersMode,
        spatialFilter
      },
      params: {
        column: columns,
        sortBy,
        sortDirection,
        limit,
        offset
      },
      opts: { signal, headers: this.props.headers }
    }).then((res) => ({
      // Avoid `normalizeObjectKeys()`, which changes column names.
      rows: res.rows ?? res.ROWS,
      totalCount: res.metadata?.total ?? res.METADATA?.TOTAL
    }));
  }
  async getTimeSeries(options) {
    const {
      signal,
      filters = this.props.filters,
      filterOwner,
      spatialFilter,
      spatialFiltersMode,
      ...params
    } = options;
    const {
      column,
      operationColumn,
      joinOperation,
      operation: operation2,
      operationExp,
      stepSize,
      stepMultiplier,
      splitByCategory,
      splitByCategoryLimit,
      splitByCategoryValues
    } = params;
    if (operation2 === AggregationTypes.Custom) {
      assert2(operationExp, "operationExp is required for custom operation");
    }
    return executeModel({
      model: "timeseries",
      source: {
        ...this.getModelSource(filters, filterOwner),
        spatialFiltersMode,
        spatialFilter
      },
      params: {
        column,
        stepSize,
        stepMultiplier,
        operationColumn: operationColumn || column,
        joinOperation,
        operation: operation2,
        operationExp,
        splitByCategory,
        splitByCategoryLimit,
        splitByCategoryValues
      },
      opts: { signal, headers: this.props.headers }
    }).then((res) => ({
      rows: normalizeObjectKeys(res.rows),
      categories: res.metadata?.categories
    }));
  }
  async getAggregations(options) {
    const {
      signal,
      filters = this.props.filters,
      filterOwner,
      spatialFilter,
      spatialFiltersMode,
      aggregations
    } = options;
    return executeModel({
      model: "aggregations",
      source: {
        ...this.getModelSource(filters, filterOwner),
        spatialFiltersMode,
        spatialFilter
      },
      params: {
        aggregations
      },
      opts: { signal, headers: this.props.headers }
    }).then((res) => ({
      rows: res.rows.map((row) => normalizeObjectKeys(row))
    }));
  }
  /** @experimental */
  async getExtent(options = {}) {
    const { signal, filters = this.props.filters, filterOwner } = options;
    const {
      type,
      data,
      apiBaseUrl,
      apiVersion,
      connectionName,
      spatialDataColumn,
      spatialDataType,
      queryParameters
    } = this.getModelSource(filters, filterOwner);
    assert2(apiVersion === "v3" /* V3 */, "Stats API requires CARTO 3+");
    let url;
    const parameters = { filters, spatialDataType };
    if (type === "query") {
      url = `${apiBaseUrl}/${apiVersion}/stats/${connectionName}/${spatialDataColumn}`;
      parameters.q = data;
      parameters.queryParameters = queryParameters;
    } else {
      url = `${apiBaseUrl}/${apiVersion}/stats/${connectionName}/${data}/${spatialDataColumn}`;
    }
    const headers = {
      Authorization: `Bearer ${this.props.accessToken}`,
      ...this.props.headers
    };
    const errorContext = {
      requestType: "Tile stats",
      connection: connectionName,
      type
    };
    return requestWithParameters({
      baseUrl: url,
      headers,
      signal,
      errorContext,
      parameters
    }).then(({ extent: { xmin, ymin, xmax, ymax } }) => ({
      bbox: [xmin, ymin, xmax, ymax]
    }));
  }
};

// src/widget-sources/widget-query-source.ts
var WidgetQuerySource = class extends WidgetRemoteSource {
  getModelSource(filters, filterOwner) {
    return {
      ...super._getModelSource(filters, filterOwner),
      type: "query",
      data: this.props.sqlQuery,
      queryParameters: this.props.queryParameters
    };
  }
};

// src/widget-sources/widget-raster-source.ts
init_cjs_shims();

// src/widget-sources/widget-tileset-source.ts
init_cjs_shims();

// src/widget-sources/widget-tileset-source-impl.ts
init_cjs_shims();

// src/operations/aggregation.ts
init_cjs_shims();
var aggregationFunctions = {
  count: (values) => values.length,
  min: (...args) => applyAggregationFunction(min, ...args),
  max: (...args) => applyAggregationFunction(max, ...args),
  sum: (...args) => applyAggregationFunction(sum2, ...args),
  avg: (...args) => applyAggregationFunction(avg, ...args)
};
function aggregate(feature2, keys, operation2) {
  if (!keys?.length) {
    throw new Error("Cannot aggregate a feature without having keys");
  } else if (keys.length === 1) {
    const value = feature2[keys[0]];
    return isPotentiallyValidNumber(value) ? Number(value) : value;
  }
  const aggregationFn = aggregationFunctions[operation2];
  if (!aggregationFn) {
    throw new Error(`${operation2} isn't a valid aggregation function`);
  }
  return aggregationFn(
    keys.map((column) => {
      const value = feature2[column];
      return isPotentiallyValidNumber(value) ? Number(value) : value;
    })
  );
}
function isPotentiallyValidNumber(value) {
  return typeof value === "string" && value.trim().length > 0;
}
var applyAggregationFunction = (aggFn, values, keys, operation2) => {
  const normalizedKeys = normalizeKeys(keys);
  const elements = (normalizedKeys?.length || 0) <= 1 ? filterFalsyElements(values, normalizedKeys || []) : values;
  return aggFn(elements, keys, operation2);
};
function filterFalsyElements(values, keys) {
  const filterFn = (value) => value !== null && value !== void 0;
  if (!keys?.length) {
    return values.filter(filterFn);
  }
  return values.filter((v2) => filterFn(v2[keys[0]]));
}
function avg(values, keys, joinOperation) {
  return sum2(values, keys, joinOperation) / (values.length || 1);
}
function sum2(values, keys, joinOperation) {
  const normalizedKeys = normalizeKeys(keys);
  if (normalizedKeys) {
    return values.reduce(
      (a, b) => a + aggregate(b, normalizedKeys, joinOperation),
      0
    );
  }
  return values.reduce((a, b) => a + b, 0);
}
function min(values, keys, joinOperation) {
  const normalizedKeys = normalizeKeys(keys);
  if (normalizedKeys) {
    return values.reduce(
      (a, b) => Math.min(a, aggregate(b, normalizedKeys, joinOperation)),
      Infinity
    );
  }
  let min2 = Number.POSITIVE_INFINITY;
  for (const value of values) {
    min2 = Math.min(min2, value);
  }
  return min2;
}
function max(values, keys, joinOperation) {
  const normalizedKeys = normalizeKeys(keys);
  if (normalizedKeys) {
    return values.reduce(
      (a, b) => Math.max(a, aggregate(b, normalizedKeys, joinOperation)),
      -Infinity
    );
  }
  let max2 = Number.NEGATIVE_INFINITY;
  for (const value of values) {
    max2 = Math.max(max2, value);
  }
  return max2;
}
function normalizeKeys(keys) {
  return Array.isArray(keys) ? keys : typeof keys === "string" ? [keys] : void 0;
}

// src/operations/applySorting.ts
init_cjs_shims();
var import_thenby = __toESM(require_thenBy_module(), 1);
function applySorting(features, {
  sortBy,
  sortByDirection = "asc",
  sortByColumnType = "string"
} = {}) {
  if (sortBy === void 0) {
    return features;
  }
  const isValidSortBy = Array.isArray(sortBy) && sortBy.length || // sortBy can be an array of columns
  typeof sortBy === "string";
  if (!isValidSortBy) {
    throw new Error("Sorting options are bad formatted");
  }
  const sortFn = createSortFn({
    sortBy,
    sortByDirection,
    sortByColumnType: sortByColumnType || "string"
  });
  return features.sort(sortFn);
}
function createSortFn({
  sortBy,
  sortByDirection,
  sortByColumnType
}) {
  const [firstSortOption, ...othersSortOptions] = normalizeSortByOptions({
    sortBy,
    sortByDirection,
    sortByColumnType
  });
  let sortFn = (0, import_thenby.firstBy)(...firstSortOption);
  for (const sortOptions of othersSortOptions) {
    sortFn = sortFn.thenBy(...sortOptions);
  }
  return sortFn;
}
function normalizeSortByOptions({
  sortBy,
  sortByDirection,
  sortByColumnType
}) {
  const numberFormat = sortByColumnType === "number" && {
    cmp: (a, b) => a - b
  };
  if (!Array.isArray(sortBy)) {
    sortBy = [sortBy];
  }
  return sortBy.map((sortByEl) => {
    if (typeof sortByEl === "string") {
      return [sortByEl, { direction: sortByDirection, ...numberFormat }];
    }
    if (Array.isArray(sortByEl)) {
      if (sortByEl[1] === void 0) {
        return [sortByEl, { direction: sortByDirection, ...numberFormat }];
      }
      if (typeof sortByEl[1] === "object") {
        const othersSortOptions = numberFormat ? { ...numberFormat, ...sortByEl[1] } : sortByEl[1];
        return [
          sortByEl[0],
          { direction: sortByDirection, ...othersSortOptions }
        ];
      }
    }
    return sortByEl;
  });
}

// src/operations/groupBy.ts
init_cjs_shims();
function groupValuesByColumn({
  data,
  valuesColumns,
  joinOperation,
  keysColumn,
  operation: operation2,
  othersThreshold,
  orderBy = "frequency_desc"
}) {
  if (Array.isArray(data) && data.length === 0) {
    return { rows: null };
  }
  const groups = data.reduce((accumulator, item) => {
    const group2 = item[keysColumn];
    const values = accumulator.get(group2) || [];
    accumulator.set(group2, values);
    const aggregatedValue = aggregate(item, valuesColumns, joinOperation);
    const isValid = (operation2 === "count" ? true : aggregatedValue !== null) && aggregatedValue !== void 0;
    if (isValid) {
      values.push(aggregatedValue);
      accumulator.set(group2, values);
    }
    return accumulator;
  }, /* @__PURE__ */ new Map());
  const targetOperation = aggregationFunctions[operation2];
  if (!targetOperation) {
    return { rows: [] };
  }
  const allCategories = Array.from(groups).map(([name, value]) => ({
    name,
    value: targetOperation(value)
  })).sort(getSorter(orderBy));
  if (othersThreshold && allCategories.length > othersThreshold) {
    const otherValue = allCategories.slice(othersThreshold).flatMap(({ name }) => groups.get(name));
    return {
      rows: allCategories,
      metadata: {
        others: targetOperation(otherValue)
      }
    };
  }
  return {
    rows: allCategories
  };
}
function getSorter(orderBy) {
  switch (orderBy) {
    case "frequency_asc":
      return (a, b) => a.value - b.value || nameCompare(a.name, b.name);
    case "frequency_desc":
      return (a, b) => b.value - a.value || nameCompare(a.name, b.name);
    case "alphabetical_asc":
      return (a, b) => nameCompare(a.name, b.name) || b.value - a.value;
    case "alphabetical_desc":
      return (a, b) => nameCompare(b.name, a.name) || b.value - a.value;
  }
}
function nameCompare(a, b) {
  if (typeof a === "number" && typeof b === "number") {
    return a - b;
  }
  return String(a ?? "null").localeCompare(String(b ?? "null"));
}

// src/operations/groupByDate.ts
init_cjs_shims();

// src/utils/dateUtils.ts
init_cjs_shims();
function getUTCMonday(date) {
  const dateCp = new Date(date);
  const day = dateCp.getUTCDay();
  const diff = dateCp.getUTCDate() - day + (day ? 1 : -6);
  dateCp.setUTCDate(diff);
  return Date.UTC(
    dateCp.getUTCFullYear(),
    dateCp.getUTCMonth(),
    dateCp.getUTCDate()
  );
}

// src/operations/groupByDate.ts
var GROUP_KEY_FN_MAPPING = {
  year: (date) => Date.UTC(date.getUTCFullYear()),
  month: (date) => Date.UTC(date.getUTCFullYear(), date.getUTCMonth()),
  week: (date) => getUTCMonday(date),
  day: (date) => Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()),
  hour: (date) => Date.UTC(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
    date.getUTCHours()
  ),
  minute: (date) => Date.UTC(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
    date.getUTCHours(),
    date.getUTCMinutes()
  ),
  second: (date) => Date.UTC(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
    date.getUTCHours(),
    date.getUTCMinutes(),
    date.getUTCSeconds()
  )
};
function groupValuesByDateColumn({
  data,
  valuesColumns,
  joinOperation,
  keysColumn,
  groupType,
  operation: operation2
}) {
  if (Array.isArray(data) && data.length === 0) {
    return null;
  }
  const groupKeyFn = GROUP_KEY_FN_MAPPING[groupType];
  if (!groupKeyFn) {
    return null;
  }
  const groups = data.reduce((acc, item) => {
    const value = item[keysColumn];
    const formattedValue = new Date(value);
    const groupKey = groupKeyFn(formattedValue);
    if (!isNaN(groupKey)) {
      let groupedValues = acc.get(groupKey);
      if (!groupedValues) {
        groupedValues = [];
        acc.set(groupKey, groupedValues);
      }
      const aggregatedValue = aggregate(item, valuesColumns, joinOperation);
      const isValid = aggregatedValue !== null && aggregatedValue !== void 0;
      if (isValid) {
        groupedValues.push(aggregatedValue);
        acc.set(groupKey, groupedValues);
      }
    }
    return acc;
  }, /* @__PURE__ */ new Map());
  const targetOperation = aggregationFunctions[operation2];
  return [...groups.entries()].map(([name, value]) => ({
    name,
    value: targetOperation(value)
  })).sort((a, b) => a.name - b.name);
}

// src/operations/histogram.ts
init_cjs_shims();
function histogram({
  data,
  valuesColumns,
  joinOperation,
  ticks,
  operation: operation2
}) {
  if (Array.isArray(data) && data.length === 0) {
    return [];
  }
  const binsContainer = [Number.MIN_SAFE_INTEGER, ...ticks].map(
    (tick, index, arr) => ({
      bin: index,
      start: tick,
      end: index === arr.length - 1 ? Number.MAX_SAFE_INTEGER : arr[index + 1],
      values: []
    })
  );
  data.forEach((feature2) => {
    const featureValue = aggregate(
      feature2,
      valuesColumns,
      joinOperation
    );
    const isValid = featureValue !== null && featureValue !== void 0;
    if (!isValid) {
      return;
    }
    const binContainer = binsContainer.find(
      (bin) => bin.start <= featureValue && bin.end > featureValue
    );
    if (!binContainer) {
      return;
    }
    binContainer.values.push(featureValue);
  });
  const targetOperation = aggregationFunctions[operation2];
  const transformedBins = binsContainer.map(
    (binContainer) => binContainer.values
  );
  return transformedBins.map(
    (values) => values.length ? targetOperation(values) : 0
  );
}

// src/operations/scatterPlot.ts
init_cjs_shims();
function scatterPlot({
  data,
  xAxisColumns,
  xAxisJoinOperation,
  yAxisColumns,
  yAxisJoinOperation
}) {
  return data.reduce(
    (acc, feature2) => {
      const xValue = aggregate(
        feature2,
        xAxisColumns,
        xAxisJoinOperation
      );
      const xIsValid = xValue !== null && xValue !== void 0;
      const yValue = aggregate(
        feature2,
        yAxisColumns,
        yAxisJoinOperation
      );
      const yIsValid = yValue !== null && yValue !== void 0;
      if (xIsValid && yIsValid) {
        acc.push([xValue, yValue]);
      }
      return acc;
    },
    []
  );
}

// node_modules/@turf/boolean-equal/dist/esm/index.js
init_cjs_shims();

// node_modules/geojson-equality-ts/dist/esm/index.js
init_cjs_shims();
var __defProp2 = Object.defineProperty;
var __name = (target, value) => __defProp2(target, "name", { value, configurable: true });
var _GeojsonEquality = class _GeojsonEquality2 {
  constructor(opts) {
    this.direction = false;
    this.compareProperties = true;
    var _a2, _b2, _c;
    this.precision = 10 ** -((_a2 = opts == null ? void 0 : opts.precision) != null ? _a2 : 17);
    this.direction = (_b2 = opts == null ? void 0 : opts.direction) != null ? _b2 : false;
    this.compareProperties = (_c = opts == null ? void 0 : opts.compareProperties) != null ? _c : true;
  }
  compare(g1, g2) {
    if (g1.type !== g2.type) {
      return false;
    }
    if (!sameLength(g1, g2)) {
      return false;
    }
    switch (g1.type) {
      case "Point":
        return this.compareCoord(g1.coordinates, g2.coordinates);
      case "LineString":
        return this.compareLine(g1.coordinates, g2.coordinates);
      case "Polygon":
        return this.comparePolygon(g1, g2);
      case "GeometryCollection":
        return this.compareGeometryCollection(g1, g2);
      case "Feature":
        return this.compareFeature(g1, g2);
      case "FeatureCollection":
        return this.compareFeatureCollection(g1, g2);
      default:
        if (g1.type.startsWith("Multi")) {
          const g1s = explode(g1);
          const g2s = explode(
            g2
          );
          return g1s.every(
            (g1part) => g2s.some((g2part) => this.compare(g1part, g2part))
          );
        }
    }
    return false;
  }
  compareCoord(c1, c2) {
    return c1.length === c2.length && c1.every((c, i) => Math.abs(c - c2[i]) < this.precision);
  }
  compareLine(path1, path2, ind = 0, isPoly = false) {
    if (!sameLength(path1, path2)) {
      return false;
    }
    const p1 = path1;
    let p2 = path2;
    if (isPoly && !this.compareCoord(p1[0], p2[0])) {
      const startIndex = this.fixStartIndex(p2, p1);
      if (!startIndex) {
        return false;
      } else {
        p2 = startIndex;
      }
    }
    const sameDirection = this.compareCoord(p1[ind], p2[ind]);
    if (this.direction || sameDirection) {
      return this.comparePath(p1, p2);
    } else {
      if (this.compareCoord(p1[ind], p2[p2.length - (1 + ind)])) {
        return this.comparePath(p1.slice().reverse(), p2);
      }
      return false;
    }
  }
  fixStartIndex(sourcePath, targetPath) {
    let correctPath, ind = -1;
    for (let i = 0; i < sourcePath.length; i++) {
      if (this.compareCoord(sourcePath[i], targetPath[0])) {
        ind = i;
        break;
      }
    }
    if (ind >= 0) {
      correctPath = [].concat(
        sourcePath.slice(ind, sourcePath.length),
        sourcePath.slice(1, ind + 1)
      );
    }
    return correctPath;
  }
  comparePath(p1, p2) {
    return p1.every((c, i) => this.compareCoord(c, p2[i]));
  }
  comparePolygon(g1, g2) {
    if (this.compareLine(g1.coordinates[0], g2.coordinates[0], 1, true)) {
      const holes1 = g1.coordinates.slice(1, g1.coordinates.length);
      const holes2 = g2.coordinates.slice(1, g2.coordinates.length);
      return holes1.every(
        (h1) => holes2.some((h2) => this.compareLine(h1, h2, 1, true))
      );
    }
    return false;
  }
  compareGeometryCollection(g1, g2) {
    return sameLength(g1.geometries, g2.geometries) && this.compareBBox(g1, g2) && g1.geometries.every((g, i) => this.compare(g, g2.geometries[i]));
  }
  compareFeature(g1, g2) {
    return g1.id === g2.id && (this.compareProperties ? equal(g1.properties, g2.properties) : true) && this.compareBBox(g1, g2) && this.compare(g1.geometry, g2.geometry);
  }
  compareFeatureCollection(g1, g2) {
    return sameLength(g1.features, g2.features) && this.compareBBox(g1, g2) && g1.features.every((f, i) => this.compare(f, g2.features[i]));
  }
  compareBBox(g1, g2) {
    return Boolean(!g1.bbox && !g2.bbox) || (g1.bbox && g2.bbox ? this.compareCoord(g1.bbox, g2.bbox) : false);
  }
};
__name(_GeojsonEquality, "GeojsonEquality");
var GeojsonEquality = _GeojsonEquality;
function sameLength(g1, g2) {
  return g1.coordinates ? g1.coordinates.length === g2.coordinates.length : g1.length === g2.length;
}
__name(sameLength, "sameLength");
function explode(g) {
  return g.coordinates.map((part) => ({
    type: g.type.replace("Multi", ""),
    coordinates: part
  }));
}
__name(explode, "explode");
function geojsonEquality(g1, g2, opts) {
  const eq = new GeojsonEquality(opts);
  return eq.compare(g1, g2);
}
__name(geojsonEquality, "geojsonEquality");
function equal(object1, object2) {
  if (object1 === null && object2 === null) {
    return true;
  }
  if (object1 === null || object2 === null) {
    return false;
  }
  const objKeys1 = Object.keys(object1);
  const objKeys2 = Object.keys(object2);
  if (objKeys1.length !== objKeys2.length) return false;
  for (var key of objKeys1) {
    const value1 = object1[key];
    const value2 = object2[key];
    const isObjects = isObject3(value1) && isObject3(value2);
    if (isObjects && !equal(value1, value2) || !isObjects && value1 !== value2) {
      return false;
    }
  }
  return true;
}
__name(equal, "equal");
var isObject3 = /* @__PURE__ */ __name((object) => {
  return object != null && typeof object === "object";
}, "isObject");

// node_modules/@turf/clean-coords/dist/esm/index.js
init_cjs_shims();
function cleanCoords(geojson, options = {}) {
  var mutate = typeof options === "object" ? options.mutate : options;
  if (!geojson) throw new Error("geojson is required");
  var type = getType(geojson);
  var newCoords = [];
  switch (type) {
    case "LineString":
      newCoords = cleanLine(geojson, type);
      break;
    case "MultiLineString":
    case "Polygon":
      getCoords(geojson).forEach(function(line) {
        newCoords.push(cleanLine(line, type));
      });
      break;
    case "MultiPolygon":
      getCoords(geojson).forEach(function(polygons) {
        var polyPoints = [];
        polygons.forEach(function(ring) {
          polyPoints.push(cleanLine(ring, type));
        });
        newCoords.push(polyPoints);
      });
      break;
    case "Point":
      return geojson;
    case "MultiPoint":
      var existing = {};
      getCoords(geojson).forEach(function(coord) {
        var key = coord.join("-");
        if (!Object.prototype.hasOwnProperty.call(existing, key)) {
          newCoords.push(coord);
          existing[key] = true;
        }
      });
      break;
    default:
      throw new Error(type + " geometry not supported");
  }
  if (geojson.coordinates) {
    if (mutate === true) {
      geojson.coordinates = newCoords;
      return geojson;
    }
    return { type, coordinates: newCoords };
  } else {
    if (mutate === true) {
      geojson.geometry.coordinates = newCoords;
      return geojson;
    }
    return feature({ type, coordinates: newCoords }, geojson.properties, {
      bbox: geojson.bbox,
      id: geojson.id
    });
  }
}
function cleanLine(line, type) {
  var points = getCoords(line);
  if (points.length === 2 && !equals2(points[0], points[1])) return points;
  var newPoints = [];
  var secondToLast = points.length - 1;
  var newPointsLength = newPoints.length;
  newPoints.push(points[0]);
  for (var i = 1; i < secondToLast; i++) {
    var prevAddedPoint = newPoints[newPoints.length - 1];
    if (points[i][0] === prevAddedPoint[0] && points[i][1] === prevAddedPoint[1])
      continue;
    else {
      newPoints.push(points[i]);
      newPointsLength = newPoints.length;
      if (newPointsLength > 2) {
        if (isPointOnLineSegment3(
          newPoints[newPointsLength - 3],
          newPoints[newPointsLength - 1],
          newPoints[newPointsLength - 2]
        ))
          newPoints.splice(newPoints.length - 2, 1);
      }
    }
  }
  newPoints.push(points[points.length - 1]);
  newPointsLength = newPoints.length;
  if ((type === "Polygon" || type === "MultiPolygon") && equals2(points[0], points[points.length - 1]) && newPointsLength < 4) {
    throw new Error("invalid polygon");
  }
  if (type === "LineString" && newPointsLength < 3) {
    return newPoints;
  }
  if (isPointOnLineSegment3(
    newPoints[newPointsLength - 3],
    newPoints[newPointsLength - 1],
    newPoints[newPointsLength - 2]
  ))
    newPoints.splice(newPoints.length - 2, 1);
  return newPoints;
}
function equals2(pt1, pt2) {
  return pt1[0] === pt2[0] && pt1[1] === pt2[1];
}
function isPointOnLineSegment3(start, end, point2) {
  var x = point2[0], y = point2[1];
  var startX = start[0], startY = start[1];
  var endX = end[0], endY = end[1];
  var dxc = x - startX;
  var dyc = y - startY;
  var dxl = endX - startX;
  var dyl = endY - startY;
  var cross = dxc * dyl - dyc * dxl;
  if (cross !== 0) return false;
  else if (Math.abs(dxl) >= Math.abs(dyl))
    return dxl > 0 ? startX <= x && x <= endX : endX <= x && x <= startX;
  else return dyl > 0 ? startY <= y && y <= endY : endY <= y && y <= startY;
}

// node_modules/@turf/boolean-equal/dist/esm/index.js
function booleanEqual(feature1, feature2, options = {}) {
  let precision2 = options.precision;
  precision2 = precision2 === void 0 || precision2 === null || isNaN(precision2) ? 6 : precision2;
  if (typeof precision2 !== "number" || !(precision2 >= 0)) {
    throw new Error("precision must be a positive number");
  }
  const type1 = getGeom(feature1).type;
  const type2 = getGeom(feature2).type;
  if (type1 !== type2) return false;
  return geojsonEquality(cleanCoords(feature1), cleanCoords(feature2), {
    precision: precision2
  });
}

// src/widget-sources/widget-tileset-source-impl.ts
var WidgetTilesetSourceImpl = class extends WidgetSource {
  constructor() {
    super(...arguments);
    __publicField(this, "_tiles", []);
    __publicField(this, "_features", []);
    __publicField(this, "_tileFeatureExtractOptions", {});
    __publicField(this, "_tileFeatureExtractPreviousInputs", {});
  }
  /**
   * Loads features as a list of tiles (typically provided by deck.gl).
   * After tiles are loaded, {@link extractTileFeatures} must be called
   * before computing statistics on the tiles.
   */
  loadTiles(tiles) {
    this._tiles = tiles;
    this._features.length = 0;
  }
  /** Configures options used to extract features from tiles. */
  setTileFeatureExtractOptions(options) {
    this._tileFeatureExtractOptions = options;
    this._features.length = 0;
  }
  _extractTileFeatures(spatialFilter) {
    const prevInputs = this._tileFeatureExtractPreviousInputs;
    if (this._features.length && spatialFilterEquals(prevInputs.spatialFilter, spatialFilter)) {
      return;
    }
    this._features = tileFeatures({
      ...assignOptional({}, this.props, this._tileFeatureExtractOptions),
      tiles: this._tiles,
      spatialFilter
    });
    prevInputs.spatialFilter = spatialFilter;
  }
  /**
   * Loads features as GeoJSON (used for testing).
   * @experimental
   * @internal Not for public use. Spatial filters in other method calls will be ignored.
   */
  loadGeoJSON({
    geojson,
    spatialFilter
  }) {
    this._features = geojsonFeatures({
      geojson,
      spatialFilter,
      ...this._tileFeatureExtractOptions
    });
    this._tileFeatureExtractPreviousInputs.spatialFilter = spatialFilter;
  }
  async getFeatures() {
    throw new Error("getFeatures not supported for tilesets");
  }
  async getFormula({
    column = "*",
    operation: operation2 = AggregationTypes.Count,
    joinOperation,
    filters,
    filterOwner,
    spatialFilter
  }) {
    const filteredFeatures = this._getFilteredFeatures(
      spatialFilter,
      filters,
      filterOwner
    );
    if (filteredFeatures.length === 0 && operation2 !== AggregationTypes.Count) {
      return { value: null };
    }
    if (operation2 === AggregationTypes.Custom) {
      throw new Error("Custom aggregation not supported for tilesets");
    }
    if (column && column !== "*" || operation2 !== AggregationTypes.Count) {
      assertColumn(this._features, column);
    }
    const targetOperation = aggregationFunctions[operation2];
    assert2(targetOperation, `Unsupported aggregation operation: ${operation2}`);
    return {
      value: targetOperation(filteredFeatures, column, joinOperation)
    };
  }
  async getHistogram({
    operation: operation2 = AggregationTypes.Count,
    ticks,
    column,
    joinOperation,
    filters,
    filterOwner,
    spatialFilter
  }) {
    const filteredFeatures = this._getFilteredFeatures(
      spatialFilter,
      filters,
      filterOwner
    );
    if (!this._features.length) {
      return [];
    }
    assertColumn(this._features, column);
    return histogram({
      data: filteredFeatures,
      valuesColumns: normalizeColumns(column),
      joinOperation,
      ticks,
      operation: operation2
    });
  }
  async getCategories({
    column,
    operation: operation2 = AggregationTypes.Count,
    operationColumn,
    joinOperation,
    filters,
    filterOwner,
    spatialFilter,
    othersThreshold,
    orderBy = "frequency_desc",
    rawResult
  }) {
    const filteredFeatures = this._getFilteredFeatures(
      spatialFilter,
      filters,
      filterOwner
    );
    if (!filteredFeatures.length) {
      return [];
    }
    assertColumn(this._features, column, operationColumn);
    const result = groupValuesByColumn({
      data: filteredFeatures,
      valuesColumns: normalizeColumns(operationColumn || column),
      joinOperation,
      keysColumn: column,
      operation: operation2,
      othersThreshold,
      orderBy
    });
    if (rawResult) {
      return result;
    }
    if (!othersThreshold) {
      return result?.rows || [];
    }
    return [
      ...result?.rows || [],
      { name: OTHERS_CATEGORY_NAME, value: result?.metadata?.others }
    ];
  }
  async getScatter({
    xAxisColumn,
    yAxisColumn,
    xAxisJoinOperation,
    yAxisJoinOperation,
    filters,
    filterOwner,
    spatialFilter
  }) {
    const filteredFeatures = this._getFilteredFeatures(
      spatialFilter,
      filters,
      filterOwner
    );
    if (!filteredFeatures.length) {
      return [];
    }
    assertColumn(this._features, xAxisColumn, yAxisColumn);
    return scatterPlot({
      data: filteredFeatures,
      xAxisColumns: normalizeColumns(xAxisColumn),
      xAxisJoinOperation,
      yAxisColumns: normalizeColumns(yAxisColumn),
      yAxisJoinOperation
    });
  }
  async getTable({
    columns,
    searchFilterColumn,
    searchFilterText,
    sortBy,
    sortDirection,
    sortByColumnType,
    offset = 0,
    limit = 10,
    filters,
    filterOwner,
    spatialFilter
  }) {
    let filteredFeatures = this._getFilteredFeatures(
      spatialFilter,
      filters,
      filterOwner
    );
    if (!filteredFeatures.length) {
      return { rows: [], totalCount: 0 };
    }
    if (searchFilterColumn && searchFilterText) {
      console.warn(
        'WidgetTilesetSource: "searchFilterText" is deprecated, use "filters" and FilterType.STRING_SEARCH instead.'
      );
      filteredFeatures = filteredFeatures.filter(
        (row) => row[searchFilterColumn] && String(row[searchFilterColumn]).toLowerCase().includes(String(searchFilterText).toLowerCase())
      );
    }
    let rows = applySorting(filteredFeatures, {
      sortBy,
      sortByDirection: sortDirection,
      sortByColumnType
    });
    const totalCount = rows.length;
    rows = rows.slice(
      Math.min(offset, totalCount),
      Math.min(offset + limit, totalCount)
    );
    rows = rows.map((srcRow) => {
      const dstRow = {};
      for (const column of columns) {
        dstRow[column] = srcRow[column];
      }
      return dstRow;
    });
    return { rows, totalCount };
  }
  async getTimeSeries({
    column,
    stepSize,
    operation: operation2,
    operationColumn,
    joinOperation,
    filters,
    filterOwner,
    spatialFilter
  }) {
    const filteredFeatures = this._getFilteredFeatures(
      spatialFilter,
      filters,
      filterOwner
    );
    if (!filteredFeatures.length) {
      return { rows: [] };
    }
    assertColumn(this._features, column, operationColumn);
    assert2(
      operation2 !== "custom",
      "Custom operation not supported for tilesets"
    );
    const rows = groupValuesByDateColumn({
      data: filteredFeatures,
      valuesColumns: normalizeColumns(operationColumn || column),
      keysColumn: column,
      groupType: stepSize,
      operation: operation2,
      joinOperation
    }) || [];
    return { rows };
  }
  async getRange({
    column,
    filters,
    filterOwner,
    spatialFilter
  }) {
    const filteredFeatures = this._getFilteredFeatures(
      spatialFilter,
      filters,
      filterOwner
    );
    if (!this._features.length) {
      return null;
    }
    assertColumn(this._features, column);
    return {
      min: aggregationFunctions.min(filteredFeatures, column),
      max: aggregationFunctions.max(filteredFeatures, column)
    };
  }
  async getAggregations({
    aggregations,
    filters,
    filterOwner,
    spatialFilter
  }) {
    const filteredFeatures = this._getFilteredFeatures(
      spatialFilter,
      filters,
      filterOwner
    );
    if (!this._features.length) {
      return { rows: [] };
    }
    assert2(
      typeof aggregations !== "string",
      "Unsupported tileset SQL aggregation"
    );
    const result = {};
    const usedAliases = /* @__PURE__ */ new Set();
    for (const { column, operation: operation2, alias } of aggregations) {
      if (column && column !== "*" || operation2 !== AggregationTypes.Count) {
        assertColumn(this._features, column);
      }
      const aliasKey = alias.toLowerCase();
      assert2(!usedAliases.has(aliasKey), `Duplicate alias: ${aliasKey}`);
      usedAliases.add(aliasKey);
      const targetOperation = aggregationFunctions[operation2];
      assert2(targetOperation, `Unsupported operation: ${operation2}`);
      result[alias] = targetOperation(filteredFeatures, column);
    }
    return { rows: [result] };
  }
  /** @experimental */
  async getExtent() {
    return Promise.reject(new Error("not implemented"));
  }
  /****************************************************************************
   * INTERNAL
   */
  _getFilteredFeatures(spatialFilter, filters, filterOwner) {
    this._extractTileFeatures(spatialFilter);
    return applyFilters(
      this._features,
      getApplicableFilters(filterOwner, filters || this.props.filters),
      this.props.filtersLogicalOperator || "and"
    );
  }
};
function assertColumn(features, ...columnArgs) {
  const columns = Array.from(new Set(columnArgs.map(normalizeColumns).flat()));
  const featureKeys = Object.keys(features[0]);
  const invalidColumns = columns.filter(
    (column) => column && !featureKeys.includes(column)
  );
  if (invalidColumns.length) {
    throw new InvalidColumnError(
      `Missing column(s): ${invalidColumns.join(", ")}`
    );
  }
}
function normalizeColumns(columns) {
  return Array.isArray(columns) ? columns : typeof columns === "string" ? [columns] : [];
}
function spatialFilterEquals(a, b) {
  if (a === b) return true;
  if (!a || !b) return false;
  return booleanEqual(a, b);
}

// src/widget-sources/widget-tileset-source.ts
var WidgetTilesetSource = class extends WidgetSource {
  constructor(props) {
    super(props);
    __publicField(this, "_localImpl", null);
    __publicField(this, "_workerImpl", null);
    __publicField(this, "_workerEnabled");
    __publicField(this, "_workerNextRequestId", 1);
    this._workerEnabled = (props.widgetWorker ?? true) && false;
    if (!this._workerEnabled) {
      this._localImpl = new WidgetTilesetSourceImpl(this.props);
    }
  }
  destroy() {
    this._localImpl?.destroy();
    this._localImpl = null;
    this._workerImpl?.terminate();
    this._workerImpl = null;
    super.destroy();
  }
  /////////////////////////////////////////////////////////////////////////////
  // WEB WORKER MANAGEMENT
  /**
   * Returns an initialized Worker, to be reused for the lifecycle of this
   * source instance.
   */
  _getWorker() {
    if (this._workerImpl) {
      return this._workerImpl;
    }
    if (this.props.widgetWorkerUrl) {
      this._workerImpl = new Worker(this.props.widgetWorkerUrl, {
        name: "cartowidgettileset"
      });
    } else {
      this._workerImpl = new Worker(
        new URL("@carto/api-client/worker", importMetaUrl),
        {
          type: "module",
          name: "cartowidgettileset"
        }
      );
    }
    this._workerImpl.addEventListener("error", (e) => {
      console.error("widget-tileset-source worker error", e);
    });
    this._workerImpl.postMessage({
      method: "init" /* INIT */,
      params: [this.props]
    });
    return this._workerImpl;
  }
  /** Executes a given method on the worker. */
  _executeWorkerMethod(method, params, signal) {
    if (!this._workerEnabled) {
      return this._localImpl[method](...params);
    }
    const worker = this._getWorker();
    const requestId = this._workerNextRequestId++;
    let resolve = null;
    let reject = null;
    function onMessage(e) {
      const response = e.data;
      if (response.requestId !== requestId) return;
      if (signal?.aborted) return;
      if (response.ok) {
        resolve(response.result);
      } else {
        reject(new Error(response.error));
      }
    }
    function onAbort() {
      reject(new Error(signal.reason));
    }
    worker.addEventListener("message", onMessage);
    signal?.addEventListener("abort", onAbort);
    const promise = new Promise((_resolve, _reject) => {
      resolve = _resolve;
      reject = _reject;
      worker.postMessage({
        requestId,
        method,
        params
      });
    });
    void promise.finally(() => {
      worker.removeEventListener("message", onMessage);
      signal?.removeEventListener("abort", onAbort);
    });
    return promise;
  }
  /////////////////////////////////////////////////////////////////////////////
  // DATA LOADING
  /**
   * Loads features as a list of tiles (typically provided by deck.gl).
   * After tiles are loaded, {@link extractTileFeatures} must be called
   * before computing statistics on the tiles.
   */
  loadTiles(tiles) {
    if (!this._workerEnabled) {
      return this._localImpl.loadTiles(tiles);
    }
    const worker = this._getWorker();
    tiles = tiles.map(
      ({ id, index, bbox: bbox2, isVisible, data }) => {
        const tile = {
          id,
          index,
          isVisible,
          data,
          bbox: bbox2
        };
        return tile;
      }
    );
    worker.postMessage({
      method: "loadTiles" /* LOAD_TILES */,
      params: [tiles]
    });
  }
  /** Configures options used to extract features from tiles. */
  setTileFeatureExtractOptions(options) {
    if (!this._workerEnabled) {
      return this._localImpl?.setTileFeatureExtractOptions(options);
    }
    const worker = this._getWorker();
    worker.postMessage({
      method: "setTileFeatureExtractOptions" /* SET_TILE_FEATURE_EXTRACT_OPTIONS */,
      params: [options]
    });
  }
  /**
   * Loads features as GeoJSON (used for testing).
   * @experimental
   * @internal Not for public use. Spatial filters in other method calls will be ignored.
   */
  loadGeoJSON({
    geojson,
    spatialFilter
  }) {
    if (!this._workerEnabled) {
      return this._localImpl.loadGeoJSON({ geojson, spatialFilter });
    }
    const worker = this._getWorker();
    worker.postMessage({
      method: "loadGeoJSON" /* LOAD_GEOJSON */,
      params: [{ geojson, spatialFilter }]
    });
  }
  /////////////////////////////////////////////////////////////////////////////
  // WIDGETS API
  // eslint-disable-next-line @typescript-eslint/require-await
  async getFeatures() {
    throw new Error("getFeatures not supported for tilesets");
  }
  async getFormula({
    signal,
    ...options
  }) {
    return this._executeWorkerMethod("getFormula" /* GET_FORMULA */, [options], signal);
  }
  async getHistogram({
    signal,
    ...options
  }) {
    return this._executeWorkerMethod("getHistogram" /* GET_HISTOGRAM */, [options], signal);
  }
  async getCategories({
    signal,
    ...options
  }) {
    return this._executeWorkerMethod("getCategories" /* GET_CATEGORIES */, [options], signal);
  }
  async getScatter({
    signal,
    ...options
  }) {
    return this._executeWorkerMethod("getScatter" /* GET_SCATTER */, [options], signal);
  }
  async getTable({
    signal,
    ...options
  }) {
    return this._executeWorkerMethod("getTable" /* GET_TABLE */, [options], signal);
  }
  async getTimeSeries({
    signal,
    ...options
  }) {
    return this._executeWorkerMethod("getTimeSeries" /* GET_TIME_SERIES */, [options], signal);
  }
  async getRange({
    signal,
    ...options
  }) {
    return this._executeWorkerMethod("getRange" /* GET_RANGE */, [options], signal);
  }
  async getAggregations({
    signal,
    ...options
  }) {
    return this._executeWorkerMethod(
      "getAggregations" /* GET_AGGREGATIONS */,
      [options],
      signal
    );
  }
  /** @experimental */
  async getExtent() {
    return Promise.resolve({
      bbox: this.props.spatialDataBounds
    });
  }
};

// src/widget-sources/widget-raster-source.ts
var WidgetRasterSource = class extends WidgetTilesetSource {
};

// src/widget-sources/widget-table-source.ts
init_cjs_shims();
var WidgetTableSource = class extends WidgetRemoteSource {
  getModelSource(filters, filterOwner) {
    return {
      ...super._getModelSource(filters, filterOwner),
      type: "table",
      data: this.props.tableName
    };
  }
};

// src/sources/h3-query-source.ts
var h3QuerySource = async function(options) {
  const {
    aggregationExp,
    aggregationResLevel = DEFAULT_AGGREGATION_RES_LEVEL_H3,
    sqlQuery,
    spatialDataColumn = "h3",
    queryParameters,
    filters
  } = options;
  const spatialDataType = "h3";
  const urlParameters = {
    aggregationExp,
    spatialDataColumn,
    spatialDataType,
    q: sqlQuery
  };
  if (aggregationResLevel) {
    urlParameters.aggregationResLevel = String(aggregationResLevel);
  }
  if (queryParameters) {
    urlParameters.queryParameters = queryParameters;
  }
  if (filters) {
    urlParameters.filters = filters;
  }
  return baseSource("query", options, urlParameters).then(
    (result) => ({
      ...result,
      widgetSource: new WidgetQuerySource({
        ...options,
        // NOTE: Parameters with default values above must be explicitly passed here.
        spatialDataColumn,
        spatialDataType: getWidgetSpatialDataType(
          spatialDataType,
          spatialDataColumn,
          result.schema
        )
      })
    })
  );
};

// src/sources/h3-table-source.ts
init_cjs_shims();
var h3TableSource = async function(options) {
  const {
    aggregationExp,
    aggregationResLevel = DEFAULT_AGGREGATION_RES_LEVEL_H3,
    spatialDataColumn = "h3",
    tableName,
    filters
  } = options;
  const spatialDataType = "h3";
  const urlParameters = {
    aggregationExp,
    name: tableName,
    spatialDataColumn,
    spatialDataType
  };
  if (aggregationResLevel) {
    urlParameters.aggregationResLevel = String(aggregationResLevel);
  }
  if (filters) {
    urlParameters.filters = filters;
  }
  return baseSource("table", options, urlParameters).then(
    (result) => ({
      ...result,
      widgetSource: new WidgetTableSource({
        ...options,
        // NOTE: Parameters with default values above must be explicitly passed here.
        spatialDataColumn,
        spatialDataType: getWidgetSpatialDataType(
          spatialDataType,
          spatialDataColumn,
          result.schema
        )
      })
    })
  );
};

// src/sources/h3-tileset-source.ts
init_cjs_shims();

// src/utils/getTileFormat.ts
init_cjs_shims();
function getTileFormat(tilejson) {
  const tileParams = new URL(tilejson.tiles[0]).searchParams;
  return tileParams.get("formatTiles") === "mvt" ? "mvt" /* MVT */ : "binary" /* BINARY */;
}

// src/sources/h3-tileset-source.ts
var h3TilesetSource = async function(options) {
  const { tableName, spatialDataColumn = "h3" } = options;
  const urlParameters = { name: tableName };
  return baseSource("tileset", options, urlParameters).then(
    (result) => ({
      ...result,
      widgetSource: new WidgetTilesetSource({
        ...options,
        tileFormat: getTileFormat(result),
        spatialDataColumn,
        spatialDataType: "h3",
        spatialDataBounds: result.bounds
      })
    })
  );
};

// src/sources/quadbin-query-source.ts
init_cjs_shims();
var quadbinQuerySource = async function(options) {
  const {
    aggregationExp,
    aggregationResLevel = DEFAULT_AGGREGATION_RES_LEVEL_QUADBIN,
    sqlQuery,
    spatialDataColumn = "quadbin",
    queryParameters,
    filters
  } = options;
  const spatialDataType = "quadbin";
  const urlParameters = {
    aggregationExp,
    q: sqlQuery,
    spatialDataColumn,
    spatialDataType
  };
  if (aggregationResLevel) {
    urlParameters.aggregationResLevel = String(aggregationResLevel);
  }
  if (queryParameters) {
    urlParameters.queryParameters = queryParameters;
  }
  if (filters) {
    urlParameters.filters = filters;
  }
  return baseSource("query", options, urlParameters).then(
    (result) => ({
      ...result,
      widgetSource: new WidgetQuerySource({
        ...options,
        // NOTE: Parameters with default values above must be explicitly passed here.
        spatialDataColumn,
        spatialDataType: getWidgetSpatialDataType(
          spatialDataType,
          spatialDataColumn,
          result.schema
        )
      })
    })
  );
};

// src/sources/quadbin-table-source.ts
init_cjs_shims();
var quadbinTableSource = async function(options) {
  const {
    aggregationExp,
    aggregationResLevel = DEFAULT_AGGREGATION_RES_LEVEL_QUADBIN,
    spatialDataColumn = "quadbin",
    tableName,
    filters
  } = options;
  const spatialDataType = "quadbin";
  const urlParameters = {
    aggregationExp,
    name: tableName,
    spatialDataColumn,
    spatialDataType
  };
  if (aggregationResLevel) {
    urlParameters.aggregationResLevel = String(aggregationResLevel);
  }
  if (filters) {
    urlParameters.filters = filters;
  }
  return baseSource("table", options, urlParameters).then(
    (result) => ({
      ...result,
      widgetSource: new WidgetTableSource({
        ...options,
        // NOTE: Parameters with default values above must be explicitly passed here.
        spatialDataColumn,
        spatialDataType: getWidgetSpatialDataType(
          spatialDataType,
          spatialDataColumn,
          result.schema
        )
      })
    })
  );
};

// src/sources/quadbin-tileset-source.ts
init_cjs_shims();
var quadbinTilesetSource = async function(options) {
  const { tableName, spatialDataColumn = "quadbin" } = options;
  const urlParameters = { name: tableName };
  return baseSource("tileset", options, urlParameters).then(
    (result) => ({
      ...result,
      widgetSource: new WidgetTilesetSource({
        ...options,
        tileFormat: getTileFormat(result),
        spatialDataColumn,
        spatialDataType: "quadbin",
        spatialDataBounds: result.bounds
      })
    })
  );
};

// src/sources/raster-source.ts
init_cjs_shims();
var rasterSource = async function(options) {
  const { tableName, filters } = options;
  const urlParameters = { name: tableName };
  if (filters) {
    urlParameters.filters = filters;
  }
  return baseSource("raster", options, urlParameters).then(
    (result) => ({
      ...result,
      widgetSource: new WidgetRasterSource({
        ...options,
        tileFormat: getTileFormat(result),
        spatialDataColumn: "quadbin",
        spatialDataType: "quadbin",
        spatialDataBounds: result.bounds,
        rasterMetadata: result.raster_metadata
      })
    })
  );
};

// src/sources/trajectory-query-source.ts
init_cjs_shims();
var trajectoryQuerySource = async function(options) {
  const {
    columns,
    spatialDataColumn = DEFAULT_GEO_COLUMN,
    sqlQuery,
    tileResolution = DEFAULT_TILE_RESOLUTION,
    queryParameters,
    aggregationExp,
    trajectoryIdColumn,
    timestampColumn
  } = options;
  const spatialDataType = "trajectory";
  const urlParameters = {
    spatialDataColumn,
    spatialDataType,
    tileResolution: tileResolution.toString(),
    q: sqlQuery,
    trajectoryIdColumn,
    timestampColumn
  };
  if (columns) {
    urlParameters.columns = columns.join(",");
  }
  if (queryParameters) {
    urlParameters.queryParameters = queryParameters;
  }
  if (aggregationExp) {
    urlParameters.aggregationExp = aggregationExp;
  }
  const result = await baseSource(
    "query",
    options,
    urlParameters
  );
  const widgetSource = new WidgetQuerySource({
    ...options,
    // NOTE: Parameters with default values above must be explicitly passed here.
    spatialDataColumn,
    spatialDataType,
    tileResolution
  });
  const timestampRange = await widgetSource.getRange({ column: timestampColumn });
  return {
    ...result,
    widgetSource,
    timestampRange
  };
};

// src/sources/trajectory-table-source.ts
init_cjs_shims();
var trajectoryTableSource = async function(options) {
  const {
    columns,
    spatialDataColumn = DEFAULT_GEO_COLUMN,
    tableName,
    tileResolution = DEFAULT_TILE_RESOLUTION,
    aggregationExp,
    trajectoryIdColumn,
    timestampColumn
  } = options;
  const spatialDataType = "trajectory";
  const urlParameters = {
    name: tableName,
    spatialDataColumn,
    spatialDataType,
    tileResolution: tileResolution.toString(),
    trajectoryIdColumn,
    timestampColumn
  };
  if (columns) {
    urlParameters.columns = columns.join(",");
  }
  if (aggregationExp) {
    urlParameters.aggregationExp = aggregationExp;
  }
  const result = await baseSource(
    "table",
    options,
    urlParameters
  );
  const widgetSource = new WidgetTableSource({
    ...options,
    // NOTE: Parameters with default values above must be explicitly passed here.
    spatialDataColumn,
    spatialDataType,
    tileResolution
  });
  const timestampRange = await widgetSource.getRange({ column: timestampColumn });
  return {
    ...result,
    widgetSource,
    timestampRange
  };
};

// src/sources/vector-query-source.ts
init_cjs_shims();
var vectorQuerySource = async function(options) {
  const {
    columns,
    filters,
    spatialDataColumn = DEFAULT_GEO_COLUMN,
    sqlQuery,
    tileResolution = DEFAULT_TILE_RESOLUTION,
    queryParameters,
    aggregationExp
  } = options;
  const spatialDataType = "geo";
  const urlParameters = {
    spatialDataColumn,
    spatialDataType,
    tileResolution: tileResolution.toString(),
    q: sqlQuery
  };
  if (columns) {
    urlParameters.columns = columns.join(",");
  }
  if (filters) {
    urlParameters.filters = filters;
  }
  if (queryParameters) {
    urlParameters.queryParameters = queryParameters;
  }
  if (aggregationExp) {
    urlParameters.aggregationExp = aggregationExp;
  }
  return baseSource("query", options, urlParameters).then(
    (result) => ({
      ...result,
      widgetSource: new WidgetQuerySource({
        ...options,
        // NOTE: Parameters with default values above must be explicitly passed here.
        spatialDataColumn,
        spatialDataType,
        tileResolution
      })
    })
  );
};

// src/sources/vector-table-source.ts
init_cjs_shims();
var vectorTableSource = async function(options) {
  const {
    columns,
    filters,
    spatialDataColumn = DEFAULT_GEO_COLUMN,
    tableName,
    tileResolution = DEFAULT_TILE_RESOLUTION,
    aggregationExp
  } = options;
  const spatialDataType = "geo";
  const urlParameters = {
    name: tableName,
    spatialDataColumn,
    spatialDataType,
    tileResolution: tileResolution.toString()
  };
  if (columns) {
    urlParameters.columns = columns.join(",");
  }
  if (filters) {
    urlParameters.filters = filters;
  }
  if (aggregationExp) {
    urlParameters.aggregationExp = aggregationExp;
  }
  return baseSource("table", options, urlParameters).then(
    (result) => ({
      ...result,
      widgetSource: new WidgetTableSource({
        ...options,
        // NOTE: Parameters with default values above must be explicitly passed here.
        spatialDataColumn,
        spatialDataType,
        tileResolution
      })
    })
  );
};

// src/sources/vector-tileset-source.ts
init_cjs_shims();
var vectorTilesetSource = async function(options) {
  const { tableName, spatialDataColumn = DEFAULT_GEO_COLUMN } = options;
  const urlParameters = { name: tableName };
  return baseSource("tileset", options, urlParameters).then(
    (result) => ({
      ...result,
      widgetSource: new WidgetTilesetSource({
        ...options,
        tileFormat: getTileFormat(result),
        spatialDataColumn,
        spatialDataType: "geo",
        spatialDataBounds: result.bounds
      })
    })
  );
};

// src/sources/constants.ts
init_cjs_shims();
var RasterBandColorinterp = /* @__PURE__ */ ((RasterBandColorinterp2) => {
  RasterBandColorinterp2["Gray"] = "gray";
  RasterBandColorinterp2["Red"] = "red";
  RasterBandColorinterp2["Green"] = "green";
  RasterBandColorinterp2["Blue"] = "blue";
  RasterBandColorinterp2["Alpha"] = "alpha";
  RasterBandColorinterp2["Palette"] = "palette";
  return RasterBandColorinterp2;
})(RasterBandColorinterp || {});

// src/sources/index.ts
var CARTO_SOURCES = {
  boundaryQuerySource,
  boundaryTableSource,
  h3QuerySource,
  h3TableSource,
  h3TilesetSource,
  quadbinQuerySource,
  quadbinTableSource,
  quadbinTilesetSource,
  rasterSource,
  trajectoryQuerySource,
  trajectoryTableSource,
  vectorQuerySource,
  vectorTableSource,
  vectorTilesetSource
};

// src/api/query.ts
var query = async function(options) {
  const {
    apiBaseUrl = SOURCE_DEFAULTS.apiBaseUrl,
    maxLengthURL = SOURCE_DEFAULTS.maxLengthURL,
    clientId = getClient(),
    localCache,
    connectionName,
    sqlQuery,
    queryParameters,
    internalParameters
  } = options;
  const urlParameters = { q: sqlQuery };
  if (queryParameters) {
    urlParameters.queryParameters = JSON.stringify(queryParameters);
  }
  const baseUrl = buildQueryUrl({ apiBaseUrl, connectionName });
  const headers = {
    Authorization: `Bearer ${options.accessToken}`,
    ...options.headers
  };
  const parameters = {
    client: clientId,
    ...options.tags,
    ...internalParameters,
    ...urlParameters
  };
  const errorContext = {
    requestType: "SQL",
    connection: options.connectionName,
    type: "query",
    source: JSON.stringify(parameters, void 0, 2)
  };
  return await requestWithParameters({
    baseUrl,
    parameters,
    headers,
    errorContext,
    maxLengthURL,
    localCache,
    signal: options.signal
  });
};

// src/fetch-map/basemap-styles.ts
var cartoStyleUrlTemplate = "https://basemaps.cartocdn.com/gl/{basemap}-gl-style/style.json";
var CARTO_MAP_STYLES = ["positron", "dark-matter", "voyager"];
var GOOGLE_BASEMAPS = {
  roadmap: {
    mapTypeId: "roadmap",
    mapId: "3754c817b510f791"
  },
  "google-positron": {
    mapTypeId: "roadmap",
    mapId: "ea84ae4203ef21cd"
  },
  "google-dark-matter": {
    mapTypeId: "roadmap",
    mapId: "2fccc3b36c22a0e2"
  },
  "google-voyager": {
    mapTypeId: "roadmap",
    mapId: "885caf1e15bb9ef2"
  },
  satellite: {
    mapTypeId: "satellite"
  },
  hybrid: {
    mapTypeId: "hybrid"
  },
  terrain: {
    mapTypeId: "terrain"
  }
};
var STYLE_LAYER_GROUPS = [
  {
    slug: "label",
    filter: ({ id }) => Boolean(
      id.match(
        /(?=(label|_label|place-|place_|poi-|poi_|watername_|roadname_|housenumber))/
      )
    ),
    defaultVisibility: true
  },
  {
    slug: "road",
    filter: ({ id }) => Boolean(id.match(/(?=(road|railway|tunnel|street|bridge))(?!.*label)/)),
    defaultVisibility: true
  },
  {
    slug: "border",
    filter: ({ id }) => Boolean(id.match(/border|boundaries|boundary_/)),
    defaultVisibility: false
  },
  {
    slug: "building",
    filter: ({ id }) => Boolean(id.match(/building/)),
    defaultVisibility: true
  },
  {
    slug: "water",
    filter: ({ id }) => Boolean(id.match(/(?=(water|stream|ferry))/)),
    defaultVisibility: true
  },
  {
    slug: "land",
    filter: ({ id }) => Boolean(
      id.match(/(?=(parks|landcover|industrial|sand|hillshade|park_))/)
    ),
    defaultVisibility: true
  }
];
function applyLayerGroupFilters(style, visibleLayerGroups) {
  if (!Array.isArray(style?.layers)) {
    return style;
  }
  const removedLayerFilters = STYLE_LAYER_GROUPS.filter(
    (lg) => !visibleLayerGroups[lg.slug]
  ).map((lg) => lg.filter);
  const visibleLayers = style.layers.filter(
    (layer) => removedLayerFilters.every((match) => !match(layer))
  );
  return {
    ...style,
    layers: visibleLayers
  };
}
function someLayerGroupsDisabled(visibleLayerGroups) {
  return visibleLayerGroups && Object.values(visibleLayerGroups).every(Boolean) === false;
}
function getStyleUrl(styleType) {
  return cartoStyleUrlTemplate.replace("{basemap}", styleType);
}
async function fetchStyle({
  styleUrl,
  errorContext
}) {
  let response;
  return await fetch(styleUrl, { mode: "cors" }).then((res) => {
    response = res;
    return res.json();
  }).catch((error) => {
    throw new CartoAPIError(
      error,
      { ...errorContext, requestType: "Basemap style" },
      response
    );
  });
}
var basemap_styles_default = {
  VOYAGER: getStyleUrl("voyager"),
  POSITRON: getStyleUrl("positron"),
  DARK_MATTER: getStyleUrl("dark-matter"),
  VOYAGER_NOLABELS: getStyleUrl("voyager-nolabels"),
  POSITRON_NOLABELS: getStyleUrl("positron-nolabels"),
  DARK_MATTER_NOLABELS: getStyleUrl("dark-matter-nolabels")
};

// src/fetch-map/raster-layer.ts
init_cjs_shims();

// src/fetch-map/vec-expr-evaluator.ts
init_cjs_shims();
var import_jsep = __toESM(require("jsep"), 1);
function createVecExprEvaluator(expression) {
  try {
    const parsed = compile(expression);
    const evalFun = (context) => evaluate(parsed, context);
    evalFun.symbols = getSymbols(parsed);
    return evalFun;
  } catch {
    return null;
  }
}
function evaluateVecExpr(expression, context) {
  try {
    return createVecExprEvaluator(expression)?.(context);
  } catch {
    return null;
  }
}
var ErrorCode = /* @__PURE__ */ ((ErrorCode2) => {
  ErrorCode2[ErrorCode2["InvalidSyntax"] = 0] = "InvalidSyntax";
  ErrorCode2[ErrorCode2["UnknownIdentifier"] = 1] = "UnknownIdentifier";
  return ErrorCode2;
})(ErrorCode || {});
function validateVecExprSyntax(expression, context) {
  let parsed;
  try {
    parsed = compile(expression);
  } catch (e) {
    return {
      valid: false,
      errorCode: 0 /* InvalidSyntax */,
      errorMessage: e && "message" in e ? String(e.message) : String(e)
    };
  }
  return validate(parsed, context);
}
function createResultArray(typeTemplate, length2 = typeTemplate.length) {
  return new Array(length2);
}
function isVecLike(a) {
  return Array.isArray(a) || ArrayBuffer.isView(a);
}
var createBinopVec = (scalarBinOp) => (left, right) => {
  const length2 = Math.min(left.length, right.length);
  const r = createResultArray(left, length2);
  for (let i = 0; i < length2; i++) {
    r[i] = scalarBinOp(left[i], right[i]);
  }
  return r;
};
var createBinopVecNum = (scalarBinOp) => (left, right) => {
  const length2 = left.length;
  const r = createResultArray(left, length2);
  for (let i = 0; i < length2; i++) {
    r[i] = scalarBinOp(left[i], right);
  }
  return r;
};
var createBinopNumVec = (scalarBinOp) => (left, right) => {
  const length2 = right.length;
  const r = createResultArray(right, length2);
  for (let i = 0; i < length2; i++) {
    r[i] = scalarBinOp(left, right[i]);
  }
  return r;
};
var createUnopVec = (scalarUnop) => (a) => {
  const length2 = a.length;
  const r = createResultArray(a, length2);
  for (let i = 0; i < length2; i++) {
    r[i] = scalarUnop(a[i]);
  }
  return r;
};
function mapDictValues(dict, fun) {
  return Object.keys(dict).reduce(
    (acc, key) => {
      acc[key] = fun(dict[key]);
      return acc;
    },
    {}
  );
}
var binopsNum = {
  "||": (a, b) => a || b,
  "&&": (a, b) => a && b,
  "|": (a, b) => a | b,
  "^": (a, b) => a ^ b,
  "&": (a, b) => a & b,
  "==": (a, b) => Number(a == b),
  "!=": (a, b) => Number(a != b),
  "===": (a, b) => Number(a === b),
  "!==": (a, b) => Number(a !== b),
  "<": (a, b) => Number(a < b),
  ">": (a, b) => Number(a > b),
  "<=": (a, b) => Number(a <= b),
  ">=": (a, b) => Number(a >= b),
  "<<": (a, b) => a << b,
  ">>": (a, b) => a >> b,
  ">>>": (a, b) => a >>> b,
  "+": (a, b) => a + b,
  "-": (a, b) => a - b,
  "*": (a, b) => a * b,
  "/": (a, b) => a / b,
  "%": (a, b) => a % b
};
var unopsNum = {
  "-": (a) => -a,
  "+": (a) => +a,
  "~": (a) => ~a,
  "!": (a) => Number(!a)
};
var binopsVector = mapDictValues(binopsNum, createBinopVec);
var binopsNumVec = mapDictValues(binopsNum, createBinopNumVec);
var binopsVecNum = mapDictValues(binopsNum, createBinopVecNum);
var unopsVector = mapDictValues(unopsNum, createUnopVec);
function getBinop(operator, left, right) {
  const isLeftVec = isVecLike(left);
  const isRightVec = isVecLike(right);
  if (isLeftVec && isRightVec) {
    return binopsVector[operator];
  } else if (isLeftVec) {
    return binopsVecNum[operator];
  } else if (isRightVec) {
    return binopsNumVec[operator];
  } else {
    return binopsNum[operator];
  }
}
function evaluate(_node, context) {
  const node = _node;
  switch (node.type) {
    case "BinaryExpression": {
      const left = evaluate(node.left, context);
      const right = evaluate(node.right, context);
      const binopFun = getBinop(node.operator, left, right);
      return binopFun(left, right);
    }
    case "ConditionalExpression": {
      const val = evaluate(node.test, context);
      if (isVecLike(val)) {
        const length2 = val.length;
        const consequentVal = evaluate(node.consequent, context);
        const alternateVal = evaluate(node.alternate, context);
        const r = createResultArray(val);
        for (let i = 0; i < length2; i++) {
          const entryVal = val[i] ? consequentVal : alternateVal;
          r[i] = isVecLike(entryVal) ? entryVal[i] ?? NaN : entryVal;
        }
        return r;
      } else {
        return val ? evaluate(node.consequent, context) : evaluate(node.alternate, context);
      }
    }
    case "Identifier":
      return context[node.name];
    case "Literal":
      return node.value;
    case "UnaryExpression": {
      const val = evaluate(node.argument, context);
      const unopFun = isVecLike(val) ? unopsVector[node.operator] : unopsNum[node.operator];
      return unopFun(val);
    }
    default:
      return void 0;
  }
}
var validResult = { valid: true };
function visit(_node, visitor) {
  const node = _node;
  visitor(node);
  switch (node.type) {
    case "BinaryExpression": {
      visit(node.left, visitor);
      visit(node.right, visitor);
      break;
    }
    case "ConditionalExpression": {
      visit(node.test, visitor);
      visit(node.consequent, visitor);
      visit(node.alternate, visitor);
      break;
    }
    case "UnaryExpression": {
      visit(node.argument, visitor);
      break;
    }
  }
}
var supportedExpressionTypes = [
  "BinaryExpression",
  "UnaryExpression",
  "ConditionalExpression",
  "LogicalExpression",
  "Identifier",
  "Literal"
];
function validate(_node, context) {
  const node = _node;
  const errors = [];
  visit(node, (node2) => {
    if (!supportedExpressionTypes.includes(node2.type)) {
      errors.push({
        valid: false,
        errorCode: 0 /* InvalidSyntax */,
        errorMessage: `Not allowed`
      });
      return;
    }
    if (node2.type === "Identifier") {
      if (!Object.prototype.hasOwnProperty.call(context, node2.name)) {
        return errors.push({
          valid: false,
          errorCode: 1 /* UnknownIdentifier */,
          errorMessage: `"${node2.name}" not found`
        });
      }
    }
    if (node2.type === "Literal") {
      if (typeof node2.value !== "number") {
        return errors.push({
          valid: false,
          errorCode: 0 /* InvalidSyntax */,
          errorMessage: `Only number literals are supported`
        });
      }
    }
  });
  return errors.length ? errors[0] : validResult;
}
function getSymbols(node) {
  const symbols = /* @__PURE__ */ new Set();
  visit(node, (node2) => {
    if (node2.type === "Identifier") {
      symbols.add(node2.name);
    }
  });
  return Array.from(symbols);
}
function compile(expression) {
  return (0, import_jsep.default)(expression);
}

// src/fetch-map/layer-map.ts
init_cjs_shims();

// node_modules/d3-array/src/index.js
init_cjs_shims();

// node_modules/d3-array/src/ascending.js
init_cjs_shims();
function ascending(a, b) {
  return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

// node_modules/d3-array/src/extent.js
init_cjs_shims();
function extent(values, valueof) {
  let min2;
  let max2;
  if (valueof === void 0) {
    for (const value of values) {
      if (value != null) {
        if (min2 === void 0) {
          if (value >= value) min2 = max2 = value;
        } else {
          if (min2 > value) min2 = value;
          if (max2 < value) max2 = value;
        }
      }
    }
  } else {
    let index = -1;
    for (let value of values) {
      if ((value = valueof(value, ++index, values)) != null) {
        if (min2 === void 0) {
          if (value >= value) min2 = max2 = value;
        } else {
          if (min2 > value) min2 = value;
          if (max2 < value) max2 = value;
        }
      }
    }
  }
  return [min2, max2];
}

// node_modules/d3-array/src/group.js
init_cjs_shims();

// node_modules/internmap/src/index.js
init_cjs_shims();
var InternMap = class extends Map {
  constructor(entries, key = keyof) {
    super();
    Object.defineProperties(this, { _intern: { value: /* @__PURE__ */ new Map() }, _key: { value: key } });
    if (entries != null) for (const [key2, value] of entries) this.set(key2, value);
  }
  get(key) {
    return super.get(intern_get(this, key));
  }
  has(key) {
    return super.has(intern_get(this, key));
  }
  set(key, value) {
    return super.set(intern_set(this, key), value);
  }
  delete(key) {
    return super.delete(intern_delete(this, key));
  }
};
function intern_get({ _intern, _key }, value) {
  const key = _key(value);
  return _intern.has(key) ? _intern.get(key) : value;
}
function intern_set({ _intern, _key }, value) {
  const key = _key(value);
  if (_intern.has(key)) return _intern.get(key);
  _intern.set(key, value);
  return value;
}
function intern_delete({ _intern, _key }, value) {
  const key = _key(value);
  if (_intern.has(key)) {
    value = _intern.get(key);
    _intern.delete(key);
  }
  return value;
}
function keyof(value) {
  return value !== null && typeof value === "object" ? value.valueOf() : value;
}

// node_modules/d3-array/src/identity.js
init_cjs_shims();
function identity(x) {
  return x;
}

// node_modules/d3-array/src/group.js
function group(values, ...keys) {
  return nest(values, identity, identity, keys);
}
function rollup(values, reduce, ...keys) {
  return nest(values, identity, reduce, keys);
}
function nest(values, map, reduce, keys) {
  return function regroup(values2, i) {
    if (i >= keys.length) return reduce(values2);
    const groups = new InternMap();
    const keyof2 = keys[i++];
    let index = -1;
    for (const value of values2) {
      const key = keyof2(value, ++index, values2);
      const group2 = groups.get(key);
      if (group2) group2.push(value);
      else groups.set(key, [value]);
    }
    for (const [key, values3] of groups) {
      groups.set(key, regroup(values3, i));
    }
    return map(groups);
  }(values, 0);
}

// node_modules/d3-array/src/groupSort.js
init_cjs_shims();

// node_modules/d3-array/src/sort.js
init_cjs_shims();

// node_modules/d3-array/src/permute.js
init_cjs_shims();
function permute(source, keys) {
  return Array.from(keys, (key) => source[key]);
}

// node_modules/d3-array/src/sort.js
function sort(values, ...F) {
  if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
  values = Array.from(values);
  let [f] = F;
  if (f && f.length !== 2 || F.length > 1) {
    const index = Uint32Array.from(values, (d, i) => i);
    if (F.length > 1) {
      F = F.map((f2) => values.map(f2));
      index.sort((i, j) => {
        for (const f2 of F) {
          const c = ascendingDefined(f2[i], f2[j]);
          if (c) return c;
        }
      });
    } else {
      f = values.map(f);
      index.sort((i, j) => ascendingDefined(f[i], f[j]));
    }
    return permute(values, index);
  }
  return values.sort(compareDefined(f));
}
function compareDefined(compare2 = ascending) {
  if (compare2 === ascending) return ascendingDefined;
  if (typeof compare2 !== "function") throw new TypeError("compare is not a function");
  return (a, b) => {
    const x = compare2(a, b);
    if (x || x === 0) return x;
    return (compare2(b, b) === 0) - (compare2(a, a) === 0);
  };
}
function ascendingDefined(a, b) {
  return (a == null || !(a >= a)) - (b == null || !(b >= b)) || (a < b ? -1 : a > b ? 1 : 0);
}

// node_modules/d3-array/src/groupSort.js
function groupSort(values, reduce, key) {
  return (reduce.length !== 2 ? sort(rollup(values, reduce, key), ([ak, av], [bk, bv]) => ascending(av, bv) || ascending(ak, bk)) : sort(group(values, key), ([ak, av], [bk, bv]) => reduce(av, bv) || ascending(ak, bk))).map(([key2]) => key2);
}

// node_modules/d3-color/src/index.js
init_cjs_shims();

// node_modules/d3-color/src/color.js
init_cjs_shims();

// node_modules/d3-color/src/define.js
init_cjs_shims();
function define_default(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
}
function extend(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition) prototype[key] = definition[key];
  return prototype;
}

// node_modules/d3-color/src/color.js
function Color() {
}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*";
var reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*";
var reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*";
var reHex = /^#([0-9a-f]{3,8})$/;
var reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`);
var reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`);
var reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`);
var reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`);
var reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`);
var reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
define_default(Color, color, {
  copy(channels) {
    return Object.assign(new this.constructor(), this, channels);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: color_formatHex,
  // Deprecated! Use color.formatHex.
  formatHex: color_formatHex,
  formatHex8: color_formatHex8,
  formatHsl: color_formatHsl,
  formatRgb: color_formatRgb,
  toString: color_formatRgb
});
function color_formatHex() {
  return this.rgb().formatHex();
}
function color_formatHex8() {
  return this.rgb().formatHex8();
}
function color_formatHsl() {
  return hslConvert(this).formatHsl();
}
function color_formatRgb() {
  return this.rgb().formatRgb();
}
function color(format) {
  var m, l;
  format = (format + "").trim().toLowerCase();
  return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) : l === 3 ? new Rgb(m >> 8 & 15 | m >> 4 & 240, m >> 4 & 15 | m & 240, (m & 15) << 4 | m & 15, 1) : l === 8 ? rgba(m >> 24 & 255, m >> 16 & 255, m >> 8 & 255, (m & 255) / 255) : l === 4 ? rgba(m >> 12 & 15 | m >> 8 & 240, m >> 8 & 15 | m >> 4 & 240, m >> 4 & 15 | m & 240, ((m & 15) << 4 | m & 15) / 255) : null) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) : named.hasOwnProperty(format) ? rgbn(named[format]) : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
  return new Rgb(n >> 16 & 255, n >> 8 & 255, n & 255, 1);
}
function rgba(r, g, b, a) {
  if (a <= 0) r = g = b = NaN;
  return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Rgb();
  o = o.rgb();
  return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
  this.r = +r;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}
define_default(Rgb, rgb, extend(Color, {
  brighter(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  darker(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && (-0.5 <= this.g && this.g < 255.5) && (-0.5 <= this.b && this.b < 255.5) && (0 <= this.opacity && this.opacity <= 1);
  },
  hex: rgb_formatHex,
  // Deprecated! Use color.formatHex.
  formatHex: rgb_formatHex,
  formatHex8: rgb_formatHex8,
  formatRgb: rgb_formatRgb,
  toString: rgb_formatRgb
}));
function rgb_formatHex() {
  return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
  return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
  const a = clampa(this.opacity);
  return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
  return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
  return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
  value = clampi(value);
  return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
  if (a <= 0) h = s = l = NaN;
  else if (l <= 0 || l >= 1) h = s = NaN;
  else if (s <= 0) h = NaN;
  return new Hsl(h, s, l, a);
}
function hslConvert(o) {
  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Hsl();
  if (o instanceof Hsl) return o;
  o = o.rgb();
  var r = o.r / 255, g = o.g / 255, b = o.b / 255, min2 = Math.min(r, g, b), max2 = Math.max(r, g, b), h = NaN, s = max2 - min2, l = (max2 + min2) / 2;
  if (s) {
    if (r === max2) h = (g - b) / s + (g < b) * 6;
    else if (g === max2) h = (b - r) / s + 2;
    else h = (r - g) / s + 4;
    s /= l < 0.5 ? max2 + min2 : 2 - max2 - min2;
    h *= 60;
  } else {
    s = l > 0 && l < 1 ? 0 : h;
  }
  return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}
define_default(Hsl, hsl, extend(Color, {
  brighter(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  darker(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  rgb() {
    var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
    return new Rgb(
      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
      hsl2rgb(h, m1, m2),
      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
      this.opacity
    );
  },
  clamp() {
    return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && (0 <= this.l && this.l <= 1) && (0 <= this.opacity && this.opacity <= 1);
  },
  formatHsl() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
  }
}));
function clamph(value) {
  value = (value || 0) % 360;
  return value < 0 ? value + 360 : value;
}
function clampt(value) {
  return Math.max(0, Math.min(1, value || 0));
}
function hsl2rgb(h, m1, m2) {
  return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

// src/fetch-map/layer-map.ts
var import_d3_scale = require("d3-scale");
var import_d3_format = require("d3-format");

// src/fetch-map/utils.ts
init_cjs_shims();
function createBinaryProxy(data, index) {
  const { properties, numericProps } = data;
  return new Proxy(properties[index] || {}, {
    get(target, property) {
      if (property in numericProps) {
        return numericProps[property].value[index];
      }
      return target[property];
    },
    has(target, property) {
      return property in numericProps || property in target;
    },
    ownKeys(target) {
      return [...Object.keys(numericProps), ...Reflect.ownKeys(target)];
    },
    getOwnPropertyDescriptor() {
      return { enumerable: true, configurable: true };
    }
  });
}
function scaleIdentity() {
  let unknown;
  function scale2(x) {
    return x === null ? unknown : x;
  }
  scale2.invert = scale2;
  scale2.domain = scale2.range = (d) => d;
  scale2.unknown = (u4) => {
    if (u4) {
      unknown = u4;
    }
    return unknown;
  };
  scale2.copy = () => {
    const scaleCopy = scaleIdentity();
    scaleCopy.unknown(unknown);
    return scaleCopy;
  };
  return scale2;
}
function isRemoteCalculationSupported(dataset) {
  if (dataset?.type === "tileset" || dataset.providerId === "databricks") {
    return false;
  }
  return true;
}
var DATE_FORMATTER = new Intl.DateTimeFormat("en-US", {
  year: "2-digit",
  month: "numeric",
  day: "numeric",
  hour: "numeric",
  minute: "numeric",
  second: "numeric",
  timeZone: "UTC"
});
function formatDate(value) {
  return DATE_FORMATTER.format(new Date(value));
}
function formatTimestamp(value) {
  return String(Math.floor(new Date(value).getTime() / 1e3));
}
function roundedPow10(exp) {
  const raw = Math.pow(10, exp);
  if (exp < 0) {
    const shift = Math.pow(10, -exp);
    return Math.round(raw * shift) / shift;
  }
  return raw;
}
function getLog10ScaleSteps({
  min: min2,
  max: max2,
  steps
}) {
  if (min2 === 0) {
    if (max2 === Infinity) {
      return [...Array(steps - 1)].map((_v, i) => roundedPow10(i + 1));
    }
    const maxLog = Math.log10(max2);
    const endExponent = Math.ceil(maxLog);
    const startExponent = endExponent - steps + 1;
    return [...Array(steps - 1)].map(
      (_v, i) => roundedPow10(startExponent + i)
    );
  } else {
    const minLog = Math.log10(min2);
    const startExponent = Math.ceil(minLog) === minLog ? minLog + 1 : Math.ceil(minLog);
    return [...Array(steps - 1)].map(
      (_v, i) => roundedPow10(startExponent + i)
    );
  }
}

// src/fetch-map/layer-map.ts
var SCALE_FUNCS = {
  linear: import_d3_scale.scaleLinear,
  ordinal: import_d3_scale.scaleOrdinal,
  log: import_d3_scale.scaleLog,
  point: import_d3_scale.scalePoint,
  quantile: import_d3_scale.scaleQuantile,
  quantize: import_d3_scale.scaleQuantize,
  sqrt: import_d3_scale.scaleSqrt,
  custom: import_d3_scale.scaleThreshold,
  identity: scaleIdentity
};
function identity2(v2) {
  return v2;
}
var hexToRGB = (c) => {
  const { r, g, b } = rgb(c);
  return [r, g, b];
};
var rgbToHex = (c) => {
  const [r, g, b] = c;
  const rStr = r.toString(16).padStart(2, "0");
  const gStr = g.toString(16).padStart(2, "0");
  const bStr = b.toString(16).padStart(2, "0");
  return `#${rStr}${gStr}${bStr}`.toUpperCase();
};
var UNKNOWN_COLOR = "#868d91";
var UNKNOWN_COLOR_RGB = hexToRGB(UNKNOWN_COLOR);
var OPACITY_MAP = {
  getFillColor: "opacity",
  getLineColor: "strokeOpacity",
  getTextColor: "opacity"
};
var hexToRGBA = (c) => {
  const { r, g, b, opacity } = rgb(c);
  return [r, g, b, 255 * opacity];
};
var sharedPropMap = {
  // Apply the value of Kepler `color` prop to the deck `getFillColor` prop
  color: "getFillColor",
  isVisible: "visible",
  label: "cartoLabel",
  textLabel: {
    alignment: "getTextAlignmentBaseline",
    anchor: "getTextAnchor",
    // Apply the value of Kepler `textLabel.color` prop to the deck `getTextColor` prop
    color: "getTextColor",
    size: "getTextSize"
  },
  visConfig: {
    enable3d: "extruded",
    elevationScale: "elevationScale",
    filled: "filled",
    strokeColor: "getLineColor",
    stroked: "stroked",
    thickness: "getLineWidth",
    radius: "getPointRadius",
    wireframe: "wireframe"
  }
};
var rasterPropsMap = {
  isVisible: "visible",
  visConfig: {
    opacity: "opacity"
  }
};
var customMarkersPropsMap = {
  color: "getIconColor",
  visConfig: {
    radius: "getIconSize"
  }
};
var heatmapTilePropsMap = {
  visConfig: {
    colorRange: (x) => ({ colorRange: x.colors.map(hexToRGBA) }),
    radius: (radius) => ({ radiusPixels: 20 + radius }),
    opacity: "opacity"
  }
};
var defaultProps = {
  lineMiterLimit: 2,
  lineWidthUnits: "pixels",
  pointRadiusUnits: "pixels",
  rounded: true,
  wrapLongitude: false
};
function mergePropMaps(a = {}, b = {}) {
  return { ...a, ...b, visConfig: { ...a.visConfig, ...b.visConfig } };
}
var deprecatedLayerTypes = [
  "geojson",
  "grid",
  "heatmap",
  "hexagon",
  "hexagonId",
  "point"
];
var TEXT_LABEL_INDEX = 0;
var TEXT_OUTLINE_OPACITY = 64;
var TEXT_NUMBER_FORMATTER = new Intl.NumberFormat("en-US", {
  maximumFractionDigits: 2,
  notation: "compact"
});
function getLayerProps(type, config2, dataset) {
  if (deprecatedLayerTypes.includes(type)) {
    throw new Error(
      `Outdated layer type: ${type}. Please open map in CARTO Builder to automatically migrate.`
    );
  }
  if (type === "raster") {
    return {
      propMap: rasterPropsMap,
      defaultProps: {}
    };
  }
  let basePropMap = sharedPropMap;
  if (config2.visConfig?.customMarkers) {
    basePropMap = mergePropMaps(basePropMap, customMarkersPropsMap);
  }
  if (type === "heatmapTile") {
    basePropMap = mergePropMaps(basePropMap, heatmapTilePropsMap);
  }
  const { aggregationExp, aggregationResLevel } = dataset;
  return {
    propMap: basePropMap,
    defaultProps: {
      ...defaultProps,
      ...aggregationExp && { aggregationExp },
      ...aggregationResLevel && { aggregationResLevel },
      uniqueIdProperty: "geoid"
    }
  };
}
function domainFromAttribute(attribute, scaleType, scaleLength) {
  if (scaleType === "ordinal" || scaleType === "point") {
    if (!attribute.categories) {
      return [0, 1];
    }
    return attribute.categories.map((c) => c.category).filter((c) => c !== void 0 && c !== null);
  }
  if (scaleType === "quantile" && attribute.quantiles) {
    const quantiles = "global" in attribute.quantiles ? attribute.quantiles.global : attribute.quantiles;
    if (scaleLength === 2 && !quantiles[2] && quantiles[4]?.length === 5) {
      return [quantiles[4][0], quantiles[4][2], quantiles[4][4]];
    }
    if (quantiles[scaleLength]) {
      return quantiles[scaleLength];
    }
  }
  let { min: min2 } = attribute;
  if (scaleType === "log" && min2 === 0) {
    min2 = 1e-5;
  }
  return [min2 ?? 0, attribute.max ?? 1];
}
function domainFromValues(values, scaleType) {
  if (scaleType === "ordinal" || scaleType === "point") {
    return groupSort(
      values,
      (g) => -g.length,
      (d) => d
    );
  } else if (scaleType === "quantile") {
    return values.sort((a, b) => a - b);
  } else if (scaleType === "log") {
    const [d0, d1] = extent(values);
    return [d0 === 0 ? 1e-5 : d0, d1];
  }
  return extent(values);
}
function calculateDomain(data, name, scaleType, scaleLength) {
  if (data.tilestats) {
    const { attributes } = data.tilestats.layers[0];
    const attribute = attributes.find((a) => a.attribute === name);
    if (attribute) {
      return domainFromAttribute(attribute, scaleType, scaleLength);
    }
  }
  return [0, 1];
}
function normalizeAccessor(accessor, data) {
  if (data.features || data.tilestats || data.raster_metadata) {
    return (object, info) => {
      if (object) {
        return accessor(object.properties || object.__source.object.properties);
      }
      const { data: data2, index } = info;
      const proxy = createBinaryProxy(data2, index);
      return accessor(proxy);
    };
  }
  return accessor;
}
function opacityToAlpha(opacity) {
  return opacity !== void 0 ? Math.round(255 * Math.pow(opacity, 1 / 2.2)) : 255;
}
function getAccessorKeys(name, aggregation) {
  let keys = [name];
  if (aggregation) {
    keys = keys.concat(
      [aggregation, aggregation.toUpperCase()].map((a) => `${name}_${a}`)
    );
  }
  return keys;
}
function findAccessorKey(keys, properties) {
  for (const key of keys) {
    if (key in properties) {
      return [key];
    }
  }
  return keys;
}
function getColorAccessor({ name, colorColumn }, scaleType, { aggregation, range }, opacity, data) {
  const { scale: scale2, domain } = calculateLayerScale(
    colorColumn || name,
    colorColumn ? "identity" : scaleType,
    range,
    data
  );
  const alpha = opacityToAlpha(opacity);
  let accessorKeys = getAccessorKeys(colorColumn || name, aggregation);
  const accessor = (properties) => {
    if (!(accessorKeys[0] in properties)) {
      accessorKeys = findAccessorKey(accessorKeys, properties);
    }
    const propertyValue = properties[accessorKeys[0]];
    const scaled = scale2(propertyValue);
    const rgb2 = typeof scaled === "string" ? hexToRGB(scaled) : scaled;
    return [...rgb2, propertyValue === null ? 0 : alpha];
  };
  return {
    accessor: normalizeAccessor(accessor, data),
    scaleDomain: scale2.domain(),
    domain,
    range: (scale2.range() || []).map(rgbToHex)
  };
}
function calculateLayerScale(name, scaleType, range, data) {
  let scaleDomain;
  let scaleColors = [];
  const { colors } = range;
  const domain = calculateDomain(data, name, scaleType, colors.length);
  if (scaleType !== "identity") {
    if (range.colorMap) {
      const { colorMap } = range;
      scaleDomain = [];
      colorMap.forEach(([value, color2]) => {
        scaleDomain.push(value);
        scaleColors.push(color2);
      });
    } else {
      if (scaleType === "custom" && range.uiCustomScaleType === "logarithmic") {
        const [min2, max2] = domain;
        scaleDomain = getLog10ScaleSteps({
          min: min2,
          max: max2,
          steps: colors.length
        });
        scaleColors = colors;
      } else {
        scaleColors = colors;
      }
    }
  }
  return {
    scale: createColorScale(
      scaleType,
      scaleDomain || domain,
      scaleColors.map(hexToRGB),
      UNKNOWN_COLOR_RGB
    ),
    domain
  };
}
function createColorScale(scaleType, domain, range, unknown) {
  const scale2 = SCALE_FUNCS[scaleType]();
  scale2.domain(domain);
  scale2.range(range);
  scale2.unknown(unknown);
  return scale2;
}
var FALLBACK_ICON = "data:image/svg+xml;charset=utf-8;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTAwIDEwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCiAgPGNpcmNsZSBjeD0iNTAiIGN5PSI1MCIgcj0iNTAiLz4NCjwvc3ZnPg==";
function getIconUrlAccessor(field, range, {
  fallbackUrl,
  maxIconSize,
  useMaskedIcons
}, data) {
  const urlToUnpackedIcon = (url) => ({
    id: `${url}@@${maxIconSize}`,
    url,
    width: maxIconSize,
    height: maxIconSize,
    mask: useMaskedIcons
  });
  let unknownValue = fallbackUrl || FALLBACK_ICON;
  if (range?.othersMarker) {
    unknownValue = range.othersMarker;
  }
  const unknownIcon = urlToUnpackedIcon(unknownValue);
  if (!range || !field) {
    return () => unknownIcon;
  }
  const mapping = {};
  for (const { value, markerUrl } of range.markerMap) {
    if (markerUrl) {
      mapping[value] = urlToUnpackedIcon(markerUrl);
    }
  }
  const accessor = (properties) => {
    const propertyValue = properties[field.name];
    return mapping[propertyValue] || unknownIcon;
  };
  return normalizeAccessor(accessor, data);
}
function getMaxMarkerSize(visConfig, visualChannels) {
  const { radiusRange, radius } = visConfig;
  const { radiusField, sizeField } = visualChannels;
  const field = radiusField || sizeField;
  return Math.ceil(radiusRange && field ? radiusRange[1] : radius);
}
function negateAccessor(accessor) {
  if (typeof accessor === "function") {
    return (d, i) => -accessor(d, i);
  }
  return -accessor;
}
function getSizeAccessor({ name }, scaleType, aggregation, range, data) {
  const scale2 = scaleType ? SCALE_FUNCS[scaleType]() : identity2;
  let domain = [];
  if (scaleType && range) {
    if (aggregation !== AggregationTypes.Count) {
      domain = calculateDomain(data, name, scaleType);
      scale2.domain(domain);
    } else {
      domain = scale2.domain();
    }
    scale2.range(range);
  }
  let accessorKeys = getAccessorKeys(name, aggregation);
  const accessor = (properties) => {
    if (!(accessorKeys[0] in properties)) {
      accessorKeys = findAccessorKey(accessorKeys, properties);
    }
    const propertyValue = properties[accessorKeys[0]];
    return scale2(propertyValue);
  };
  return {
    accessor: normalizeAccessor(accessor, data),
    domain,
    scaleDomain: domain,
    range
  };
}
var FORMATS = {
  date: formatDate,
  integer: (0, import_d3_format.format)("i"),
  float: (0, import_d3_format.format)(".5f"),
  timestamp: formatTimestamp,
  default: String
};
function getTextAccessor({ name, type }, data) {
  const format = FORMATS[type] || FORMATS.default;
  const accessor = (properties) => {
    return format(properties[name]);
  };
  return normalizeAccessor(accessor, data);
}
function calculateClusterRadius(properties, stats, radiusRange, column) {
  const { min: min2, max: max2 } = stats[column];
  const value = properties[column];
  if (min2 === max2) return radiusRange[1];
  const normalizedValue = (value - min2) / (max2 - min2);
  return radiusRange[0] + normalizedValue * (radiusRange[1] - radiusRange[0]);
}
function getDefaultAggregationExpColumnAliasForLayerType(layerType, provider, schema) {
  if (schema && layerType === "clusterTile") {
    return getColumnAliasForAggregationExp(
      getDefaultColumnFromSchemaForAggregationExp(schema),
      "count",
      provider
    );
  } else {
    return DEFAULT_AGGREGATION_EXP_ALIAS;
  }
}
function getColumnAliasForAggregationExp(name, aggregation, provider) {
  const columnAlias = `${name}_${aggregation}`;
  return provider === "snowflake" ? columnAlias.toUpperCase() : columnAlias;
}
function getDefaultColumnFromSchemaForAggregationExp(schema) {
  return schema ? schema[0].name : "";
}
function calculateClusterTextFontSize(radius) {
  if (radius >= 80) return 24;
  if (radius >= 72) return 24;
  if (radius >= 56) return 20;
  if (radius >= 40) return 16;
  if (radius >= 24) return 13;
  if (radius >= 8) return 11;
  return 11;
}

// src/fetch-map/raster-layer.ts
var UNKNOWN_COLOR2 = [134, 141, 145];
var RASTER_COLOR_BANDS = ["red", "green", "blue"];
function getHasDataPredicate(noData) {
  if (noData === "nan") {
    return (v2) => !isNaN(v2);
  }
  if (typeof noData === "string") {
    noData = parseFloat(noData);
  }
  if (typeof noData === "number") {
    return (v2) => v2 !== noData && !isNaN(v2);
  }
  return () => true;
}
function createRasterColumnLayerDataTransform(transform) {
  return (data) => {
    if (!data || !("data" in data) || !data?.data?.cells?.numericProps) {
      return data;
    }
    return transform(data);
  };
}
function createEvaluationContext(numericProps, noData) {
  const hasData = getHasDataPredicate(noData);
  const bands = Object.entries(numericProps).map(([bandName, { value }]) => ({
    bandName,
    values: value,
    copied: false
  }));
  const length2 = bands[0].values.length;
  for (let i = 0; i < length2; i++) {
    let hasSomeData = false;
    for (let j = 0; j < bands.length; j++) {
      hasSomeData = hasSomeData || hasData(bands[j].values[i]);
    }
    if (!hasSomeData) {
      for (let j = 0; j < bands.length; j++) {
        if (!bands[j].copied) {
          bands[j].copied = true;
          bands[j].values = Array.from(bands[j].values);
        }
        bands[j].values[i] = NaN;
      }
    }
  }
  const context = bands.reduce(
    (agg, { bandName, values }) => {
      agg[bandName] = values;
      return agg;
    },
    {}
  );
  return context;
}
function createExprDataTransform({
  colorBand,
  rasterMetadata,
  usedSymbols
}) {
  if (!colorBand || !colorBand.type || colorBand.type === "none") {
    return void 0;
  }
  const expr = colorBand?.type === "expression" ? colorBand.value : void 0;
  const vecExprEvaluator = expr ? createVecExprEvaluator(expr) : void 0;
  const dataTransform = createRasterColumnLayerDataTransform(
    (dataWrapped) => {
      const data = dataWrapped.data;
      if (expr) {
        const cachedResult = dataWrapped.customExpressionResults?.[expr];
        if (cachedResult) {
          return dataWrapped;
        }
      }
      let context = dataWrapped.expressionEvalContext;
      if (!context) {
        const usedNumericProps = usedSymbols.reduce(
          (acc, symbol) => {
            acc[symbol] = data.cells.numericProps[symbol];
            return acc;
          },
          {}
        );
        context = createEvaluationContext(
          usedNumericProps,
          rasterMetadata.nodata
        );
        dataWrapped = {
          ...dataWrapped,
          expressionEvalContext: context
        };
      }
      if (!vecExprEvaluator || !expr) return dataWrapped;
      const evalResult = vecExprEvaluator(context);
      return {
        ...dataWrapped,
        customExpressionResults: {
          ...dataWrapped.customExpressionResults,
          [expr]: evalResult
        }
      };
    }
  );
  return dataTransform;
}
function combineDataTransforms(dataTransforms) {
  const actualTransforms = dataTransforms.filter((v2) => v2);
  if (actualTransforms.length === 0) return void 0;
  if (actualTransforms.length === 1) return actualTransforms[0];
  return (data) => actualTransforms.reduce(
    (aggData, transformFun) => transformFun(aggData),
    data
  );
}
function createRgbToColorBufferDataTransform({
  bandDefs,
  attribute
}) {
  return createRasterColumnLayerDataTransform(
    (dataWrapped) => {
      const length2 = dataWrapped.length;
      const getBandBufferOrValue = (colorBand) => {
        if (colorBand?.type === "expression") {
          return dataWrapped.customExpressionResults?.[colorBand.value];
        }
        if (colorBand?.type === "band") {
          return dataWrapped.expressionEvalContext?.[colorBand.value];
        }
        return 0;
      };
      const red = getBandBufferOrValue(bandDefs.red);
      const green = getBandBufferOrValue(bandDefs.green);
      const blue = getBandBufferOrValue(bandDefs.blue);
      const colorBuffer = new Uint8Array(length2 * 4);
      for (let inputIndex = 0, outputIndex = 0; inputIndex < length2; inputIndex++, outputIndex += 4) {
        const redRaw = typeof red === "number" ? red : red ? red[inputIndex] : NaN;
        const greenRaw = typeof green === "number" ? green : green ? green[inputIndex] : NaN;
        const blueRaw = typeof blue === "number" ? blue : blue ? blue[inputIndex] : NaN;
        if (isNaN(redRaw) && isNaN(greenRaw) && isNaN(blueRaw)) {
          bufferSetRgba(colorBuffer, outputIndex, 0, 0, 0, 0);
        } else {
          bufferSetRgba(
            colorBuffer,
            outputIndex,
            redRaw,
            greenRaw,
            blueRaw,
            255
          );
        }
      }
      dataWrapped.customExpressionResults = void 0;
      dataWrapped.expressionEvalContext = void 0;
      return {
        ...dataWrapped,
        attributes: {
          [attribute]: colorBuffer
        }
      };
    }
  );
}
function getUsedSymbols(colorBands) {
  return Array.from(
    colorBands.reduce((symbols, band) => {
      if (band.type === "expression") {
        const expressionSymbols = createVecExprEvaluator(band.value)?.symbols || [];
        expressionSymbols.forEach((symbol) => symbols.add(symbol));
      }
      if (band.type === "band") {
        symbols.add(band.value);
      }
      return symbols;
    }, /* @__PURE__ */ new Set())
  );
}
function getRasterTileLayerStylePropsRgb({
  layerConfig,
  rasterMetadata,
  visualChannels
}) {
  const { visConfig } = layerConfig;
  const { colorBands } = visConfig;
  const bandDefs = {
    red: colorBands?.find((band) => band.band === "red"),
    green: colorBands?.find((band) => band.band === "green"),
    blue: colorBands?.find((band) => band.band === "blue")
  };
  const rgbToInstanceFillColorsDataTransform = createRgbToColorBufferDataTransform({
    bandDefs,
    attribute: "instanceFillColors"
  });
  const usedSymbols = colorBands ? getUsedSymbols(colorBands) : [];
  const bandTransforms = RASTER_COLOR_BANDS.map(
    (band) => createExprDataTransform({
      colorBand: bandDefs[band],
      rasterMetadata,
      usedSymbols
    })
  );
  const combinedDataTransform = combineDataTransforms([
    ...bandTransforms,
    rgbToInstanceFillColorsDataTransform
  ]);
  return {
    dataTransform: combinedDataTransform,
    updateTriggers: getRasterTileLayerUpdateTriggers({
      layerConfig,
      visualChannels
    })
  };
}
function createBandColorScaleDataTransform({
  bandName,
  scaleFun,
  nodata,
  attribute
}) {
  const hasData = getHasDataPredicate(nodata);
  return createRasterColumnLayerDataTransform(
    (dataWrapped) => {
      const length2 = dataWrapped.length;
      const bandBuffer = dataWrapped.data.cells.numericProps[bandName].value;
      const colorBuffer = new Uint8Array(length2 * 4);
      for (let i = 0; i < length2; i++) {
        const rawValue = bandBuffer[i];
        if (!hasData(rawValue)) {
          bufferSetRgba(colorBuffer, i * 4, 0, 0, 0, 0);
        } else {
          const colorRgb = scaleFun(rawValue);
          bufferSetRgba(
            colorBuffer,
            i * 4,
            colorRgb[0],
            colorRgb[1],
            colorRgb[2],
            255
          );
        }
      }
      return {
        ...dataWrapped,
        attributes: {
          [attribute]: colorBuffer
        }
      };
    }
  );
}
function domainFromRasterMetadataBand(band, scaleType, colorRange) {
  if (scaleType === "ordinal") {
    return colorRange.colorMap?.map(([value]) => value) || [];
  }
  if (scaleType === "custom") {
    if (colorRange.uiCustomScaleType === "logarithmic") {
      return getLog10ScaleSteps({
        min: band.stats.min,
        max: band.stats.max,
        steps: colorRange.colors.length
      });
    } else {
      return colorRange.colorMap?.map(([value]) => value) || [];
    }
  }
  const scaleLength = colorRange.colors.length;
  if (scaleType === "quantile") {
    const quantiles = band.stats.quantiles?.[scaleLength];
    if (!quantiles) {
      return [0, 1];
    }
    return [band.stats.min, ...quantiles, band.stats.max];
  }
  return [band.stats.min, band.stats.max];
}
function getRasterTileLayerStylePropsScaledBand({
  layerConfig,
  rasterMetadata,
  visualChannels
}) {
  const { visConfig } = layerConfig;
  const { colorField } = visualChannels;
  const { rasterStyleType } = visConfig;
  const colorRange = rasterStyleType === "ColorRange" ? visConfig.colorRange : visConfig.uniqueValuesColorRange;
  const scaleType = rasterStyleType === "ColorRange" ? visualChannels.colorScale : "ordinal";
  const bandInfo = rasterMetadata.bands.find(
    (band) => band.name === colorField?.name
  );
  if (!colorField?.name || !scaleType || !colorRange || !bandInfo) {
    return {};
  }
  const domain = domainFromRasterMetadataBand(bandInfo, scaleType, colorRange);
  const scaleFun = createColorScale(
    scaleType,
    domain,
    colorRange.colors.map(hexToRGB2),
    UNKNOWN_COLOR2
  );
  const bandColorScaleDataTransform = createBandColorScaleDataTransform({
    bandName: bandInfo.name,
    scaleFun,
    nodata: bandInfo?.nodata ?? rasterMetadata.nodata,
    attribute: "instanceFillColors"
  });
  return {
    dataTransform: bandColorScaleDataTransform,
    updateTriggers: getRasterTileLayerUpdateTriggers({
      layerConfig,
      visualChannels
    })
  };
}
function getRasterTileLayerStyleProps({
  layerConfig,
  visualChannels,
  rasterMetadata
}) {
  const { visConfig } = layerConfig;
  const { rasterStyleType } = visConfig;
  if (rasterStyleType === "Rgb") {
    return getRasterTileLayerStylePropsRgb({
      layerConfig,
      rasterMetadata,
      visualChannels
    });
  } else {
    return getRasterTileLayerStylePropsScaledBand({
      layerConfig,
      rasterMetadata,
      visualChannels
    });
  }
}
function getRasterTileLayerUpdateTriggers({
  layerConfig,
  visualChannels
}) {
  const { visConfig } = layerConfig;
  const { rasterStyleType } = visConfig;
  const getFillColorUpdateTriggers = {
    rasterStyleType
  };
  if (rasterStyleType === "ColorRange") {
    getFillColorUpdateTriggers.colorRange = visConfig.colorRange?.colors;
    getFillColorUpdateTriggers.colorMap = visConfig.colorRange?.colorMap;
    getFillColorUpdateTriggers.colorScale = visualChannels.colorScale;
    getFillColorUpdateTriggers.colorFieldId = visualChannels.colorField?.name;
  } else if (rasterStyleType === "UniqueValues") {
    getFillColorUpdateTriggers.colorMap = visConfig.uniqueValuesColorRange?.colorMap;
    getFillColorUpdateTriggers.colorFieldId = visualChannels.colorField?.name;
  } else if (rasterStyleType === "Rgb") {
    getFillColorUpdateTriggers.colorBands = visConfig.colorBands;
  }
  return {
    getFillColor: getFillColorUpdateTriggers
  };
}
function bufferSetRgba(target, index, r, g, b, a) {
  target[index + 0] = r;
  target[index + 1] = g;
  target[index + 2] = b;
  target[index + 3] = a;
}
function hexToRGB2(hexColor) {
  const r = parseInt(hexColor.slice(1, 3), 16);
  const g = parseInt(hexColor.slice(3, 5), 16);
  const b = parseInt(hexColor.slice(5, 7), 16);
  return [r, g, b];
}

// src/fetch-map/fetch-map.ts
init_cjs_shims();

// src/fetch-map/parse-map.ts
init_cjs_shims();
function getLayerDescriptor({
  mapConfig,
  layer,
  dataset
}) {
  const { filters, visState } = mapConfig;
  const { layerBlending, interactionConfig } = visState;
  const { id, type, config: config2, visualChannels } = layer;
  const { data, id: datasetId } = dataset;
  const { propMap, defaultProps: defaultProps2 } = getLayerProps(type, config2, dataset);
  const styleProps = createStyleProps(config2, propMap);
  const { channelProps, scales } = createChannelProps(
    id,
    type,
    config2,
    visualChannels,
    data,
    dataset
  );
  const layerDescriptor = {
    type,
    filters: isEmptyObject(filters) || isRemoteCalculationSupported(dataset) ? void 0 : filters[datasetId],
    props: {
      id,
      data,
      ...defaultProps2,
      ...createInteractionProps(interactionConfig),
      ...styleProps,
      ...channelProps,
      ...createParametersProp(layerBlending, styleProps.parameters || {}),
      // Must come after style
      ...createLoadOptions(data.accessToken)
    },
    scales
  };
  return layerDescriptor;
}
function parseMap(json) {
  const { keplerMapConfig, datasets, token } = json;
  assert2(keplerMapConfig.version === "v1", "Only support Kepler v1");
  const mapConfig = keplerMapConfig.config;
  const { mapState, mapStyle, popupSettings, legendSettings, visState } = mapConfig;
  const { layers } = visState;
  const layersReverse = [...layers].reverse();
  return {
    id: json.id,
    title: json.title,
    description: json.description,
    createdAt: json.createdAt,
    updatedAt: json.updatedAt,
    initialViewState: mapState,
    /** @deprecated Use `basemap`. */
    mapStyle,
    popupSettings,
    legendSettings,
    token,
    layers: layersReverse.map((layer) => {
      try {
        const { dataId } = layer.config;
        const dataset = datasets.find(
          (d) => d.id === dataId
        );
        assert2(dataset, `No dataset matching dataId: ${dataId}`);
        const layerDescriptor = getLayerDescriptor({
          mapConfig,
          layer,
          dataset
        });
        return layerDescriptor;
      } catch (e) {
        console.error(e.message);
        return void 0;
      }
    })
  };
}
function createParametersProp(layerBlending, parameters) {
  if (layerBlending === "additive") {
    parameters.blendColorSrcFactor = parameters.blendAlphaSrcFactor = "src-alpha";
    parameters.blendColorDstFactor = parameters.blendAlphaDstFactor = "dst-alpha";
    parameters.blendColorOperation = parameters.blendAlphaOperation = "add";
  } else if (layerBlending === "subtractive") {
    parameters.blendColorSrcFactor = "one";
    parameters.blendColorDstFactor = "one-minus-dst-color";
    parameters.blendAlphaSrcFactor = "src-alpha";
    parameters.blendAlphaDstFactor = "dst-alpha";
    parameters.blendColorOperation = "subtract";
    parameters.blendAlphaOperation = "add";
  }
  return Object.keys(parameters).length ? { parameters } : {};
}
function createInteractionProps(interactionConfig) {
  const pickable = interactionConfig && interactionConfig.tooltip.enabled;
  return {
    autoHighlight: pickable,
    pickable
  };
}
function mapProps(source, target, mapping) {
  for (const sourceKey in mapping) {
    const sourceValue = source[sourceKey];
    const targetKey = mapping[sourceKey];
    if (sourceValue === void 0) {
      continue;
    }
    if (typeof targetKey === "string") {
      target[targetKey] = sourceValue;
    } else if (typeof targetKey === "function") {
      const [key, value] = Object.entries(targetKey(sourceValue))[0];
      target[key] = value;
    } else if (typeof targetKey === "object") {
      mapProps(sourceValue, target, targetKey);
    }
  }
}
function createStyleProps(config2, mapping) {
  const result = {};
  mapProps(config2, result, mapping);
  if (result.stroked && !result.getLineColor) {
    result.getLineColor = result.getFillColor;
  }
  for (const colorAccessor in OPACITY_MAP) {
    if (Array.isArray(result[colorAccessor])) {
      const color2 = [...result[colorAccessor]];
      const opacityKey = OPACITY_MAP[colorAccessor];
      const opacity = config2.visConfig[opacityKey];
      color2[3] = opacityToAlpha(opacity);
      result[colorAccessor] = color2;
    }
  }
  result.highlightColor = config2.visConfig.enable3d ? [255, 255, 255, 60] : [252, 242, 26, 255];
  return result;
}
function createChannelProps(id, layerType, config2, visualChannels, data, dataset) {
  if (layerType === "raster") {
    const rasterMetadata = data.raster_metadata;
    if (!rasterMetadata) {
      return {
        channelProps: {},
        scales: {}
      };
    }
    const rasterStyleType = config2.visConfig.rasterStyleType;
    if (rasterStyleType === "Rgb") {
      return {
        channelProps: getRasterTileLayerStylePropsRgb({
          layerConfig: config2,
          rasterMetadata,
          visualChannels
        }),
        scales: {}
        // TODO
      };
    } else {
      return {
        channelProps: getRasterTileLayerStylePropsScaledBand({
          layerConfig: config2,
          visualChannels,
          rasterMetadata
        }),
        scales: {
          // TODO
        }
      };
    }
  }
  const { textLabel, visConfig } = config2;
  const result = {};
  const updateTriggers = {};
  const scales = {};
  {
    const { colorField, colorScale } = visualChannels;
    const { colorRange, colorAggregation } = visConfig;
    if (colorField && colorScale && colorRange) {
      const { accessor, ...scaleProps } = getColorAccessor(
        colorField,
        colorScale,
        { aggregation: colorAggregation, range: colorRange },
        visConfig.opacity,
        data
      );
      result.getFillColor = accessor;
      scales.fillColor = updateTriggers.getFillColor = {
        field: colorField,
        type: colorScale,
        ...scaleProps
      };
    } else {
      scales.fillColor = {};
    }
  }
  if (layerType === "clusterTile") {
    const aggregationExpAlias = getDefaultAggregationExpColumnAliasForLayerType(
      layerType,
      dataset.providerId,
      data.schema
    );
    result.pointType = visConfig.isTextVisible ? "circle+text" : "circle";
    result.clusterLevel = visConfig.clusterLevel;
    result.getWeight = (d) => {
      return d.properties[aggregationExpAlias];
    };
    updateTriggers.getWeight = aggregationExpAlias;
    result.getPointRadius = (d, info) => {
      return calculateClusterRadius(
        d.properties,
        info.data.attributes.stats,
        visConfig.radiusRange,
        aggregationExpAlias
      );
    };
    updateTriggers.getPointRadius = {
      aggregationExpAlias,
      radiusRange: visConfig.radiusRange
    };
    result.textCharacterSet = "auto";
    result.textFontFamily = "Inter, sans";
    result.textFontSettings = { sdf: true };
    result.textFontWeight = 600;
    result.getText = (d) => TEXT_NUMBER_FORMATTER.format(d.properties[aggregationExpAlias]);
    updateTriggers.getText = aggregationExpAlias;
    result.getTextColor = config2.textLabel[TEXT_LABEL_INDEX].color;
    result.textOutlineColor = [
      ...config2.textLabel[TEXT_LABEL_INDEX].outlineColor,
      TEXT_OUTLINE_OPACITY
    ];
    result.textOutlineWidth = 5;
    result.textSizeUnits = "pixels";
    result.getTextSize = (d, info) => {
      const radius = calculateClusterRadius(
        d.properties,
        info.data.attributes.stats,
        visConfig.radiusRange,
        aggregationExpAlias
      );
      return calculateClusterTextFontSize(radius);
    };
    updateTriggers.getTextSize = {
      aggregationExpAlias,
      radiusRange: visConfig.radiusRange
    };
  }
  {
    const radiusRange = visConfig.radiusRange;
    const { radiusField, radiusScale } = visualChannels;
    if (radiusField && radiusRange && radiusScale) {
      const { accessor, ...scaleProps } = getSizeAccessor(
        radiusField,
        radiusScale,
        visConfig.radiusAggregation,
        radiusRange,
        data
      );
      result.getPointRadius = accessor;
      scales.pointRadius = updateTriggers.getPointRadius = {
        field: radiusField,
        type: radiusScale,
        ...scaleProps
      };
    }
  }
  {
    const strokeColorRange = visConfig.strokeColorRange;
    const { strokeColorScale, strokeColorField } = visualChannels;
    if (strokeColorField && strokeColorRange && strokeColorScale) {
      const { strokeColorAggregation: aggregation } = visConfig;
      const opacity = visConfig.strokeOpacity !== void 0 ? visConfig.strokeOpacity : 1;
      const { accessor, ...scaleProps } = getColorAccessor(
        strokeColorField,
        strokeColorScale,
        { aggregation, range: strokeColorRange },
        opacity,
        data
      );
      result.getLineColor = accessor;
      scales.lineColor = updateTriggers.getLineColor = {
        field: strokeColorField,
        type: strokeColorScale,
        ...scaleProps
      };
    }
  }
  {
    const { sizeField: strokeWidthField, sizeScale: strokeWidthScale } = visualChannels;
    const { sizeRange, sizeAggregation } = visConfig;
    if (strokeWidthField && sizeRange) {
      const { accessor, ...scaleProps } = getSizeAccessor(
        strokeWidthField,
        strokeWidthScale,
        sizeAggregation,
        sizeRange,
        data
      );
      result.getLineWidth = accessor;
      scales.lineWidth = updateTriggers.getLineWidth = {
        field: strokeWidthField,
        type: strokeWidthScale || "identity",
        ...scaleProps
      };
    }
  }
  {
    const { enable3d, heightRange } = visConfig;
    const { heightField, heightScale } = visualChannels;
    if (heightField && heightRange && enable3d) {
      const { accessor, ...scaleProps } = getSizeAccessor(
        heightField,
        heightScale,
        visConfig.heightAggregation,
        heightRange,
        data
      );
      result.getElevation = accessor;
      scales.elevation = updateTriggers.getElevation = {
        field: heightField,
        type: heightScale || "identity",
        ...scaleProps
      };
    }
  }
  {
    const { weightField } = visualChannels;
    const { weightAggregation } = visConfig;
    if (weightField && weightAggregation) {
      const { accessor, ...scaleProps } = getSizeAccessor(
        weightField,
        void 0,
        weightAggregation,
        void 0,
        data
      );
      result.getWeight = accessor;
      scales.weight = updateTriggers.getWeight = {
        field: weightField,
        type: "identity",
        ...scaleProps
      };
    }
  }
  if (visConfig.customMarkers) {
    const maxIconSize = getMaxMarkerSize(visConfig, visualChannels);
    const { getPointRadius, getFillColor } = result;
    const {
      customMarkersUrl,
      customMarkersRange,
      filled: useMaskedIcons
    } = visConfig;
    result.pointType = "icon";
    result.getIcon = getIconUrlAccessor(
      visualChannels.customMarkersField,
      customMarkersRange,
      { fallbackUrl: customMarkersUrl, maxIconSize, useMaskedIcons },
      data
    );
    updateTriggers.getIcon = {
      customMarkersUrl,
      customMarkersRange,
      maxIconSize,
      useMaskedIcons
    };
    result._subLayerProps = {
      "points-icon": {
        loadOptions: {
          image: {
            type: "imagebitmap"
          },
          imagebitmap: {
            resizeWidth: maxIconSize,
            resizeHeight: maxIconSize,
            resizeQuality: "high"
          }
        }
      }
    };
    if (getFillColor && useMaskedIcons) {
      result.getIconColor = getFillColor;
      updateTriggers.getIconColor = updateTriggers.getFillColor;
    }
    if (getPointRadius) {
      result.getIconSize = getPointRadius;
      updateTriggers.getIconSize = updateTriggers.getPointRadius;
    }
    if (visualChannels.rotationField) {
      const { accessor } = getSizeAccessor(
        visualChannels.rotationField,
        void 0,
        null,
        void 0,
        data
      );
      result.getIconAngle = negateAccessor(accessor);
      updateTriggers.getIconAngle = updateTriggers.getRotationField;
    }
  } else if (layerType === "tileset") {
    result.pointType = "circle";
  }
  if (textLabel && textLabel.length && textLabel[0].field) {
    const [mainLabel, secondaryLabel] = textLabel;
    const collisionGroup = id;
    ({
      alignment: result.getTextAlignmentBaseline,
      anchor: result.getTextAnchor,
      color: result.getTextColor,
      outlineColor: result.textOutlineColor,
      size: result.textSizeScale
    } = mainLabel);
    const {
      color: getSecondaryColor,
      field: secondaryField,
      outlineColor: secondaryOutlineColor,
      size: secondarySizeScale
    } = secondaryLabel || {};
    result.getText = mainLabel.field && getTextAccessor(mainLabel.field, data);
    const getSecondaryText = secondaryField && getTextAccessor(secondaryField, data);
    result.pointType = `${result.pointType}+text`;
    result.textCharacterSet = "auto";
    result.textFontFamily = "Inter, sans";
    result.textFontSettings = { sdf: true };
    result.textFontWeight = 600;
    result.textOutlineWidth = 3;
    result._subLayerProps = {
      ...result._subLayerProps,
      "points-text": {
        collisionEnabled: true,
        collisionGroup,
        // getPointRadius already has radiusScale baked in, so only pass one or the other
        ...result.getPointRadius ? { getRadius: result.getPointRadius } : { radiusScale: visConfig.radius },
        ...secondaryField && {
          getSecondaryText,
          getSecondaryColor,
          secondarySizeScale,
          secondaryOutlineColor
        }
      }
    };
  }
  return {
    channelProps: {
      ...result,
      updateTriggers
    },
    scales
  };
}
function createLoadOptions(accessToken) {
  return {
    loadOptions: { fetch: { headers: { Authorization: `Bearer ${accessToken}` } } }
  };
}

// src/fetch-map/basemap.ts
init_cjs_shims();
var CUSTOM_STYLE_ID_PREFIX = "custom:";
var DEFAULT_CARTO_STYLE = "positron";
function mapLibreViewpros(config2) {
  const { longitude, latitude, ...rest } = config2.mapState;
  return {
    center: [longitude, latitude],
    ...rest
  };
}
async function fetchBasemapProps({
  config: config2,
  errorContext,
  applyLayerFilters = true
}) {
  const { mapStyle } = config2;
  const styleType = mapStyle.styleType || DEFAULT_CARTO_STYLE;
  if (styleType.startsWith(CUSTOM_STYLE_ID_PREFIX)) {
    const currentCustomStyle = config2.customBaseMaps?.customStyle;
    if (currentCustomStyle) {
      return {
        type: "maplibre",
        props: {
          style: currentCustomStyle.style || currentCustomStyle.url,
          ...mapLibreViewpros(config2)
        },
        attribution: currentCustomStyle.customAttribution
      };
    }
  }
  if (CARTO_MAP_STYLES.includes(styleType)) {
    const { visibleLayerGroups } = mapStyle;
    const styleUrl = getStyleUrl(styleType);
    let style = styleUrl;
    let rawStyle = styleUrl;
    if (applyLayerFilters && visibleLayerGroups && someLayerGroupsDisabled(visibleLayerGroups)) {
      rawStyle = await fetchStyle({ styleUrl, errorContext });
      style = applyLayerGroupFilters(rawStyle, visibleLayerGroups);
    }
    return {
      type: "maplibre",
      props: {
        style,
        ...mapLibreViewpros(config2)
      },
      visibleLayerGroups,
      rawStyle
    };
  }
  const googleBasemapDef = GOOGLE_BASEMAPS[styleType];
  if (googleBasemapDef) {
    const { mapState } = config2;
    return {
      type: "google-maps",
      props: {
        ...googleBasemapDef,
        center: { lat: mapState.latitude, lng: mapState.longitude },
        zoom: mapState.zoom + 1,
        tilt: mapState.pitch,
        heading: mapState.bearing
      }
    };
  }
  return {
    type: "maplibre",
    props: {
      style: getStyleUrl(DEFAULT_CARTO_STYLE),
      ...mapLibreViewpros(config2)
    }
  };
}

// src/fetch-map/source.ts
init_cjs_shims();
function configureSource({
  dataset,
  filters,
  options
}) {
  const {
    geoColumn,
    columns,
    type,
    source,
    queryParameters,
    aggregationExp,
    aggregationResLevel: originalAggregationResLevel
  } = dataset;
  const sourceOptions = getSourceOptions(options);
  const spatialDataColumn = getColumnNameFromGeoColumn(geoColumn) || void 0;
  const spatialIndex = geoColumn ? getSpatialIndexFromGeoColumn(geoColumn) : void 0;
  const tileResolution = getDynamicTileResolution(spatialIndex);
  const isH3 = spatialIndex === "h3" /* H3 */;
  const isQuadbin = spatialIndex === "quadbin" /* QUADBIN */;
  let aggregationResLevel = originalAggregationResLevel;
  if (typeof originalAggregationResLevel !== "number" && isH3) {
    aggregationResLevel = DEFAULT_AGGREGATION_RES_LEVEL_H3;
  } else if (typeof originalAggregationResLevel !== "number" && isQuadbin) {
    aggregationResLevel = DEFAULT_AGGREGATION_RES_LEVEL_QUADBIN;
  }
  const spatialIndexOptions = {
    aggregationExp: !aggregationExp ? DEFAULT_AGGREGATION_EXP : aggregationExp,
    aggregationResLevel: scaleAggregationResLevel(
      aggregationResLevel,
      tileResolution
    ),
    spatialDataColumn,
    ...filters && { filters }
  };
  const tilesetOptions = {
    ...sourceOptions,
    tableName: source
  };
  const tableOptions = {
    ...sourceOptions,
    tableName: source,
    tileResolution
  };
  const queryOptions = {
    ...sourceOptions,
    sqlQuery: source,
    tileResolution,
    ...queryParameters && { queryParameters }
  };
  const vectorOptions = {
    spatialDataColumn,
    ...columns && { columns },
    ...filters && { filters },
    ...aggregationExp && { aggregationExp }
  };
  if (type === "raster") {
    return rasterSource({
      ...sourceOptions,
      tableName: source,
      ...filters && { filters }
    });
  }
  if (type === "tileset") {
    return vectorTilesetSource({ ...tilesetOptions });
  }
  if (type === "table") {
    if (isH3) {
      return h3TableSource({
        ...tableOptions,
        ...spatialIndexOptions
      });
    } else if (isQuadbin) {
      return quadbinTableSource({
        ...tableOptions,
        ...spatialIndexOptions
      });
    } else {
      return vectorTableSource({
        ...tableOptions,
        ...vectorOptions
      });
    }
  }
  if (type === "query") {
    if (isH3) {
      return h3QuerySource({
        ...queryOptions,
        ...spatialIndexOptions
      });
    } else if (isQuadbin) {
      return quadbinQuerySource({
        ...queryOptions,
        ...spatialIndexOptions
      });
    } else {
      return vectorQuerySource({
        ...queryOptions,
        ...vectorOptions
      });
    }
  }
  throw new Error(`Invalid source type: ${type}`);
}
function getSourceOptions({
  accessToken,
  apiBaseUrl,
  connection,
  headers,
  maxLengthURL
}) {
  return {
    accessToken,
    connectionName: connection,
    apiBaseUrl,
    headers,
    maxLengthURL,
    ...headers?.["Cache-Control"]?.includes("no-cache") && {
      localCache: {
        cacheControl: ["no-cache"]
      }
    }
  };
}
function getDynamicTileResolution(spatialIndex) {
  if (spatialIndex !== "h3" /* H3 */) {
    return REDUCED_QUERIES_TILE_RESOLUTION;
  }
  return DEFAULT_TILE_RESOLUTION;
}
function scaleAggregationResLevel(aggregationResLevel, tileResolution) {
  if (typeof aggregationResLevel !== "number") return;
  return aggregationResLevel - Math.log2(0.5 / tileResolution);
}
function getColumnNameFromGeoColumn(geoColumn) {
  if (!geoColumn) {
    return geoColumn;
  }
  const parts = geoColumn.split(":");
  return parts.length === 1 ? parts[0] : parts.length === 2 ? parts[1] : null;
}
function getSpatialIndexFromGeoColumn(geoColumn) {
  const spatialIndexToSearch = geoColumn.split(":")[0];
  for (const index of Object.values(SpatialIndex)) {
    if (SpatialIndexColumn[index].includes(spatialIndexToSearch)) {
      return index;
    }
  }
  return null;
}

// src/fetch-map/fetch-map.ts
async function _fetchMapDataset(dataset, filters, context) {
  const { connectionName } = dataset;
  const cache = {};
  const configuredSource = configureSource({
    dataset,
    filters: isRemoteCalculationSupported(dataset) ? filters : void 0,
    options: {
      ...context,
      connection: connectionName,
      headers: context.headers,
      accessToken: context.accessToken,
      apiBaseUrl: context.apiBaseUrl,
      maxLengthURL: context.maxLengthURL
    }
  });
  dataset.data = await configuredSource;
  let cacheChanged = true;
  if (cache.value) {
    cacheChanged = dataset.cache !== cache.value;
    dataset.cache = cache.value;
  }
  return cacheChanged;
}
async function _fetchTilestats(attribute, dataset, context) {
  const { connectionName, data, id, source, type, queryParameters } = dataset;
  const { apiBaseUrl } = context;
  const errorContext = {
    requestType: "Tile stats",
    connection: connectionName,
    type,
    source
  };
  if (!("tilestats" in data)) {
    throw new CartoAPIError(
      new Error(`Invalid dataset for tilestats: ${id}`),
      errorContext
    );
  }
  const baseUrl = buildStatsUrl({ attribute, apiBaseUrl, ...dataset });
  const client2 = new URLSearchParams(data.tiles[0]).get("client");
  const headers = { Authorization: `Bearer ${context.accessToken}` };
  const parameters = {};
  if (client2) {
    parameters.client = client2;
  }
  if (type === "query") {
    parameters.q = source;
    if (queryParameters) {
      parameters.queryParameters = JSON.stringify(queryParameters);
    }
  }
  const stats = await requestWithParameters({
    baseUrl,
    headers,
    parameters,
    errorContext,
    maxLengthURL: context.maxLengthURL
  });
  const { attributes } = data.tilestats.layers[0];
  const index = attributes.findIndex((d) => d.attribute === attribute);
  attributes[index] = stats;
  return true;
}
async function fillInMapDatasets({ datasets, keplerMapConfig }, context) {
  const { filters } = keplerMapConfig.config;
  const promises = datasets.map(
    (dataset) => _fetchMapDataset(dataset, filters[dataset.id], context)
  );
  return await Promise.all(promises);
}
async function fillInTileStats({ datasets, keplerMapConfig }, context) {
  const attributes = [];
  const { layers } = keplerMapConfig.config.visState;
  for (const layer of layers) {
    for (const channel of Object.keys(layer.visualChannels)) {
      const attribute = layer.visualChannels[channel]?.name;
      if (attribute) {
        const dataset = datasets.find((d) => d.id === layer.config.dataId);
        if (dataset && dataset.type !== "tileset" && dataset.data.tilestats) {
          attributes.push({ attribute, dataset });
        }
      }
    }
  }
  const filteredAttributes = [];
  for (const a of attributes) {
    if (!filteredAttributes.find(
      ({ attribute, dataset }) => attribute === a.attribute && dataset === a.dataset
    )) {
      filteredAttributes.push(a);
    }
  }
  const promises = filteredAttributes.map(
    ({ attribute, dataset }) => _fetchTilestats(attribute, dataset, context)
  );
  return await Promise.all(promises);
}
async function fetchMap({
  accessToken,
  apiBaseUrl = DEFAULT_API_BASE_URL,
  cartoMapId,
  clientId,
  headers,
  autoRefresh,
  onNewData,
  maxLengthURL
}) {
  assert2(
    cartoMapId,
    'Must define CARTO map id: fetchMap({cartoMapId: "XXXX-XXXX-XXXX"})'
  );
  if (accessToken) {
    headers = { Authorization: `Bearer ${accessToken}`, ...headers };
  }
  if (autoRefresh || onNewData) {
    assert2(onNewData, "Must define `onNewData` when using autoRefresh");
    assert2(typeof onNewData === "function", "`onNewData` must be a function");
    assert2(
      typeof autoRefresh === "number" && autoRefresh > 0,
      "`autoRefresh` must be a positive number"
    );
  }
  const baseUrl = buildPublicMapUrl({ apiBaseUrl, cartoMapId });
  const errorContext = {
    requestType: "Public map",
    mapId: cartoMapId
  };
  const map = await requestWithParameters({
    baseUrl,
    headers,
    errorContext,
    maxLengthURL
  });
  const context = {
    accessToken: map.token || accessToken,
    apiBaseUrl,
    clientId,
    headers,
    maxLengthURL
  };
  let stopAutoRefresh;
  if (autoRefresh) {
    const intervalId = setInterval(async () => {
      const changed = await fillInMapDatasets(map, {
        ...context,
        headers: {
          ...headers,
          "If-Modified-Since": (/* @__PURE__ */ new Date()).toUTCString()
        }
      });
      if (onNewData && changed.some((v2) => v2 === true)) {
        onNewData(parseMap(map));
      }
    }, autoRefresh * 1e3);
    stopAutoRefresh = () => {
      clearInterval(intervalId);
    };
  }
  const geojsonLayers = map.keplerMapConfig.config.visState.layers.filter(
    ({ type }) => type === "geojson" || type === "point"
  );
  const geojsonDatasetIds = geojsonLayers.map(
    ({ config: config2 }) => config2.dataId
  );
  map.datasets.forEach((dataset) => {
    if (geojsonDatasetIds.includes(dataset.id)) {
      const { config: config2 } = geojsonLayers.find(
        ({ config: config3 }) => config3.dataId === dataset.id
      );
      dataset.format = "geojson";
      if (!dataset.geoColumn && config2.columns.geojson) {
        dataset.geoColumn = config2.columns.geojson;
      }
    }
  });
  const [basemap] = await Promise.all([
    fetchBasemapProps({ config: map.keplerMapConfig.config, errorContext }),
    // Mutates map.datasets so that dataset.data contains data
    fillInMapDatasets(map, context)
  ]);
  await fillInTileStats(map, context);
  const out = { ...parseMap(map), basemap, ...{ stopAutoRefresh } };
  const textLayers = out.layers.filter((layer) => {
    const pointType = layer.props?.pointType || "";
    return pointType.includes("text");
  });
  if (textLayers.length && window.FontFace && !document.fonts.check("12px Inter")) {
    const font = new FontFace(
      "Inter",
      "url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7W0Q5nw.woff2)"
    );
    await font.load().then((f) => document.fonts.add(f));
  }
  return out;
}

// src/geo.ts
init_cjs_shims();

// node_modules/@turf/union/dist/esm/index.js
init_cjs_shims();
function union2(features, options = {}) {
  const geoms = [];
  geomEach(features, (geom) => {
    geoms.push(geom.coordinates);
  });
  if (geoms.length < 2) {
    throw new Error("Must have at least 2 geometries");
  }
  const unioned = union(geoms[0], ...geoms.slice(1));
  if (unioned.length === 0) return null;
  if (unioned.length === 1) return polygon(unioned[0], options.properties);
  else return multiPolygon(unioned, options.properties);
}
var turf_union_default = union2;

// src/geo.ts
function createViewportSpatialFilter(viewport) {
  if (_isGlobalViewport(viewport)) {
    return;
  }
  return createPolygonSpatialFilter(turf_bbox_polygon_default(viewport).geometry);
}
function createPolygonSpatialFilter(spatialFilter) {
  return spatialFilter && _normalizeGeometry(spatialFilter) || void 0;
}
function _isGlobalViewport(viewport) {
  const [minx, miny, maxx, maxy] = viewport;
  return maxx - minx > 179.5 * 2 && maxy - miny > 85.05 * 2;
}
function _normalizeGeometry(geometry) {
  const WORLD = [-180, -90, 180, 90];
  const worldClip = _clean(
    turf_bbox_clip_default(geometry, WORLD).geometry
  );
  const geometryTxWest = _tx(geometry, 360);
  const geometryTxEast = _tx(geometry, -360);
  let result = worldClip;
  if (result && geometryTxWest) {
    const worldWestClip = _clean(
      turf_bbox_clip_default(geometryTxWest, WORLD).geometry
    );
    if (worldWestClip) {
      const collection = featureCollection([
        feature(result),
        feature(worldWestClip)
      ]);
      const merged = turf_union_default(collection);
      result = merged ? _clean(merged.geometry) : result;
    }
  }
  if (result && geometryTxEast) {
    const worldEastClip = _clean(
      turf_bbox_clip_default(geometryTxEast, WORLD).geometry
    );
    if (worldEastClip) {
      const collection = featureCollection([
        feature(result),
        feature(worldEastClip)
      ]);
      const merged = turf_union_default(collection);
      result = merged ? _clean(merged.geometry) : result;
    }
  }
  return result;
}
function _cleanPolygonCoords(cc2) {
  const coords = cc2.filter((c) => c.length > 0);
  return coords.length > 0 ? coords : null;
}
function _cleanMultiPolygonCoords(ccc) {
  const coords = ccc.map(_cleanPolygonCoords).filter((cc2) => cc2);
  return coords.length > 0 ? coords : null;
}
function _clean(geometry) {
  if (!geometry) {
    return null;
  }
  if (_isPolygon(geometry)) {
    const coords = _cleanPolygonCoords(geometry.coordinates);
    return coords ? polygon(coords).geometry : null;
  }
  if (_isMultiPolygon(geometry)) {
    const coords = _cleanMultiPolygonCoords(geometry.coordinates);
    return coords ? multiPolygon(coords).geometry : null;
  }
  return null;
}
function _txContourCoords(cc2, distance) {
  return cc2.map((c) => [c[0] + distance, c[1]]);
}
function _txPolygonCoords(ccc, distance) {
  return ccc.map((cc2) => _txContourCoords(cc2, distance));
}
function _txMultiPolygonCoords(cccc, distance) {
  return cccc.map((ccc) => _txPolygonCoords(ccc, distance));
}
function _tx(geometry, distance) {
  if (geometry && getType(geometry) === "Polygon") {
    const coords = _txPolygonCoords(
      geometry.coordinates,
      distance
    );
    return polygon(coords).geometry;
  } else if (geometry && getType(geometry) === "MultiPolygon") {
    const coords = _txMultiPolygonCoords(
      geometry.coordinates,
      distance
    );
    return multiPolygon(coords).geometry;
  } else {
    return null;
  }
}
function _isPolygon(geometry) {
  return getType(geometry) === "Polygon";
}
function _isMultiPolygon(geometry) {
  return getType(geometry) === "MultiPolygon";
}

// src/spatial-index.ts
init_cjs_shims();
var DEFAULT_TILE_SIZE = 512;
var BIAS = 2;
function _getHexagonResolution(viewport, tileSize) {
  const zoomOffset = Math.log2(tileSize / DEFAULT_TILE_SIZE);
  const hexagonScaleFactor = 2 / 3 * (viewport.zoom - zoomOffset);
  const latitudeScaleFactor = Math.log(
    1 / Math.cos(Math.PI * viewport.latitude / 180)
  );
  return Math.max(
    0,
    Math.floor(hexagonScaleFactor + latitudeScaleFactor - BIAS)
  );
}

// src/utils/CellSet.ts
init_cjs_shims();
var EMPTY_U32 = 2 ** 32 - 1;
var CellSet = class {
  constructor(cells) {
    /** List of cells stored by the set. Stored by reference, without copying. */
    __publicField(this, "cells");
    /** DataView representing a single cell ID. Pre-allocated to reduce memory during queries. */
    __publicField(this, "cellView", new DataView(new ArrayBuffer(8)));
    /** Hash table, mapping a hash index (computed) to an index in the 'cells' array. */
    __publicField(this, "hashTable");
    this.cells = cells;
    this.hashTable = new Uint32Array(hashBuckets(cells.length)).fill(EMPTY_U32);
    for (let cellIndex = 0; cellIndex < cells.length; cellIndex++) {
      this.hashTable[this.hashLookup(cells[cellIndex])] = cellIndex;
    }
  }
  has(cell) {
    const hashIndex = this.hashLookup(cell);
    return this.hashTable[hashIndex] !== EMPTY_U32;
  }
  hashLookup(cell) {
    this.cellView.setBigUint64(0, cell);
    const hashval = hash(this.cellView);
    const hashmod = this.hashTable.length - 1;
    let bucket = hashval & hashmod;
    for (let probe = 0; probe <= hashmod; probe++) {
      const cellIndex = this.hashTable[bucket];
      if (cellIndex === EMPTY_U32 || cell === this.cells[cellIndex]) {
        return bucket;
      }
      bucket = bucket + probe + 1 & hashmod;
    }
    throw new Error("Hash table full.");
  }
};
function hash(view, h = 0) {
  const m = 1540483477;
  const r = 24;
  for (let i = 0, il = view.byteLength / 4; i < il; i++) {
    let k = view.getUint32(i * 4);
    k = Math.imul(k, m) >>> 0;
    k = (k ^ k >> r) >>> 0;
    k = Math.imul(k, m) >>> 0;
    h = Math.imul(h, m) >>> 0;
    h = (h ^ k) >>> 0;
  }
  return h;
}
function hashBuckets(initialCount) {
  let buckets = 1;
  while (buckets < initialCount + initialCount / 4) {
    buckets *= 2;
  }
  return buckets;
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  AggregationTypes,
  ApiVersion,
  BASEMAP,
  CARTO_SOURCES,
  CartoAPIError,
  CellSet,
  DEFAULT_API_BASE_URL,
  FEATURE_GEOM_PROPERTY,
  FilterType,
  OPACITY_MAP,
  OTHERS_CATEGORY_NAME,
  Provider,
  RasterBandColorinterp,
  SOURCE_DEFAULTS,
  SchemaFieldType,
  SpatialIndex,
  SpatialIndexColumn,
  TEXT_LABEL_INDEX,
  TEXT_NUMBER_FORMATTER,
  TEXT_OUTLINE_OPACITY,
  TileFormat,
  WidgetQuerySource,
  WidgetRasterSource,
  WidgetRemoteSource,
  WidgetSource,
  WidgetTableSource,
  WidgetTilesetSource,
  _ErrorCode,
  _applyLayerGroupFilters,
  _buildFeatureFilter,
  _createVecExprEvaluator,
  _domainFromValues,
  _evaluateVecExpr,
  _getHexagonResolution,
  _getLog10ScaleSteps,
  _getRasterTileLayerStyleProps,
  _validateVecExprSyntax,
  addFilter,
  aggregate,
  aggregationFunctions,
  applyFilters,
  applySorting,
  boundaryQuerySource,
  boundaryTableSource,
  buildBinaryFeatureFilter,
  buildPublicMapUrl,
  buildStatsUrl,
  calculateClusterRadius,
  calculateClusterTextFontSize,
  calculateLayerScale,
  clearDefaultRequestCache,
  clearFilters,
  configureSource,
  createColorScale,
  createPolygonSpatialFilter,
  createViewportSpatialFilter,
  fetchBasemapProps,
  fetchMap,
  filterFunctions,
  geojsonFeatures,
  getApplicableFilters,
  getClient,
  getColorAccessor,
  getColumnNameFromGeoColumn,
  getDataFilterExtensionProps,
  getDefaultAggregationExpColumnAliasForLayerType,
  getFilter,
  getIconUrlAccessor,
  getLayerDescriptor,
  getLayerProps,
  getMaxMarkerSize,
  getSizeAccessor,
  getSorter,
  getSpatialIndexFromGeoColumn,
  getTextAccessor,
  groupValuesByColumn,
  groupValuesByDateColumn,
  h3QuerySource,
  h3TableSource,
  h3TilesetSource,
  hasFilter,
  histogram,
  makeIntervalComplete,
  negateAccessor,
  opacityToAlpha,
  parseMap,
  quadbinQuerySource,
  quadbinTableSource,
  quadbinTilesetSource,
  query,
  rasterSource,
  removeFilter,
  requestWithParameters,
  scaleAggregationResLevel,
  scatterPlot,
  setClient,
  tileFeatures,
  tileFeaturesGeometries,
  tileFeaturesSpatialIndex,
  trajectoryQuerySource,
  trajectoryTableSource,
  transformToTileCoords,
  vectorQuerySource,
  vectorTableSource,
  vectorTilesetSource
});
//# sourceMappingURL=api-client.cjs.map